"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9525],{

/***/ 20294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "cache": function() { return /* binding */ cache; },
  "css": function() { return /* binding */ css; },
  "cx": function() { return /* binding */ cx; },
  "flush": function() { return /* binding */ flush; },
  "getRegisteredStyles": function() { return /* binding */ emotion_css_esm_getRegisteredStyles; },
  "hydrate": function() { return /* binding */ hydrate; },
  "injectGlobal": function() { return /* binding */ injectGlobal; },
  "keyframes": function() { return /* binding */ keyframes; },
  "merge": function() { return /* binding */ emotion_css_esm_merge; },
  "sheet": function() { return /* binding */ sheet; }
});

;// CONCATENATED MODULE: ./node_modules/@emotion/sheet/dist/emotion-sheet.browser.esm.js
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (false) { var isImportRule; }

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (false) {}
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;

    if (false) {}
  };

  return StyleSheet;
}();



;// CONCATENATED MODULE: ./node_modules/stylis/src/Utility.js
/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs

/**
 * @param {number}
 * @return {string}
 */
var Utility_from = String.fromCharCode

/**
 * @param {object}
 * @return {object}
 */
var Utility_assign = Object.assign

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return (((((((length << 2) ^ Utility_charat(value, 0)) << 2) ^ Utility_charat(value, 1)) << 2) ^ Utility_charat(value, 2)) << 2) ^ Utility_charat(value, 3)
}

/**
 * @param {string} value
 * @return {string}
 */
function trim (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function Utility_charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function Utility_substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function Utility_strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function Utility_sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function Utility_append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function Utility_combine (array, callback) {
	return array.map(callback).join('')
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Tokenizer.js


var line = 1
var column = 1
var Tokenizer_length = 0
var position = 0
var character = 0
var characters = ''

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function copy (root, props) {
	return Utility_assign(node('', null, null, '', null, null, 0), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function Tokenizer_char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position > 0 ? Utility_charat(characters, --position) : 0

	if (column--, character === 10)
		column = 1, line--

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position < Tokenizer_length ? Utility_charat(characters, position++) : 0

	if (column++, character === 10)
		column = 1, line++

	return character
}

/**
 * @return {number}
 */
function peek () {
	return Utility_charat(characters, position)
}

/**
 * @return {number}
 */
function caret () {
	return position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return Utility_substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, Tokenizer_length = Utility_strlen(characters = value), position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {string} value
 * @return {string[]}
 */
function Tokenizer_tokenize (value) {
	return dealloc(tokenizer(alloc(value)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next()
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {string[]} children
 * @return {string[]}
 */
function tokenizer (children) {
	while (next())
		switch (token(character)) {
			case 0: append(identifier(position - 1), children)
				break
			case 2: append(delimit(character), children)
				break
			default: append(from(character), children)
		}

	return children
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character)
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type)
				break
			// \
			case 92:
				next()
				break
		}

	return position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position - 1) + '*' + Utility_from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next()

	return slice(index, position)
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Enum.js
var MS = '-ms-'
var MOZ = '-moz-'
var WEBKIT = '-webkit-'

var COMMENT = 'comm'
var Enum_RULESET = 'rule'
var DECLARATION = 'decl'

var PAGE = '@page'
var MEDIA = '@media'
var IMPORT = '@import'
var CHARSET = '@charset'
var VIEWPORT = '@viewport'
var SUPPORTS = '@supports'
var DOCUMENT = '@document'
var NAMESPACE = '@namespace'
var KEYFRAMES = '@keyframes'
var FONT_FACE = '@font-face'
var COUNTER_STYLE = '@counter-style'
var FONT_FEATURE_VALUES = '@font-feature-values'

;// CONCATENATED MODULE: ./node_modules/stylis/src/Serializer.js



/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function serialize (children, callback) {
	var output = ''
	var length = Utility_sizeof(children)

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || ''

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case IMPORT: case DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case KEYFRAMES: return element.return = element.value + '{' + serialize(element.children, callback) + '}'
		case Enum_RULESET: element.value = element.props.join(',')
	}

	return Utility_strlen(children = serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Prefixer.js



/**
 * @param {string} value
 * @param {number} length
 * @return {string}
 */
function prefix (value, length) {
	switch (hash(value, length)) {
		// color-adjust
		case 5103:
			return WEBKIT + 'print-' + value + value
		// animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
		case 5737: case 4201: case 3177: case 3433: case 1641: case 4457: case 2921:
		// text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
		case 5572: case 6356: case 5844: case 3191: case 6645: case 3005:
		// mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
		case 6391: case 5879: case 5623: case 6135: case 4599: case 4855:
		// background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
		case 4215: case 6389: case 5109: case 5365: case 5621: case 3829:
			return WEBKIT + value + value
		// appearance, user-select, transform, hyphens, text-size-adjust
		case 5349: case 4246: case 4810: case 6968: case 2756:
			return WEBKIT + value + MOZ + value + MS + value + value
		// flex, flex-direction
		case 6828: case 4268:
			return WEBKIT + value + MS + value + value
		// order
		case 6165:
			return WEBKIT + value + MS + 'flex-' + value + value
		// align-items
		case 5187:
			return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + 'box-$1$2' + MS + 'flex-$1$2') + value
		// align-self
		case 5443:
			return WEBKIT + value + MS + 'flex-item-' + replace(value, /flex-|-self/, '') + value
		// align-content
		case 4675:
			return WEBKIT + value + MS + 'flex-line-pack' + replace(value, /align-content|flex-|-self/, '') + value
		// flex-shrink
		case 5548:
			return WEBKIT + value + MS + replace(value, 'shrink', 'negative') + value
		// flex-basis
		case 5292:
			return WEBKIT + value + MS + replace(value, 'basis', 'preferred-size') + value
		// flex-grow
		case 6060:
			return WEBKIT + 'box-' + replace(value, '-grow', '') + WEBKIT + value + MS + replace(value, 'grow', 'positive') + value
		// transition
		case 4554:
			return WEBKIT + replace(value, /([^-])(transform)/g, '$1' + WEBKIT + '$2') + value
		// cursor
		case 6187:
			return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + '$1'), /(image-set)/, WEBKIT + '$1'), value, '') + value
		// background, background-image
		case 5495: case 3959:
			return replace(value, /(image-set\([^]*)/, WEBKIT + '$1' + '$`$1')
		// justify-content
		case 4968:
			return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + 'box-pack:$3' + MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + WEBKIT + value + value
		// (margin|padding)-inline-(start|end)
		case 4095: case 3583: case 4068: case 2532:
			return replace(value, /(.+)-inline(.+)/, WEBKIT + '$1$2') + value
		// (min|max)?(width|height|inline-size|block-size)
		case 8116: case 7059: case 5753: case 5535:
		case 5445: case 5701: case 4933: case 4677:
		case 5533: case 5789: case 5021: case 4765:
			// stretch, max-content, min-content, fill-available
			if (Utility_strlen(value) - 1 - length > 6)
				switch (Utility_charat(value, length + 1)) {
					// (m)ax-content, (m)in-content
					case 109:
						// -
						if (Utility_charat(value, length + 4) !== 45)
							break
					// (f)ill-available, (f)it-content
					case 102:
						return replace(value, /(.+:)(.+)-([^]+)/, '$1' + WEBKIT + '$2-$3' + '$1' + MOZ + (Utility_charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value
					// (s)tretch
					case 115:
						return ~indexof(value, 'stretch') ? prefix(replace(value, 'stretch', 'fill-available'), length) + value : value
				}
			break
		// position: sticky
		case 4949:
			// (s)ticky?
			if (Utility_charat(value, length + 1) !== 115)
				break
		// display: (flex|inline-flex)
		case 6444:
			switch (Utility_charat(value, Utility_strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
				// stic(k)y
				case 107:
					return replace(value, ':', ':' + WEBKIT) + value
				// (inline-)?fl(e)x
				case 101:
					return replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + WEBKIT + (Utility_charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + WEBKIT + '$2$3' + '$1' + MS + '$2box$3') + value
			}
			break
		// writing-mode
		case 5936:
			switch (Utility_charat(value, length + 11)) {
				// vertical-l(r)
				case 114:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value
				// vertical-r(l)
				case 108:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value
				// horizontal(-)tb
				case 45:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value
			}

			return WEBKIT + value + MS + value + value
	}

	return value
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Middleware.js






/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = Utility_sizeof(collection)

	return function (element, index, children, callback) {
		var output = ''

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || ''

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element)
	}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 */
function prefixer (element, index, children, callback) {
	if (element.length > -1)
		if (!element.return)
			switch (element.type) {
				case DECLARATION: element.return = prefix(element.value, element.length)
					break
				case KEYFRAMES:
					return serialize([copy(element, {value: replace(element.value, '@', '@' + WEBKIT)})], callback)
				case Enum_RULESET:
					if (element.length)
						return Utility_combine(element.props, function (value) {
							switch (match(value, /(::plac\w+|:read-\w+)/)) {
								// :read-(only|write)
								case ':read-only': case ':read-write':
									return serialize([copy(element, {props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]})], callback)
								// :placeholder
								case '::placeholder':
									return serialize([
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]})
									], callback)
							}

							return ''
						})
			}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 */
function namespace (element) {
	switch (element.type) {
		case RULESET:
			element.props = element.props.map(function (value) {
				return combine(tokenize(value), function (value, index, children) {
					switch (charat(value, 0)) {
						// \f
						case 12:
							return substr(value, 1, strlen(value))
						// \0 ( + > ~
						case 0: case 40: case 43: case 62: case 126:
							return value
						// :
						case 58:
							if (children[++index] === 'global')
								children[index] = '', children[++index] = '\f' + substr(children[index], index = 1, -1)
						// \s
						case 32:
							return index === 1 ? '' : value
						default:
							switch (index) {
								case 0: element = value
									return sizeof(children) > 1 ? '' : value
								case index = sizeof(children) - 1: case 2:
									return index === 2 ? value + element + element : value + element
								default:
									return value
							}
					}
				})
			})
	}
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Parser.js




/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0
	var offset = 0
	var length = pseudo
	var atrule = 0
	var property = 0
	var previous = 0
	var variable = 1
	var scanning = 1
	var ampersand = 1
	var character = 0
	var type = ''
	var props = rules
	var children = rulesets
	var reference = rule
	var characters = type

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && characters.charCodeAt(length - 1) == 58) {
					if (indexof(characters += replace(delimit(character), '&', '&\f'), '&\f') != -1)
						ampersand = -1
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character)
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous)
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7)
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						Utility_append(comment(commenter(next(), caret()), root, parent), declarations)
						break
					default:
						characters += '/'
				}
				break
			// {
			case 123 * variable:
				points[index++] = Utility_strlen(characters) * ampersand
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0
					// ;
					case 59 + offset:
						if (property > 0 && (Utility_strlen(characters) - length))
							Utility_append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations)
						break
					// @ ;
					case 59: characters += ';'
					// { rule/at-rule
					default:
						Utility_append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets)

						if (character === 123)
							if (offset === 0)
								parse(characters, root, reference, reference, props, rulesets, length, points, children)
							else
								switch (atrule) {
									// d m s
									case 100: case 109: case 115:
										parse(value, reference, reference, rule && Utility_append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children)
										break
									default:
										parse(characters, reference, reference, reference, [''], children, 0, points, children)
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo
				break
			// :
			case 58:
				length = 1 + Utility_strlen(characters), property = previous
			default:
				if (variable < 1)
					if (character == 123)
						--variable
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += Utility_from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1)
						break
					// ,
					case 44:
						points[index++] = (Utility_strlen(characters) - 1) * ampersand, ampersand = 1
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next())

						atrule = peek(), offset = length = Utility_strlen(type = characters += identifier(caret())), character++
						break
					// -
					case 45:
						if (previous === 45 && Utility_strlen(characters) == 2)
							variable = 0
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1
	var rule = offset === 0 ? rules : ['']
	var size = Utility_sizeof(rule)

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = Utility_substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim(j > 0 ? rule[x] + ' ' + y : replace(y, /&\f/g, rule[x])))
				props[k++] = z

	return node(value, root, parent, offset === 0 ? Enum_RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return node(value, root, parent, COMMENT, Utility_from(Tokenizer_char()), Utility_substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return node(value, root, parent, DECLARATION, Utility_substr(value, 0, length), Utility_substr(value, length + 1, -1), length)
}

;// CONCATENATED MODULE: ./node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js





var last = function last(arr) {
  return arr.length ? arr[arr.length - 1] : null;
}; // based on https://github.com/thysultan/stylis.js/blob/e6843c373ebcbbfade25ebcc23f540ed8508da0a/src/Tokenizer.js#L239-L244


var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return slice(begin, position);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += Utility_from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

var isIgnoringComment = function isIgnoringComment(element) {
  return !!element && element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};

var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule') return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

    if (unsafePseudoClasses && cache.compat !== true) {
      var prevElement = index > 0 ? children[index - 1] : null;

      if (prevElement && isIgnoringComment(last(prevElement.children))) {
        return;
      }

      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};

var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};

var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }

  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user


var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};

var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }

  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

var defaultStylisPlugins = [prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if (false) {}

  if ( key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  if (false) {}

  var inserted = {}; // $FlowFixMe

  var container;
  var nodesToHydrate = [];

  {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (false) {}

  {
    var currentSheet;
    var finalizingPlugins = [stringify,  false ? 0 : rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return serialize(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      if (false) {}

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

/* harmony default export */ var emotion_cache_browser_esm = (createCache);

;// CONCATENATED MODULE: ./node_modules/@emotion/hash/dist/hash.browser.esm.js
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

/* harmony default export */ var hash_browser_esm = (murmur2);

;// CONCATENATED MODULE: ./node_modules/@emotion/unitless/dist/unitless.browser.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ var unitless_browser_esm = (unitlessKeys);

;// CONCATENATED MODULE: ./node_modules/@emotion/memoize/dist/emotion-memoize.browser.esm.js
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ var emotion_memoize_browser_esm = (memoize);

;// CONCATENATED MODULE: ./node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js




var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */emotion_memoize_browser_esm(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitless_browser_esm[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) { var hyphenatedCache, hyphenPattern, msPattern, oldProcessStyleValue, contentValues, contentValuePattern; }

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {}

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (false) {}

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (false) {}

        break;
      }

    case 'string':
      if (false) { var replaced, matched; }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {}

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (false) {}

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

if (false) {} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (false) {}

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if (false) {}

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {} // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = hash_browser_esm(styles) + identifierName;

  if (false) {}

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};



;// CONCATENATED MODULE: ./node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false ) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};



;// CONCATENATED MODULE: ./node_modules/@emotion/css/create-instance/dist/emotion-css-create-instance.esm.js




function insertWithoutScoping(cache, serialized) {
  if (cache.inserted[serialized.name] === undefined) {
    return cache.insert('', serialized, cache.sheet, true);
  }
}

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var createEmotion = function createEmotion(options) {
  var cache = emotion_cache_browser_esm(options); // $FlowFixMe

  cache.sheet.speedy = function (value) {
    if (false) {}

    this.isSpeedy = value;
  };

  cache.compat = true;

  var css = function css() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = serializeStyles(args, cache.registered, undefined);
    insertStyles(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var keyframes = function keyframes() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var serialized = serializeStyles(args, cache.registered);
    var animation = "animation-" + serialized.name;
    insertWithoutScoping(cache, {
      name: serialized.name,
      styles: "@keyframes " + animation + "{" + serialized.styles + "}"
    });
    return animation;
  };

  var injectGlobal = function injectGlobal() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    var serialized = serializeStyles(args, cache.registered);
    insertWithoutScoping(cache, serialized);
  };

  var cx = function cx() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return merge(cache.registered, css, classnames(args));
  };

  return {
    css: css,
    cx: cx,
    injectGlobal: injectGlobal,
    keyframes: keyframes,
    hydrate: function hydrate(ids) {
      ids.forEach(function (key) {
        cache.inserted[key] = true;
      });
    },
    flush: function flush() {
      cache.registered = {};
      cache.inserted = {};
      cache.sheet.flush();
    },
    // $FlowFixMe
    sheet: cache.sheet,
    cache: cache,
    getRegisteredStyles: getRegisteredStyles.bind(null, cache.registered),
    merge: merge.bind(null, cache.registered, css)
  };
};

var classnames = function classnames(args) {
  var cls = '';

  for (var i = 0; i < args.length; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

/* harmony default export */ var emotion_css_create_instance_esm = (createEmotion);

;// CONCATENATED MODULE: ./node_modules/@emotion/css/dist/emotion-css.esm.js





var _createEmotion = emotion_css_create_instance_esm({
  key: 'css'
}),
    flush = _createEmotion.flush,
    hydrate = _createEmotion.hydrate,
    cx = _createEmotion.cx,
    emotion_css_esm_merge = _createEmotion.merge,
    emotion_css_esm_getRegisteredStyles = _createEmotion.getRegisteredStyles,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    css = _createEmotion.css,
    sheet = _createEmotion.sheet,
    cache = _createEmotion.cache;




/***/ }),

/***/ 62418:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE


var Curry = __webpack_require__(41386);
var Js_dict = __webpack_require__(97076);
var Css_Colors = __webpack_require__(49323);
var Css = __webpack_require__(20294);
var Css_Legacy_Core = __webpack_require__(48050);

function renderRaw(param, css) {
  return Css.injectGlobal(css);
}

function injectRules(selector, rules) {
  return Css.injectGlobal(Js_dict.fromArray([[
                    selector,
                    rules
                  ]]));
}

function renderRules(param, selector, rules) {
  return Css.injectGlobal(Js_dict.fromArray([[
                    selector,
                    rules
                  ]]));
}

function makeKeyframes(frames) {
  return Css.keyframes(frames);
}

function renderKeyframes(param, frames) {
  return Css.keyframes(frames);
}

var include = Css_Legacy_Core.Make({
      injectRaw: Css.injectGlobal,
      renderRaw: renderRaw,
      injectRules: injectRules,
      renderRules: renderRules,
      make: Css.css,
      mergeStyles: Css.cx,
      makeKeyframes: makeKeyframes,
      renderKeyframes: renderKeyframes
    });

var insertRule = include.insertRule;

function fontFace(fontFamily, src, fontStyle, fontWeight, fontDisplay, param) {
  var asString = Css_Legacy_Core.fontFace(fontFamily, src, fontStyle, fontWeight, fontDisplay, undefined);
  Curry._1(insertRule, asString);
  return fontFamily;
}

var Types = Css_Legacy_Core.Types;

var Make = Css_Legacy_Core.Make;

var toJson = Css_Legacy_Core.toJson;

var important = Css_Legacy_Core.important;

var label = Css_Legacy_Core.label;

var Shadow = Css_Legacy_Core.Shadow;

var unsafe = Css_Legacy_Core.unsafe;

var alignContent = Css_Legacy_Core.alignContent;

var alignItems = Css_Legacy_Core.alignItems;

var alignSelf = Css_Legacy_Core.alignSelf;

var animationDelay = Css_Legacy_Core.animationDelay;

var animationDirection = Css_Legacy_Core.animationDirection;

var animationDuration = Css_Legacy_Core.animationDuration;

var animationFillMode = Css_Legacy_Core.animationFillMode;

var animationIterationCount = Css_Legacy_Core.animationIterationCount;

var animationPlayState = Css_Legacy_Core.animationPlayState;

var animationTimingFunction = Css_Legacy_Core.animationTimingFunction;

var backdropFilter = Css_Legacy_Core.backdropFilter;

var backfaceVisibility = Css_Legacy_Core.backfaceVisibility;

var backgroundAttachment = Css_Legacy_Core.backgroundAttachment;

var backgroundColor = Css_Legacy_Core.backgroundColor;

var backgroundClip = Css_Legacy_Core.backgroundClip;

var backgroundImage = Css_Legacy_Core.backgroundImage;

var maskImage = Css_Legacy_Core.maskImage;

var backgroundOrigin = Css_Legacy_Core.backgroundOrigin;

var backgroundPosition = Css_Legacy_Core.backgroundPosition;

var backgroundPositions = Css_Legacy_Core.backgroundPositions;

var backgroundPosition4 = Css_Legacy_Core.backgroundPosition4;

var backgroundRepeat = Css_Legacy_Core.backgroundRepeat;

var maskPosition = Css_Legacy_Core.maskPosition;

var maskPositions = Css_Legacy_Core.maskPositions;

var borderBottom = Css_Legacy_Core.borderBottom;

var borderBottomColor = Css_Legacy_Core.borderBottomColor;

var borderBottomLeftRadius = Css_Legacy_Core.borderBottomLeftRadius;

var borderBottomRightRadius = Css_Legacy_Core.borderBottomRightRadius;

var borderBottomStyle = Css_Legacy_Core.borderBottomStyle;

var borderBottomWidth = Css_Legacy_Core.borderBottomWidth;

var borderCollapse = Css_Legacy_Core.borderCollapse;

var borderColor = Css_Legacy_Core.borderColor;

var borderLeft = Css_Legacy_Core.borderLeft;

var borderLeftColor = Css_Legacy_Core.borderLeftColor;

var borderLeftStyle = Css_Legacy_Core.borderLeftStyle;

var borderLeftWidth = Css_Legacy_Core.borderLeftWidth;

var borderRight = Css_Legacy_Core.borderRight;

var borderRightColor = Css_Legacy_Core.borderRightColor;

var borderRightStyle = Css_Legacy_Core.borderRightStyle;

var borderRightWidth = Css_Legacy_Core.borderRightWidth;

var borderRadius = Css_Legacy_Core.borderRadius;

var borderSpacing = Css_Legacy_Core.borderSpacing;

var borderStyle = Css_Legacy_Core.borderStyle;

var borderTopColor = Css_Legacy_Core.borderTopColor;

var borderTopLeftRadius = Css_Legacy_Core.borderTopLeftRadius;

var borderTopRightRadius = Css_Legacy_Core.borderTopRightRadius;

var borderTopStyle = Css_Legacy_Core.borderTopStyle;

var borderTopWidth = Css_Legacy_Core.borderTopWidth;

var borderWidth = Css_Legacy_Core.borderWidth;

var bottom = Css_Legacy_Core.bottom;

var boxSizing = Css_Legacy_Core.boxSizing;

var boxShadow = Css_Legacy_Core.boxShadow;

var boxShadows = Css_Legacy_Core.boxShadows;

var clear = Css_Legacy_Core.clear;

var clipPath = Css_Legacy_Core.clipPath;

var color = Css_Legacy_Core.color;

var columnCount = Css_Legacy_Core.columnCount;

var contentRule = Css_Legacy_Core.contentRule;

var contentRules = Css_Legacy_Core.contentRules;

var counterIncrement = Css_Legacy_Core.counterIncrement;

var countersIncrement = Css_Legacy_Core.countersIncrement;

var counterReset = Css_Legacy_Core.counterReset;

var countersReset = Css_Legacy_Core.countersReset;

var counterSet = Css_Legacy_Core.counterSet;

var countersSet = Css_Legacy_Core.countersSet;

var cursor = Css_Legacy_Core.cursor;

var direction = Css_Legacy_Core.direction;

var display = Css_Legacy_Core.display;

var flex = Css_Legacy_Core.flex;

var flexBasis = Css_Legacy_Core.flexBasis;

var flexDirection = Css_Legacy_Core.flexDirection;

var flexGrow = Css_Legacy_Core.flexGrow;

var flexShrink = Css_Legacy_Core.flexShrink;

var flexWrap = Css_Legacy_Core.flexWrap;

var $$float = Css_Legacy_Core.$$float;

var fontFamily = Css_Legacy_Core.fontFamily;

var fontFamilies = Css_Legacy_Core.fontFamilies;

var fontSize = Css_Legacy_Core.fontSize;

var fontStyle = Css_Legacy_Core.fontStyle;

var fontVariant = Css_Legacy_Core.fontVariant;

var fontWeight = Css_Legacy_Core.fontWeight;

var gridArea = Css_Legacy_Core.gridArea;

var gridArea2 = Css_Legacy_Core.gridArea2;

var gridArea3 = Css_Legacy_Core.gridArea3;

var gridArea4 = Css_Legacy_Core.gridArea4;

var gridAutoFlow = Css_Legacy_Core.gridAutoFlow;

var gridColumn = Css_Legacy_Core.gridColumn;

var gridColumnEnd = Css_Legacy_Core.gridColumnEnd;

var columnGap = Css_Legacy_Core.columnGap;

var scrollBehavior = Css_Legacy_Core.scrollBehavior;

var overscrollBehavior = Css_Legacy_Core.overscrollBehavior;

var overflowAnchor = Css_Legacy_Core.overflowAnchor;

var columnWidth = Css_Legacy_Core.columnWidth;

var caretColor = Css_Legacy_Core.caretColor;

var rowGap = Css_Legacy_Core.rowGap;

var gridColumnGap = Css_Legacy_Core.gridColumnGap;

var gridColumnStart = Css_Legacy_Core.gridColumnStart;

var gap = Css_Legacy_Core.gap;

var gap2 = Css_Legacy_Core.gap2;

var gridGap = Css_Legacy_Core.gridGap;

var gridRow = Css_Legacy_Core.gridRow;

var gridRowEnd = Css_Legacy_Core.gridRowEnd;

var gridRowGap = Css_Legacy_Core.gridRowGap;

var gridRowStart = Css_Legacy_Core.gridRowStart;

var gridTemplateAreas = Css_Legacy_Core.gridTemplateAreas;

var height = Css_Legacy_Core.height;

var justifyContent = Css_Legacy_Core.justifyContent;

var justifyItems = Css_Legacy_Core.justifyItems;

var justifySelf = Css_Legacy_Core.justifySelf;

var left = Css_Legacy_Core.left;

var letterSpacing = Css_Legacy_Core.letterSpacing;

var lineHeight = Css_Legacy_Core.lineHeight;

var listStyle = Css_Legacy_Core.listStyle;

var listStyleImage = Css_Legacy_Core.listStyleImage;

var listStyleType = Css_Legacy_Core.listStyleType;

var listStylePosition = Css_Legacy_Core.listStylePosition;

var margin = Css_Legacy_Core.margin;

var margin2 = Css_Legacy_Core.margin2;

var margin3 = Css_Legacy_Core.margin3;

var margin4 = Css_Legacy_Core.margin4;

var marginLeft = Css_Legacy_Core.marginLeft;

var marginRight = Css_Legacy_Core.marginRight;

var marginTop = Css_Legacy_Core.marginTop;

var marginBottom = Css_Legacy_Core.marginBottom;

var maxHeight = Css_Legacy_Core.maxHeight;

var maxWidth = Css_Legacy_Core.maxWidth;

var minHeight = Css_Legacy_Core.minHeight;

var minWidth = Css_Legacy_Core.minWidth;

var objectFit = Css_Legacy_Core.objectFit;

var objectPosition = Css_Legacy_Core.objectPosition;

var opacity = Css_Legacy_Core.opacity;

var order = Css_Legacy_Core.order;

var outline = Css_Legacy_Core.outline;

var outlineColor = Css_Legacy_Core.outlineColor;

var outlineOffset = Css_Legacy_Core.outlineOffset;

var outlineStyle = Css_Legacy_Core.outlineStyle;

var outlineWidth = Css_Legacy_Core.outlineWidth;

var overflow = Css_Legacy_Core.overflow;

var overflowX = Css_Legacy_Core.overflowX;

var overflowY = Css_Legacy_Core.overflowY;

var overflowWrap = Css_Legacy_Core.overflowWrap;

var padding = Css_Legacy_Core.padding;

var padding2 = Css_Legacy_Core.padding2;

var padding3 = Css_Legacy_Core.padding3;

var padding4 = Css_Legacy_Core.padding4;

var paddingLeft = Css_Legacy_Core.paddingLeft;

var paddingRight = Css_Legacy_Core.paddingRight;

var paddingTop = Css_Legacy_Core.paddingTop;

var paddingBottom = Css_Legacy_Core.paddingBottom;

var perspective = Css_Legacy_Core.perspective;

var perspectiveOrigin = Css_Legacy_Core.perspectiveOrigin;

var pointerEvents = Css_Legacy_Core.pointerEvents;

var position = Css_Legacy_Core.position;

var isolation = Css_Legacy_Core.isolation;

var resize = Css_Legacy_Core.resize;

var right = Css_Legacy_Core.right;

var tableLayout = Css_Legacy_Core.tableLayout;

var textAlign = Css_Legacy_Core.textAlign;

var textDecorationColor = Css_Legacy_Core.textDecorationColor;

var textDecorationLine = Css_Legacy_Core.textDecorationLine;

var textDecorationStyle = Css_Legacy_Core.textDecorationStyle;

var textIndent = Css_Legacy_Core.textIndent;

var textOverflow = Css_Legacy_Core.textOverflow;

var textShadow = Css_Legacy_Core.textShadow;

var textShadows = Css_Legacy_Core.textShadows;

var textTransform = Css_Legacy_Core.textTransform;

var top = Css_Legacy_Core.top;

var transform = Css_Legacy_Core.transform;

var transforms = Css_Legacy_Core.transforms;

var transformOrigin = Css_Legacy_Core.transformOrigin;

var transformOrigin3d = Css_Legacy_Core.transformOrigin3d;

var transitionDelay = Css_Legacy_Core.transitionDelay;

var transitionDuration = Css_Legacy_Core.transitionDuration;

var transitionProperty = Css_Legacy_Core.transitionProperty;

var transformStyle = Css_Legacy_Core.transformStyle;

var transitionTimingFunction = Css_Legacy_Core.transitionTimingFunction;

var userSelect = Css_Legacy_Core.userSelect;

var verticalAlign = Css_Legacy_Core.verticalAlign;

var visibility = Css_Legacy_Core.visibility;

var width = Css_Legacy_Core.width;

var whiteSpace = Css_Legacy_Core.whiteSpace;

var wordBreak = Css_Legacy_Core.wordBreak;

var wordSpacing = Css_Legacy_Core.wordSpacing;

var wordWrap = Css_Legacy_Core.wordWrap;

var zIndex = Css_Legacy_Core.zIndex;

var selector = Css_Legacy_Core.selector;

var media = Css_Legacy_Core.media;

var active = Css_Legacy_Core.active;

var checked = Css_Legacy_Core.checked;

var $$default = Css_Legacy_Core.$$default;

var defined = Css_Legacy_Core.defined;

var disabled = Css_Legacy_Core.disabled;

var empty = Css_Legacy_Core.empty;

var enabled = Css_Legacy_Core.enabled;

var first = Css_Legacy_Core.first;

var firstChild = Css_Legacy_Core.firstChild;

var firstOfType = Css_Legacy_Core.firstOfType;

var focus = Css_Legacy_Core.focus;

var focusVisible = Css_Legacy_Core.focusVisible;

var focusWithin = Css_Legacy_Core.focusWithin;

var host = Css_Legacy_Core.host;

var hover = Css_Legacy_Core.hover;

var indeterminate = Css_Legacy_Core.indeterminate;

var inRange = Css_Legacy_Core.inRange;

var invalid = Css_Legacy_Core.invalid;

var lang = Css_Legacy_Core.lang;

var lastChild = Css_Legacy_Core.lastChild;

var lastOfType = Css_Legacy_Core.lastOfType;

var link = Css_Legacy_Core.link;

var not__ = Css_Legacy_Core.not__;

var Nth = Css_Legacy_Core.Nth;

var nthChild = Css_Legacy_Core.nthChild;

var nthLastChild = Css_Legacy_Core.nthLastChild;

var nthLastOfType = Css_Legacy_Core.nthLastOfType;

var nthOfType = Css_Legacy_Core.nthOfType;

var onlyChild = Css_Legacy_Core.onlyChild;

var onlyOfType = Css_Legacy_Core.onlyOfType;

var optional = Css_Legacy_Core.optional;

var outOfRange = Css_Legacy_Core.outOfRange;

var readOnly = Css_Legacy_Core.readOnly;

var readWrite = Css_Legacy_Core.readWrite;

var required = Css_Legacy_Core.required;

var root = Css_Legacy_Core.root;

var scope = Css_Legacy_Core.scope;

var target = Css_Legacy_Core.target;

var valid = Css_Legacy_Core.valid;

var visited = Css_Legacy_Core.visited;

var after = Css_Legacy_Core.after;

var before = Css_Legacy_Core.before;

var firstLetter = Css_Legacy_Core.firstLetter;

var firstLine = Css_Legacy_Core.firstLine;

var placeholder = Css_Legacy_Core.placeholder;

var selection = Css_Legacy_Core.selection;

var child = Css_Legacy_Core.child;

var children = Css_Legacy_Core.children;

var directSibling = Css_Legacy_Core.directSibling;

var siblings = Css_Legacy_Core.siblings;

var anyLink = Css_Legacy_Core.anyLink;

var initial = Css_Legacy_Core.initial;

var inherit_ = Css_Legacy_Core.inherit_;

var unset = Css_Legacy_Core.unset;

var $$var = Css_Legacy_Core.$$var;

var varDefault = Css_Legacy_Core.varDefault;

var auto = Css_Legacy_Core.auto;

var none = Css_Legacy_Core.none;

var text = Css_Legacy_Core.text;

var pct = Css_Legacy_Core.pct;

var ch = Css_Legacy_Core.ch;

var cm = Css_Legacy_Core.cm;

var em = Css_Legacy_Core.em;

var ex = Css_Legacy_Core.ex;

var mm = Css_Legacy_Core.mm;

var pt = Css_Legacy_Core.pt;

var px = Css_Legacy_Core.px;

var pxFloat = Css_Legacy_Core.pxFloat;

var rem = Css_Legacy_Core.rem;

var vh = Css_Legacy_Core.vh;

var vmin = Css_Legacy_Core.vmin;

var vmax = Css_Legacy_Core.vmax;

var zero = Css_Legacy_Core.zero;

var deg = Css_Legacy_Core.deg;

var rad = Css_Legacy_Core.rad;

var grad = Css_Legacy_Core.grad;

var turn = Css_Legacy_Core.turn;

var ltr = Css_Legacy_Core.ltr;

var rtl = Css_Legacy_Core.rtl;

var absolute = Css_Legacy_Core.absolute;

var relative = Css_Legacy_Core.relative;

var $$static = Css_Legacy_Core.$$static;

var fixed = Css_Legacy_Core.fixed;

var sticky = Css_Legacy_Core.sticky;

var isolate = Css_Legacy_Core.isolate;

var horizontal = Css_Legacy_Core.horizontal;

var vertical = Css_Legacy_Core.vertical;

var smallCaps = Css_Legacy_Core.smallCaps;

var italic = Css_Legacy_Core.italic;

var oblique = Css_Legacy_Core.oblique;

var hidden = Css_Legacy_Core.hidden;

var visible = Css_Legacy_Core.visible;

var scroll = Css_Legacy_Core.scroll;

var rgb = Css_Legacy_Core.rgb;

var rgba = Css_Legacy_Core.rgba;

var hsl = Css_Legacy_Core.hsl;

var hsla = Css_Legacy_Core.hsla;

var hex = Css_Legacy_Core.hex;

var currentColor = Css_Legacy_Core.currentColor;

var local = Css_Legacy_Core.local;

var paddingBox = Css_Legacy_Core.paddingBox;

var borderBox = Css_Legacy_Core.borderBox;

var contentBox = Css_Legacy_Core.contentBox;

var noRepeat = Css_Legacy_Core.noRepeat;

var space = Css_Legacy_Core.space;

var repeat = Css_Legacy_Core.repeat;

var minmax = Css_Legacy_Core.minmax;

var repeatX = Css_Legacy_Core.repeatX;

var repeatY = Css_Legacy_Core.repeatY;

var contain = Css_Legacy_Core.contain;

var cover = Css_Legacy_Core.cover;

var row = Css_Legacy_Core.row;

var rowReverse = Css_Legacy_Core.rowReverse;

var column = Css_Legacy_Core.column;

var columnReverse = Css_Legacy_Core.columnReverse;

var wrap = Css_Legacy_Core.wrap;

var nowrap = Css_Legacy_Core.nowrap;

var wrapReverse = Css_Legacy_Core.wrapReverse;

var inline = Css_Legacy_Core.inline;

var block = Css_Legacy_Core.block;

var contents = Css_Legacy_Core.contents;

var flexBox = Css_Legacy_Core.flexBox;

var grid = Css_Legacy_Core.grid;

var inlineBlock = Css_Legacy_Core.inlineBlock;

var inlineFlex = Css_Legacy_Core.inlineFlex;

var inlineGrid = Css_Legacy_Core.inlineGrid;

var inlineTable = Css_Legacy_Core.inlineTable;

var listItem = Css_Legacy_Core.listItem;

var runIn = Css_Legacy_Core.runIn;

var table = Css_Legacy_Core.table;

var tableCaption = Css_Legacy_Core.tableCaption;

var tableColumnGroup = Css_Legacy_Core.tableColumnGroup;

var tableHeaderGroup = Css_Legacy_Core.tableHeaderGroup;

var tableFooterGroup = Css_Legacy_Core.tableFooterGroup;

var tableRowGroup = Css_Legacy_Core.tableRowGroup;

var tableCell = Css_Legacy_Core.tableCell;

var tableColumn = Css_Legacy_Core.tableColumn;

var tableRow = Css_Legacy_Core.tableRow;

var flexStart = Css_Legacy_Core.flexStart;

var flexEnd = Css_Legacy_Core.flexEnd;

var center = Css_Legacy_Core.center;

var stretch = Css_Legacy_Core.stretch;

var spaceBetween = Css_Legacy_Core.spaceBetween;

var spaceAround = Css_Legacy_Core.spaceAround;

var spaceEvenly = Css_Legacy_Core.spaceEvenly;

var baseline = Css_Legacy_Core.baseline;

var forwards = Css_Legacy_Core.forwards;

var backwards = Css_Legacy_Core.backwards;

var both = Css_Legacy_Core.both;

var infinite = Css_Legacy_Core.infinite;

var count = Css_Legacy_Core.count;

var paused = Css_Legacy_Core.paused;

var running = Css_Legacy_Core.running;

var inside = Css_Legacy_Core.inside;

var outside = Css_Legacy_Core.outside;

var solid = Css_Legacy_Core.solid;

var dotted = Css_Legacy_Core.dotted;

var dashed = Css_Legacy_Core.dashed;

var underline = Css_Legacy_Core.underline;

var overline = Css_Legacy_Core.overline;

var lineThrough = Css_Legacy_Core.lineThrough;

var clip = Css_Legacy_Core.clip;

var ellipsis = Css_Legacy_Core.ellipsis;

var wavy = Css_Legacy_Core.wavy;

var $$double = Css_Legacy_Core.$$double;

var uppercase = Css_Legacy_Core.uppercase;

var lowercase = Css_Legacy_Core.lowercase;

var capitalize = Css_Legacy_Core.capitalize;

var sub = Css_Legacy_Core.sub;

var $$super = Css_Legacy_Core.$$super;

var textTop = Css_Legacy_Core.textTop;

var textBottom = Css_Legacy_Core.textBottom;

var middle = Css_Legacy_Core.middle;

var normal = Css_Legacy_Core.normal;

var breakAll = Css_Legacy_Core.breakAll;

var keepAll = Css_Legacy_Core.keepAll;

var breakWord = Css_Legacy_Core.breakWord;

var reverse = Css_Legacy_Core.reverse;

var alternate = Css_Legacy_Core.alternate;

var alternateReverse = Css_Legacy_Core.alternateReverse;

var fill = Css_Legacy_Core.fill;

var content = Css_Legacy_Core.content;

var maxContent = Css_Legacy_Core.maxContent;

var minContent = Css_Legacy_Core.minContent;

var fitContent = Css_Legacy_Core.fitContent;

var all = Css_Legacy_Core.all;

var round = Css_Legacy_Core.round;

var miter = Css_Legacy_Core.miter;

var bevel = Css_Legacy_Core.bevel;

var butt = Css_Legacy_Core.butt;

var square = Css_Legacy_Core.square;

var panX = Css_Legacy_Core.panX;

var panY = Css_Legacy_Core.panY;

var panLeft = Css_Legacy_Core.panLeft;

var panRight = Css_Legacy_Core.panRight;

var panUp = Css_Legacy_Core.panUp;

var panDown = Css_Legacy_Core.panDown;

var pinchZoom = Css_Legacy_Core.pinchZoom;

var manipulation = Css_Legacy_Core.manipulation;

var thin = Css_Legacy_Core.thin;

var extraLight = Css_Legacy_Core.extraLight;

var light = Css_Legacy_Core.light;

var medium = Css_Legacy_Core.medium;

var semiBold = Css_Legacy_Core.semiBold;

var bold = Css_Legacy_Core.bold;

var extraBold = Css_Legacy_Core.extraBold;

var lighter = Css_Legacy_Core.lighter;

var bolder = Css_Legacy_Core.bolder;

var fr = Css_Legacy_Core.fr;

var vw = Css_Legacy_Core.vw;

var localUrl = Css_Legacy_Core.localUrl;

var url = Css_Legacy_Core.url;

var linear = Css_Legacy_Core.linear;

var ease = Css_Legacy_Core.ease;

var easeIn = Css_Legacy_Core.easeIn;

var easeOut = Css_Legacy_Core.easeOut;

var easeInOut = Css_Legacy_Core.easeInOut;

var stepStart = Css_Legacy_Core.stepStart;

var stepEnd = Css_Legacy_Core.stepEnd;

var steps = Css_Legacy_Core.steps;

var cubicBezier = Css_Legacy_Core.cubicBezier;

var marginBox = Css_Legacy_Core.marginBox;

var fillBox = Css_Legacy_Core.fillBox;

var strokeBox = Css_Legacy_Core.strokeBox;

var viewBox = Css_Legacy_Core.viewBox;

var translate = Css_Legacy_Core.translate;

var translate3d = Css_Legacy_Core.translate3d;

var translateX = Css_Legacy_Core.translateX;

var translateY = Css_Legacy_Core.translateY;

var translateZ = Css_Legacy_Core.translateZ;

var scale = Css_Legacy_Core.scale;

var scale3d = Css_Legacy_Core.scale3d;

var scaleX = Css_Legacy_Core.scaleX;

var scaleY = Css_Legacy_Core.scaleY;

var scaleZ = Css_Legacy_Core.scaleZ;

var rotate = Css_Legacy_Core.rotate;

var rotate3d = Css_Legacy_Core.rotate3d;

var rotateX = Css_Legacy_Core.rotateX;

var rotateY = Css_Legacy_Core.rotateY;

var rotateZ = Css_Legacy_Core.rotateZ;

var skew = Css_Legacy_Core.skew;

var skewX = Css_Legacy_Core.skewX;

var skewY = Css_Legacy_Core.skewY;

var linearGradient = Css_Legacy_Core.linearGradient;

var repeatingLinearGradient = Css_Legacy_Core.repeatingLinearGradient;

var radialGradient = Css_Legacy_Core.radialGradient;

var repeatingRadialGradient = Css_Legacy_Core.repeatingRadialGradient;

var conicGradient = Css_Legacy_Core.conicGradient;

var areas = Css_Legacy_Core.areas;

var ident = Css_Legacy_Core.ident;

var numIdent = Css_Legacy_Core.numIdent;

var contextMenu = Css_Legacy_Core.contextMenu;

var help = Css_Legacy_Core.help;

var pointer = Css_Legacy_Core.pointer;

var progress = Css_Legacy_Core.progress;

var wait = Css_Legacy_Core.wait;

var cell = Css_Legacy_Core.cell;

var crosshair = Css_Legacy_Core.crosshair;

var verticalText = Css_Legacy_Core.verticalText;

var alias = Css_Legacy_Core.alias;

var copy = Css_Legacy_Core.copy;

var move = Css_Legacy_Core.move;

var noDrop = Css_Legacy_Core.noDrop;

var notAllowed = Css_Legacy_Core.notAllowed;

var grab = Css_Legacy_Core.grab;

var grabbing = Css_Legacy_Core.grabbing;

var allScroll = Css_Legacy_Core.allScroll;

var colResize = Css_Legacy_Core.colResize;

var rowResize = Css_Legacy_Core.rowResize;

var nResize = Css_Legacy_Core.nResize;

var eResize = Css_Legacy_Core.eResize;

var sResize = Css_Legacy_Core.sResize;

var wResize = Css_Legacy_Core.wResize;

var neResize = Css_Legacy_Core.neResize;

var nwResize = Css_Legacy_Core.nwResize;

var seResize = Css_Legacy_Core.seResize;

var swResize = Css_Legacy_Core.swResize;

var ewResize = Css_Legacy_Core.ewResize;

var nsResize = Css_Legacy_Core.nsResize;

var neswResize = Css_Legacy_Core.neswResize;

var nwseResize = Css_Legacy_Core.nwseResize;

var zoomIn = Css_Legacy_Core.zoomIn;

var zoomOut = Css_Legacy_Core.zoomOut;

var flex3 = Css_Legacy_Core.flex3;

var border = Css_Legacy_Core.border;

var borderTop = Css_Legacy_Core.borderTop;

var backgroundSize = Css_Legacy_Core.backgroundSize;

var textDecoration = Css_Legacy_Core.textDecoration;

var background = Css_Legacy_Core.background;

var backgrounds = Css_Legacy_Core.backgrounds;

var gridAutoColumns = Css_Legacy_Core.gridAutoColumns;

var gridAutoRows = Css_Legacy_Core.gridAutoRows;

var gridTemplateColumns = Css_Legacy_Core.gridTemplateColumns;

var gridTemplateRows = Css_Legacy_Core.gridTemplateRows;

var Calc = Css_Legacy_Core.Calc;

var size = Css_Legacy_Core.size;

var filter = Css_Legacy_Core.filter;

var Transition = Css_Legacy_Core.Transition;

var transitionValue = Css_Legacy_Core.transitionValue;

var transitionList = Css_Legacy_Core.transitionList;

var transition = Css_Legacy_Core.transition;

var transitions = Css_Legacy_Core.transitions;

var Animation = Css_Legacy_Core.Animation;

var animationValue = Css_Legacy_Core.animationValue;

var animation = Css_Legacy_Core.animation;

var animations = Css_Legacy_Core.animations;

var animationName = Css_Legacy_Core.animationName;

var SVG = Css_Legacy_Core.SVG;

var touchAction = Css_Legacy_Core.touchAction;

var aliceblue = Css_Colors.aliceblue;

var antiquewhite = Css_Colors.antiquewhite;

var aqua = Css_Colors.aqua;

var aquamarine = Css_Colors.aquamarine;

var azure = Css_Colors.azure;

var beige = Css_Colors.beige;

var bisque = Css_Colors.bisque;

var black = Css_Colors.black;

var blanchedalmond = Css_Colors.blanchedalmond;

var blue = Css_Colors.blue;

var blueviolet = Css_Colors.blueviolet;

var brown = Css_Colors.brown;

var burlywood = Css_Colors.burlywood;

var cadetblue = Css_Colors.cadetblue;

var chartreuse = Css_Colors.chartreuse;

var chocolate = Css_Colors.chocolate;

var coral = Css_Colors.coral;

var cornflowerblue = Css_Colors.cornflowerblue;

var cornsilk = Css_Colors.cornsilk;

var crimson = Css_Colors.crimson;

var cyan = Css_Colors.cyan;

var darkblue = Css_Colors.darkblue;

var darkcyan = Css_Colors.darkcyan;

var darkgoldenrod = Css_Colors.darkgoldenrod;

var darkgray = Css_Colors.darkgray;

var darkgreen = Css_Colors.darkgreen;

var darkgrey = Css_Colors.darkgrey;

var darkkhaki = Css_Colors.darkkhaki;

var darkmagenta = Css_Colors.darkmagenta;

var darkolivegreen = Css_Colors.darkolivegreen;

var darkorange = Css_Colors.darkorange;

var darkorchid = Css_Colors.darkorchid;

var darkred = Css_Colors.darkred;

var darksalmon = Css_Colors.darksalmon;

var darkseagreen = Css_Colors.darkseagreen;

var darkslateblue = Css_Colors.darkslateblue;

var darkslategray = Css_Colors.darkslategray;

var darkslategrey = Css_Colors.darkslategrey;

var darkturquoise = Css_Colors.darkturquoise;

var darkviolet = Css_Colors.darkviolet;

var deeppink = Css_Colors.deeppink;

var deepskyblue = Css_Colors.deepskyblue;

var dimgray = Css_Colors.dimgray;

var dimgrey = Css_Colors.dimgrey;

var dodgerblue = Css_Colors.dodgerblue;

var firebrick = Css_Colors.firebrick;

var floralwhite = Css_Colors.floralwhite;

var forestgreen = Css_Colors.forestgreen;

var fuchsia = Css_Colors.fuchsia;

var gainsboro = Css_Colors.gainsboro;

var ghostwhite = Css_Colors.ghostwhite;

var gold = Css_Colors.gold;

var goldenrod = Css_Colors.goldenrod;

var gray = Css_Colors.gray;

var green = Css_Colors.green;

var greenyellow = Css_Colors.greenyellow;

var grey = Css_Colors.grey;

var honeydew = Css_Colors.honeydew;

var hotpink = Css_Colors.hotpink;

var indianred = Css_Colors.indianred;

var indigo = Css_Colors.indigo;

var ivory = Css_Colors.ivory;

var khaki = Css_Colors.khaki;

var lavender = Css_Colors.lavender;

var lavenderblush = Css_Colors.lavenderblush;

var lawngreen = Css_Colors.lawngreen;

var lemonchiffon = Css_Colors.lemonchiffon;

var lightblue = Css_Colors.lightblue;

var lightcoral = Css_Colors.lightcoral;

var lightcyan = Css_Colors.lightcyan;

var lightgoldenrodyellow = Css_Colors.lightgoldenrodyellow;

var lightgray = Css_Colors.lightgray;

var lightgreen = Css_Colors.lightgreen;

var lightgrey = Css_Colors.lightgrey;

var lightpink = Css_Colors.lightpink;

var lightsalmon = Css_Colors.lightsalmon;

var lightseagreen = Css_Colors.lightseagreen;

var lightskyblue = Css_Colors.lightskyblue;

var lightslategray = Css_Colors.lightslategray;

var lightslategrey = Css_Colors.lightslategrey;

var lightsteelblue = Css_Colors.lightsteelblue;

var lightyellow = Css_Colors.lightyellow;

var lime = Css_Colors.lime;

var limegreen = Css_Colors.limegreen;

var linen = Css_Colors.linen;

var magenta = Css_Colors.magenta;

var maroon = Css_Colors.maroon;

var mediumaquamarine = Css_Colors.mediumaquamarine;

var mediumblue = Css_Colors.mediumblue;

var mediumorchid = Css_Colors.mediumorchid;

var mediumpurple = Css_Colors.mediumpurple;

var mediumseagreen = Css_Colors.mediumseagreen;

var mediumslateblue = Css_Colors.mediumslateblue;

var mediumspringgreen = Css_Colors.mediumspringgreen;

var mediumturquoise = Css_Colors.mediumturquoise;

var mediumvioletred = Css_Colors.mediumvioletred;

var midnightblue = Css_Colors.midnightblue;

var mintcream = Css_Colors.mintcream;

var mistyrose = Css_Colors.mistyrose;

var moccasin = Css_Colors.moccasin;

var navajowhite = Css_Colors.navajowhite;

var navy = Css_Colors.navy;

var oldlace = Css_Colors.oldlace;

var olive = Css_Colors.olive;

var olivedrab = Css_Colors.olivedrab;

var orange = Css_Colors.orange;

var orangered = Css_Colors.orangered;

var orchid = Css_Colors.orchid;

var palegoldenrod = Css_Colors.palegoldenrod;

var palegreen = Css_Colors.palegreen;

var paleturquoise = Css_Colors.paleturquoise;

var palevioletred = Css_Colors.palevioletred;

var papayawhip = Css_Colors.papayawhip;

var peachpuff = Css_Colors.peachpuff;

var peru = Css_Colors.peru;

var pink = Css_Colors.pink;

var plum = Css_Colors.plum;

var powderblue = Css_Colors.powderblue;

var purple = Css_Colors.purple;

var rebeccapurple = Css_Colors.rebeccapurple;

var red = Css_Colors.red;

var rosybrown = Css_Colors.rosybrown;

var royalblue = Css_Colors.royalblue;

var saddlebrown = Css_Colors.saddlebrown;

var salmon = Css_Colors.salmon;

var sandybrown = Css_Colors.sandybrown;

var seagreen = Css_Colors.seagreen;

var seashell = Css_Colors.seashell;

var sienna = Css_Colors.sienna;

var silver = Css_Colors.silver;

var skyblue = Css_Colors.skyblue;

var slateblue = Css_Colors.slateblue;

var slategray = Css_Colors.slategray;

var slategrey = Css_Colors.slategrey;

var snow = Css_Colors.snow;

var springgreen = Css_Colors.springgreen;

var steelblue = Css_Colors.steelblue;

var tan = Css_Colors.tan;

var teal = Css_Colors.teal;

var thistle = Css_Colors.thistle;

var tomato = Css_Colors.tomato;

var turquoise = Css_Colors.turquoise;

var violet = Css_Colors.violet;

var wheat = Css_Colors.wheat;

var white = Css_Colors.white;

var whitesmoke = Css_Colors.whitesmoke;

var yellow = Css_Colors.yellow;

var yellowgreen = Css_Colors.yellowgreen;

var transparent = Css_Colors.transparent;

var renderRule = include.renderRule;

var $$global = include.$$global;

var renderGlobal = include.renderGlobal;

var style = include.style;

var merge = include.merge;

var merge2 = include.merge2;

var merge3 = include.merge3;

var merge4 = include.merge4;

var keyframes = include.keyframes;

var renderKeyframes$1 = include.renderKeyframes;

exports.Types = Types;
exports.Make = Make;
exports.toJson = toJson;
exports.important = important;
exports.label = label;
exports.Shadow = Shadow;
exports.unsafe = unsafe;
exports.alignContent = alignContent;
exports.alignItems = alignItems;
exports.alignSelf = alignSelf;
exports.animationDelay = animationDelay;
exports.animationDirection = animationDirection;
exports.animationDuration = animationDuration;
exports.animationFillMode = animationFillMode;
exports.animationIterationCount = animationIterationCount;
exports.animationPlayState = animationPlayState;
exports.animationTimingFunction = animationTimingFunction;
exports.backdropFilter = backdropFilter;
exports.backfaceVisibility = backfaceVisibility;
exports.backgroundAttachment = backgroundAttachment;
exports.backgroundColor = backgroundColor;
exports.backgroundClip = backgroundClip;
exports.backgroundImage = backgroundImage;
exports.maskImage = maskImage;
exports.backgroundOrigin = backgroundOrigin;
exports.backgroundPosition = backgroundPosition;
exports.backgroundPositions = backgroundPositions;
exports.backgroundPosition4 = backgroundPosition4;
exports.backgroundRepeat = backgroundRepeat;
exports.maskPosition = maskPosition;
exports.maskPositions = maskPositions;
exports.borderBottom = borderBottom;
exports.borderBottomColor = borderBottomColor;
exports.borderBottomLeftRadius = borderBottomLeftRadius;
exports.borderBottomRightRadius = borderBottomRightRadius;
exports.borderBottomStyle = borderBottomStyle;
exports.borderBottomWidth = borderBottomWidth;
exports.borderCollapse = borderCollapse;
exports.borderColor = borderColor;
exports.borderLeft = borderLeft;
exports.borderLeftColor = borderLeftColor;
exports.borderLeftStyle = borderLeftStyle;
exports.borderLeftWidth = borderLeftWidth;
exports.borderRight = borderRight;
exports.borderRightColor = borderRightColor;
exports.borderRightStyle = borderRightStyle;
exports.borderRightWidth = borderRightWidth;
exports.borderRadius = borderRadius;
exports.borderSpacing = borderSpacing;
exports.borderStyle = borderStyle;
exports.borderTopColor = borderTopColor;
exports.borderTopLeftRadius = borderTopLeftRadius;
exports.borderTopRightRadius = borderTopRightRadius;
exports.borderTopStyle = borderTopStyle;
exports.borderTopWidth = borderTopWidth;
exports.borderWidth = borderWidth;
exports.bottom = bottom;
exports.boxSizing = boxSizing;
exports.boxShadow = boxShadow;
exports.boxShadows = boxShadows;
exports.clear = clear;
exports.clipPath = clipPath;
exports.color = color;
exports.columnCount = columnCount;
exports.contentRule = contentRule;
exports.contentRules = contentRules;
exports.counterIncrement = counterIncrement;
exports.countersIncrement = countersIncrement;
exports.counterReset = counterReset;
exports.countersReset = countersReset;
exports.counterSet = counterSet;
exports.countersSet = countersSet;
exports.cursor = cursor;
exports.direction = direction;
exports.display = display;
exports.flex = flex;
exports.flexBasis = flexBasis;
exports.flexDirection = flexDirection;
exports.flexGrow = flexGrow;
exports.flexShrink = flexShrink;
exports.flexWrap = flexWrap;
exports.$$float = $$float;
exports.fontFamily = fontFamily;
exports.fontFamilies = fontFamilies;
exports.fontSize = fontSize;
exports.fontStyle = fontStyle;
exports.fontVariant = fontVariant;
exports.fontWeight = fontWeight;
exports.gridArea = gridArea;
exports.gridArea2 = gridArea2;
exports.gridArea3 = gridArea3;
exports.gridArea4 = gridArea4;
exports.gridAutoFlow = gridAutoFlow;
exports.gridColumn = gridColumn;
exports.gridColumnEnd = gridColumnEnd;
exports.columnGap = columnGap;
exports.scrollBehavior = scrollBehavior;
exports.overscrollBehavior = overscrollBehavior;
exports.overflowAnchor = overflowAnchor;
exports.columnWidth = columnWidth;
exports.caretColor = caretColor;
exports.rowGap = rowGap;
exports.gridColumnGap = gridColumnGap;
exports.gridColumnStart = gridColumnStart;
exports.gap = gap;
exports.gap2 = gap2;
exports.gridGap = gridGap;
exports.gridRow = gridRow;
exports.gridRowEnd = gridRowEnd;
exports.gridRowGap = gridRowGap;
exports.gridRowStart = gridRowStart;
exports.gridTemplateAreas = gridTemplateAreas;
exports.height = height;
exports.justifyContent = justifyContent;
exports.justifyItems = justifyItems;
exports.justifySelf = justifySelf;
exports.left = left;
exports.letterSpacing = letterSpacing;
exports.lineHeight = lineHeight;
exports.listStyle = listStyle;
exports.listStyleImage = listStyleImage;
exports.listStyleType = listStyleType;
exports.listStylePosition = listStylePosition;
exports.margin = margin;
exports.margin2 = margin2;
exports.margin3 = margin3;
exports.margin4 = margin4;
exports.marginLeft = marginLeft;
exports.marginRight = marginRight;
exports.marginTop = marginTop;
exports.marginBottom = marginBottom;
exports.maxHeight = maxHeight;
exports.maxWidth = maxWidth;
exports.minHeight = minHeight;
exports.minWidth = minWidth;
exports.objectFit = objectFit;
exports.objectPosition = objectPosition;
exports.opacity = opacity;
exports.order = order;
exports.outline = outline;
exports.outlineColor = outlineColor;
exports.outlineOffset = outlineOffset;
exports.outlineStyle = outlineStyle;
exports.outlineWidth = outlineWidth;
exports.overflow = overflow;
exports.overflowX = overflowX;
exports.overflowY = overflowY;
exports.overflowWrap = overflowWrap;
exports.padding = padding;
exports.padding2 = padding2;
exports.padding3 = padding3;
exports.padding4 = padding4;
exports.paddingLeft = paddingLeft;
exports.paddingRight = paddingRight;
exports.paddingTop = paddingTop;
exports.paddingBottom = paddingBottom;
exports.perspective = perspective;
exports.perspectiveOrigin = perspectiveOrigin;
exports.pointerEvents = pointerEvents;
exports.position = position;
exports.isolation = isolation;
exports.resize = resize;
exports.right = right;
exports.tableLayout = tableLayout;
exports.textAlign = textAlign;
exports.textDecorationColor = textDecorationColor;
exports.textDecorationLine = textDecorationLine;
exports.textDecorationStyle = textDecorationStyle;
exports.textIndent = textIndent;
exports.textOverflow = textOverflow;
exports.textShadow = textShadow;
exports.textShadows = textShadows;
exports.textTransform = textTransform;
exports.top = top;
exports.transform = transform;
exports.transforms = transforms;
exports.transformOrigin = transformOrigin;
exports.transformOrigin3d = transformOrigin3d;
exports.transitionDelay = transitionDelay;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
exports.transformStyle = transformStyle;
exports.transitionTimingFunction = transitionTimingFunction;
exports.userSelect = userSelect;
exports.verticalAlign = verticalAlign;
exports.visibility = visibility;
exports.width = width;
exports.whiteSpace = whiteSpace;
exports.wordBreak = wordBreak;
exports.wordSpacing = wordSpacing;
exports.wordWrap = wordWrap;
exports.zIndex = zIndex;
exports.selector = selector;
exports.media = media;
exports.active = active;
exports.checked = checked;
exports.$$default = $$default;
exports["default"] = $$default;
exports.__esModule = true;
exports.defined = defined;
exports.disabled = disabled;
exports.empty = empty;
exports.enabled = enabled;
exports.first = first;
exports.firstChild = firstChild;
exports.firstOfType = firstOfType;
exports.focus = focus;
exports.focusVisible = focusVisible;
exports.focusWithin = focusWithin;
exports.host = host;
exports.hover = hover;
exports.indeterminate = indeterminate;
exports.inRange = inRange;
exports.invalid = invalid;
exports.lang = lang;
exports.lastChild = lastChild;
exports.lastOfType = lastOfType;
exports.link = link;
exports.not__ = not__;
exports.Nth = Nth;
exports.nthChild = nthChild;
exports.nthLastChild = nthLastChild;
exports.nthLastOfType = nthLastOfType;
exports.nthOfType = nthOfType;
exports.onlyChild = onlyChild;
exports.onlyOfType = onlyOfType;
exports.optional = optional;
exports.outOfRange = outOfRange;
exports.readOnly = readOnly;
exports.readWrite = readWrite;
exports.required = required;
exports.root = root;
exports.scope = scope;
exports.target = target;
exports.valid = valid;
exports.visited = visited;
exports.after = after;
exports.before = before;
exports.firstLetter = firstLetter;
exports.firstLine = firstLine;
exports.placeholder = placeholder;
exports.selection = selection;
exports.child = child;
exports.children = children;
exports.directSibling = directSibling;
exports.siblings = siblings;
exports.anyLink = anyLink;
exports.initial = initial;
exports.inherit_ = inherit_;
exports.unset = unset;
exports.$$var = $$var;
exports.varDefault = varDefault;
exports.auto = auto;
exports.none = none;
exports.text = text;
exports.pct = pct;
exports.ch = ch;
exports.cm = cm;
exports.em = em;
exports.ex = ex;
exports.mm = mm;
exports.pt = pt;
exports.px = px;
exports.pxFloat = pxFloat;
exports.rem = rem;
exports.vh = vh;
exports.vmin = vmin;
exports.vmax = vmax;
exports.zero = zero;
exports.deg = deg;
exports.rad = rad;
exports.grad = grad;
exports.turn = turn;
exports.ltr = ltr;
exports.rtl = rtl;
exports.absolute = absolute;
exports.relative = relative;
exports.$$static = $$static;
exports.fixed = fixed;
exports.sticky = sticky;
exports.isolate = isolate;
exports.horizontal = horizontal;
exports.vertical = vertical;
exports.smallCaps = smallCaps;
exports.italic = italic;
exports.oblique = oblique;
exports.hidden = hidden;
exports.visible = visible;
exports.scroll = scroll;
exports.rgb = rgb;
exports.rgba = rgba;
exports.hsl = hsl;
exports.hsla = hsla;
exports.hex = hex;
exports.currentColor = currentColor;
exports.local = local;
exports.paddingBox = paddingBox;
exports.borderBox = borderBox;
exports.contentBox = contentBox;
exports.noRepeat = noRepeat;
exports.space = space;
exports.repeat = repeat;
exports.minmax = minmax;
exports.repeatX = repeatX;
exports.repeatY = repeatY;
exports.contain = contain;
exports.cover = cover;
exports.row = row;
exports.rowReverse = rowReverse;
exports.column = column;
exports.columnReverse = columnReverse;
exports.wrap = wrap;
exports.nowrap = nowrap;
exports.wrapReverse = wrapReverse;
exports.inline = inline;
exports.block = block;
exports.contents = contents;
exports.flexBox = flexBox;
exports.grid = grid;
exports.inlineBlock = inlineBlock;
exports.inlineFlex = inlineFlex;
exports.inlineGrid = inlineGrid;
exports.inlineTable = inlineTable;
exports.listItem = listItem;
exports.runIn = runIn;
exports.table = table;
exports.tableCaption = tableCaption;
exports.tableColumnGroup = tableColumnGroup;
exports.tableHeaderGroup = tableHeaderGroup;
exports.tableFooterGroup = tableFooterGroup;
exports.tableRowGroup = tableRowGroup;
exports.tableCell = tableCell;
exports.tableColumn = tableColumn;
exports.tableRow = tableRow;
exports.flexStart = flexStart;
exports.flexEnd = flexEnd;
exports.center = center;
exports.stretch = stretch;
exports.spaceBetween = spaceBetween;
exports.spaceAround = spaceAround;
exports.spaceEvenly = spaceEvenly;
exports.baseline = baseline;
exports.forwards = forwards;
exports.backwards = backwards;
exports.both = both;
exports.infinite = infinite;
exports.count = count;
exports.paused = paused;
exports.running = running;
exports.inside = inside;
exports.outside = outside;
exports.solid = solid;
exports.dotted = dotted;
exports.dashed = dashed;
exports.underline = underline;
exports.overline = overline;
exports.lineThrough = lineThrough;
exports.clip = clip;
exports.ellipsis = ellipsis;
exports.wavy = wavy;
exports.$$double = $$double;
exports.uppercase = uppercase;
exports.lowercase = lowercase;
exports.capitalize = capitalize;
exports.sub = sub;
exports.$$super = $$super;
exports.textTop = textTop;
exports.textBottom = textBottom;
exports.middle = middle;
exports.normal = normal;
exports.breakAll = breakAll;
exports.keepAll = keepAll;
exports.breakWord = breakWord;
exports.reverse = reverse;
exports.alternate = alternate;
exports.alternateReverse = alternateReverse;
exports.fill = fill;
exports.content = content;
exports.maxContent = maxContent;
exports.minContent = minContent;
exports.fitContent = fitContent;
exports.all = all;
exports.round = round;
exports.miter = miter;
exports.bevel = bevel;
exports.butt = butt;
exports.square = square;
exports.panX = panX;
exports.panY = panY;
exports.panLeft = panLeft;
exports.panRight = panRight;
exports.panUp = panUp;
exports.panDown = panDown;
exports.pinchZoom = pinchZoom;
exports.manipulation = manipulation;
exports.thin = thin;
exports.extraLight = extraLight;
exports.light = light;
exports.medium = medium;
exports.semiBold = semiBold;
exports.bold = bold;
exports.extraBold = extraBold;
exports.lighter = lighter;
exports.bolder = bolder;
exports.fr = fr;
exports.vw = vw;
exports.localUrl = localUrl;
exports.url = url;
exports.linear = linear;
exports.ease = ease;
exports.easeIn = easeIn;
exports.easeOut = easeOut;
exports.easeInOut = easeInOut;
exports.stepStart = stepStart;
exports.stepEnd = stepEnd;
exports.steps = steps;
exports.cubicBezier = cubicBezier;
exports.marginBox = marginBox;
exports.fillBox = fillBox;
exports.strokeBox = strokeBox;
exports.viewBox = viewBox;
exports.translate = translate;
exports.translate3d = translate3d;
exports.translateX = translateX;
exports.translateY = translateY;
exports.translateZ = translateZ;
exports.scale = scale;
exports.scale3d = scale3d;
exports.scaleX = scaleX;
exports.scaleY = scaleY;
exports.scaleZ = scaleZ;
exports.rotate = rotate;
exports.rotate3d = rotate3d;
exports.rotateX = rotateX;
exports.rotateY = rotateY;
exports.rotateZ = rotateZ;
exports.skew = skew;
exports.skewX = skewX;
exports.skewY = skewY;
exports.linearGradient = linearGradient;
exports.repeatingLinearGradient = repeatingLinearGradient;
exports.radialGradient = radialGradient;
exports.repeatingRadialGradient = repeatingRadialGradient;
exports.conicGradient = conicGradient;
exports.areas = areas;
exports.ident = ident;
exports.numIdent = numIdent;
exports.contextMenu = contextMenu;
exports.help = help;
exports.pointer = pointer;
exports.progress = progress;
exports.wait = wait;
exports.cell = cell;
exports.crosshair = crosshair;
exports.verticalText = verticalText;
exports.alias = alias;
exports.copy = copy;
exports.move = move;
exports.noDrop = noDrop;
exports.notAllowed = notAllowed;
exports.grab = grab;
exports.grabbing = grabbing;
exports.allScroll = allScroll;
exports.colResize = colResize;
exports.rowResize = rowResize;
exports.nResize = nResize;
exports.eResize = eResize;
exports.sResize = sResize;
exports.wResize = wResize;
exports.neResize = neResize;
exports.nwResize = nwResize;
exports.seResize = seResize;
exports.swResize = swResize;
exports.ewResize = ewResize;
exports.nsResize = nsResize;
exports.neswResize = neswResize;
exports.nwseResize = nwseResize;
exports.zoomIn = zoomIn;
exports.zoomOut = zoomOut;
exports.flex3 = flex3;
exports.border = border;
exports.borderTop = borderTop;
exports.backgroundSize = backgroundSize;
exports.textDecoration = textDecoration;
exports.background = background;
exports.backgrounds = backgrounds;
exports.gridAutoColumns = gridAutoColumns;
exports.gridAutoRows = gridAutoRows;
exports.gridTemplateColumns = gridTemplateColumns;
exports.gridTemplateRows = gridTemplateRows;
exports.Calc = Calc;
exports.size = size;
exports.filter = filter;
exports.Transition = Transition;
exports.transitionValue = transitionValue;
exports.transitionList = transitionList;
exports.transition = transition;
exports.transitions = transitions;
exports.Animation = Animation;
exports.animationValue = animationValue;
exports.animation = animation;
exports.animations = animations;
exports.animationName = animationName;
exports.SVG = SVG;
exports.touchAction = touchAction;
exports.aliceblue = aliceblue;
exports.antiquewhite = antiquewhite;
exports.aqua = aqua;
exports.aquamarine = aquamarine;
exports.azure = azure;
exports.beige = beige;
exports.bisque = bisque;
exports.black = black;
exports.blanchedalmond = blanchedalmond;
exports.blue = blue;
exports.blueviolet = blueviolet;
exports.brown = brown;
exports.burlywood = burlywood;
exports.cadetblue = cadetblue;
exports.chartreuse = chartreuse;
exports.chocolate = chocolate;
exports.coral = coral;
exports.cornflowerblue = cornflowerblue;
exports.cornsilk = cornsilk;
exports.crimson = crimson;
exports.cyan = cyan;
exports.darkblue = darkblue;
exports.darkcyan = darkcyan;
exports.darkgoldenrod = darkgoldenrod;
exports.darkgray = darkgray;
exports.darkgreen = darkgreen;
exports.darkgrey = darkgrey;
exports.darkkhaki = darkkhaki;
exports.darkmagenta = darkmagenta;
exports.darkolivegreen = darkolivegreen;
exports.darkorange = darkorange;
exports.darkorchid = darkorchid;
exports.darkred = darkred;
exports.darksalmon = darksalmon;
exports.darkseagreen = darkseagreen;
exports.darkslateblue = darkslateblue;
exports.darkslategray = darkslategray;
exports.darkslategrey = darkslategrey;
exports.darkturquoise = darkturquoise;
exports.darkviolet = darkviolet;
exports.deeppink = deeppink;
exports.deepskyblue = deepskyblue;
exports.dimgray = dimgray;
exports.dimgrey = dimgrey;
exports.dodgerblue = dodgerblue;
exports.firebrick = firebrick;
exports.floralwhite = floralwhite;
exports.forestgreen = forestgreen;
exports.fuchsia = fuchsia;
exports.gainsboro = gainsboro;
exports.ghostwhite = ghostwhite;
exports.gold = gold;
exports.goldenrod = goldenrod;
exports.gray = gray;
exports.green = green;
exports.greenyellow = greenyellow;
exports.grey = grey;
exports.honeydew = honeydew;
exports.hotpink = hotpink;
exports.indianred = indianred;
exports.indigo = indigo;
exports.ivory = ivory;
exports.khaki = khaki;
exports.lavender = lavender;
exports.lavenderblush = lavenderblush;
exports.lawngreen = lawngreen;
exports.lemonchiffon = lemonchiffon;
exports.lightblue = lightblue;
exports.lightcoral = lightcoral;
exports.lightcyan = lightcyan;
exports.lightgoldenrodyellow = lightgoldenrodyellow;
exports.lightgray = lightgray;
exports.lightgreen = lightgreen;
exports.lightgrey = lightgrey;
exports.lightpink = lightpink;
exports.lightsalmon = lightsalmon;
exports.lightseagreen = lightseagreen;
exports.lightskyblue = lightskyblue;
exports.lightslategray = lightslategray;
exports.lightslategrey = lightslategrey;
exports.lightsteelblue = lightsteelblue;
exports.lightyellow = lightyellow;
exports.lime = lime;
exports.limegreen = limegreen;
exports.linen = linen;
exports.magenta = magenta;
exports.maroon = maroon;
exports.mediumaquamarine = mediumaquamarine;
exports.mediumblue = mediumblue;
exports.mediumorchid = mediumorchid;
exports.mediumpurple = mediumpurple;
exports.mediumseagreen = mediumseagreen;
exports.mediumslateblue = mediumslateblue;
exports.mediumspringgreen = mediumspringgreen;
exports.mediumturquoise = mediumturquoise;
exports.mediumvioletred = mediumvioletred;
exports.midnightblue = midnightblue;
exports.mintcream = mintcream;
exports.mistyrose = mistyrose;
exports.moccasin = moccasin;
exports.navajowhite = navajowhite;
exports.navy = navy;
exports.oldlace = oldlace;
exports.olive = olive;
exports.olivedrab = olivedrab;
exports.orange = orange;
exports.orangered = orangered;
exports.orchid = orchid;
exports.palegoldenrod = palegoldenrod;
exports.palegreen = palegreen;
exports.paleturquoise = paleturquoise;
exports.palevioletred = palevioletred;
exports.papayawhip = papayawhip;
exports.peachpuff = peachpuff;
exports.peru = peru;
exports.pink = pink;
exports.plum = plum;
exports.powderblue = powderblue;
exports.purple = purple;
exports.rebeccapurple = rebeccapurple;
exports.red = red;
exports.rosybrown = rosybrown;
exports.royalblue = royalblue;
exports.saddlebrown = saddlebrown;
exports.salmon = salmon;
exports.sandybrown = sandybrown;
exports.seagreen = seagreen;
exports.seashell = seashell;
exports.sienna = sienna;
exports.silver = silver;
exports.skyblue = skyblue;
exports.slateblue = slateblue;
exports.slategray = slategray;
exports.slategrey = slategrey;
exports.snow = snow;
exports.springgreen = springgreen;
exports.steelblue = steelblue;
exports.tan = tan;
exports.teal = teal;
exports.thistle = thistle;
exports.tomato = tomato;
exports.turquoise = turquoise;
exports.violet = violet;
exports.wheat = wheat;
exports.white = white;
exports.whitesmoke = whitesmoke;
exports.yellow = yellow;
exports.yellowgreen = yellowgreen;
exports.transparent = transparent;
exports.insertRule = insertRule;
exports.renderRule = renderRule;
exports.$$global = $$global;
exports.renderGlobal = renderGlobal;
exports.style = style;
exports.merge = merge;
exports.merge2 = merge2;
exports.merge3 = merge3;
exports.merge4 = merge4;
exports.keyframes = keyframes;
exports.renderKeyframes = renderKeyframes$1;
exports.fontFace = fontFace;
/* include Not a pure module */


/***/ }),

/***/ 82974:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE


var List = __webpack_require__(68724);
var $$String = __webpack_require__(65760);
var Belt_Array = __webpack_require__(2971);

function toString(param) {
  if (param === "inherit_") {
    return "inherit";
  } else if (param === "unset") {
    return "unset";
  } else {
    return "initial";
  }
}

var Cascading = {
  initial: "initial",
  inherit_: "inherit_",
  unset: "unset",
  toString: toString
};

function $$var(x) {
  return {
          NAME: "var",
          VAL: x
        };
}

function varDefault(x, $$default) {
  return {
          NAME: "varDefault",
          VAL: [
            x,
            $$default
          ]
        };
}

function prefix(x) {
  if (x.startsWith("--")) {
    return x;
  } else {
    return "--" + x;
  }
}

function toString$1(param) {
  if (param.NAME === "var") {
    return "var(" + (prefix(param.VAL) + ")");
  }
  var match = param.VAL;
  return "var(" + (prefix(match[0]) + ("," + (match[1] + ")")));
}

function s(x) {
  return {
          NAME: "s",
          VAL: x
        };
}

function ms(x) {
  return {
          NAME: "ms",
          VAL: x
        };
}

function toString$2(param) {
  if (param.NAME === "ms") {
    return param.VAL.toString() + "ms";
  } else {
    return param.VAL.toString() + "s";
  }
}

var Time = {
  s: s,
  ms: ms,
  toString: toString$2
};

function pct(x) {
  return {
          NAME: "percent",
          VAL: x
        };
}

function toString$3(param) {
  return param.VAL.toString() + "%";
}

var Percentage = {
  pct: pct,
  toString: toString$3
};

function toString$4(param) {
  return "url(" + (param.VAL + ")");
}

var Url = {
  toString: toString$4
};

function ch(x) {
  return {
          NAME: "ch",
          VAL: x
        };
}

function em(x) {
  return {
          NAME: "em",
          VAL: x
        };
}

function ex(x) {
  return {
          NAME: "ex",
          VAL: x
        };
}

function rem(x) {
  return {
          NAME: "rem",
          VAL: x
        };
}

function vh(x) {
  return {
          NAME: "vh",
          VAL: x
        };
}

function vw(x) {
  return {
          NAME: "vw",
          VAL: x
        };
}

function vmin(x) {
  return {
          NAME: "vmin",
          VAL: x
        };
}

function vmax(x) {
  return {
          NAME: "vmax",
          VAL: x
        };
}

function px(x) {
  return {
          NAME: "px",
          VAL: x
        };
}

function pxFloat(x) {
  return {
          NAME: "pxFloat",
          VAL: x
        };
}

function cm(x) {
  return {
          NAME: "cm",
          VAL: x
        };
}

function mm(x) {
  return {
          NAME: "mm",
          VAL: x
        };
}

function inch(x) {
  return {
          NAME: "inch",
          VAL: x
        };
}

function pc(x) {
  return {
          NAME: "pc",
          VAL: x
        };
}

function pt(x) {
  return {
          NAME: "pt",
          VAL: x
        };
}

function toString$5(param) {
  if (typeof param !== "object") {
    return "0";
  }
  var variant = param.NAME;
  if (variant === "pxFloat") {
    return param.VAL.toString() + "px";
  }
  if (variant === "inch") {
    return param.VAL.toString() + "in";
  }
  if (variant === "vmax") {
    return param.VAL.toString() + "vmax";
  }
  if (variant === "vmin") {
    return param.VAL.toString() + "vmin";
  }
  if (variant === "percent") {
    return param.VAL.toString() + "%";
  }
  if (variant === "ch") {
    return param.VAL.toString() + "ch";
  }
  if (variant === "cm") {
    return param.VAL.toString() + "cm";
  }
  if (variant === "em") {
    return param.VAL.toString() + "em";
  }
  if (variant === "ex") {
    return param.VAL.toString() + "ex";
  }
  if (variant === "mm") {
    return param.VAL.toString() + "mm";
  }
  if (variant === "pc") {
    return param.VAL.toString() + "pc";
  }
  if (variant === "pt") {
    return param.VAL.toString() + "pt";
  }
  if (variant === "px") {
    return param.VAL.toString() + "px";
  }
  if (variant === "vh") {
    return param.VAL.toString() + "vh";
  }
  if (variant === "vw") {
    return param.VAL.toString() + "vw";
  }
  if (variant === "rem") {
    return param.VAL.toString() + "rem";
  }
  var match = param.VAL;
  if (match[0] === "sub") {
    return "calc(" + (toString$5(match[1]) + (" - " + (toString$5(match[2]) + ")")));
  } else {
    return "calc(" + (toString$5(match[1]) + (" + " + (toString$5(match[2]) + ")")));
  }
}

var Length = {
  ch: ch,
  em: em,
  ex: ex,
  rem: rem,
  vh: vh,
  vw: vw,
  vmin: vmin,
  vmax: vmax,
  px: px,
  pxFloat: pxFloat,
  cm: cm,
  mm: mm,
  inch: inch,
  pc: pc,
  pt: pt,
  zero: "zero",
  toString: toString$5
};

function deg(x) {
  return {
          NAME: "deg",
          VAL: x
        };
}

function rad(x) {
  return {
          NAME: "rad",
          VAL: x
        };
}

function grad(x) {
  return {
          NAME: "grad",
          VAL: x
        };
}

function turn(x) {
  return {
          NAME: "turn",
          VAL: x
        };
}

function toString$6(param) {
  var variant = param.NAME;
  if (variant === "turn") {
    return param.VAL.toString() + "turn";
  } else if (variant === "deg") {
    return param.VAL.toString() + "deg";
  } else if (variant === "rad") {
    return param.VAL.toString() + "rad";
  } else {
    return param.VAL.toString() + "grad";
  }
}

var Angle = {
  deg: deg,
  rad: rad,
  grad: grad,
  turn: turn,
  toString: toString$6
};

function toString$7(param) {
  if (param === "rtl") {
    return "rtl";
  } else {
    return "ltr";
  }
}

var Direction = {
  ltr: "ltr",
  rtl: "rtl",
  toString: toString$7
};

function toString$8(param) {
  if (param === "fixed") {
    return "fixed";
  } else if (param === "static") {
    return "static";
  } else if (param === "sticky") {
    return "sticky";
  } else if (param === "relative") {
    return "relative";
  } else {
    return "absolute";
  }
}

var Position = {
  absolute: "absolute",
  relative: "relative",
  $$static: "static",
  fixed: "fixed",
  sticky: "sticky",
  toString: toString$8
};

function toString$9(param) {
  if (param === "isolate") {
    return "isolate";
  } else {
    return "auto";
  }
}

var Isolation = {
  toString: toString$9
};

function toString$10(param) {
  if (param === "none") {
    return "none";
  } else if (param === "vertical") {
    return "vertical";
  } else if (param === "horizontal") {
    return "horizontal";
  } else if (param === "inline") {
    return "inline";
  } else if (param === "block") {
    return "block";
  } else {
    return "both";
  }
}

var Resize = {
  none: "none",
  both: "both",
  horizontal: "horizontal",
  vertical: "vertical",
  block: "block",
  inline: "inline",
  toString: toString$10
};

function toString$11(param) {
  if (param === "normal") {
    return "normal";
  } else {
    return "smallCaps";
  }
}

var FontVariant = {
  normal: "normal",
  smallCaps: "smallCaps",
  toString: toString$11
};

function toString$12(param) {
  if (param === "oblique") {
    return "oblique";
  } else if (param === "normal") {
    return "normal";
  } else {
    return "italic";
  }
}

var FontStyle = {
  normal: "normal",
  italic: "italic",
  oblique: "oblique",
  toString: toString$12
};

function toString$13(param) {
  if (param === "fill") {
    return "fill";
  } else if (param === "minContent") {
    return "min-content";
  } else if (param === "fitContent") {
    return "fit-content";
  } else if (param === "maxContent") {
    return "max-content";
  } else if (param === "content") {
    return "content";
  } else {
    return "auto";
  }
}

var FlexBasis = {
  fill: "fill",
  content: "content",
  maxContent: "maxContent",
  minContent: "minContent",
  fitContent: "fitContent",
  toString: toString$13
};

function toString$14(param) {
  if (param === "scroll") {
    return "scroll";
  } else if (param === "hidden") {
    return "hidden";
  } else if (param === "visible") {
    return "visible";
  } else {
    return "auto";
  }
}

var Overflow = {
  hidden: "hidden",
  visible: "visible",
  scroll: "scroll",
  auto: "auto",
  toString: toString$14
};

function toString$15(param) {
  return "auto";
}

var Margin = {
  auto: "auto",
  toString: toString$15
};

function toString$16(param) {
  if (param === "columnDense") {
    return "column dense";
  } else if (param === "rowDense") {
    return "row dense";
  } else if (param === "row") {
    return "row";
  } else {
    return "column";
  }
}

var GridAutoFlow = {
  toString: toString$16
};

function toString$17(param) {
  return "normal";
}

var Gap = {
  toString: toString$17
};

function toString$18(param) {
  if (param === "smooth") {
    return "smooth";
  } else {
    return "auto";
  }
}

var ScrollBehavior = {
  toString: toString$18
};

function toString$19(param) {
  if (param === "none") {
    return "none";
  } else if (param === "contain") {
    return "contain";
  } else {
    return "auto";
  }
}

var OverscrollBehavior = {
  toString: toString$19
};

function toString$20(param) {
  if (param === "none") {
    return "none";
  } else {
    return "auto";
  }
}

var OverflowAnchor = {
  toString: toString$20
};

function toString$21(param) {
  return "auto";
}

var ColumnWidth = {
  toString: toString$21
};

function toString$22(param) {
  return "auto";
}

var CaretColor = {
  toString: toString$22
};

function toString$23(param) {
  if (param === "bottom") {
    return "bottom";
  } else if (param === "sub") {
    return "sub";
  } else if (param === "top") {
    return "top";
  } else if (param === "super") {
    return "super";
  } else if (param === "baseline") {
    return "baseline";
  } else if (param === "textBottom") {
    return "text-bottom";
  } else if (param === "textTop") {
    return "text-top";
  } else {
    return "middle";
  }
}

var VerticalAlign = {
  toString: toString$23
};

function steps(i, dir) {
  return {
          NAME: "steps",
          VAL: [
            i,
            dir
          ]
        };
}

function cubicBezier(a, b, c, d) {
  return {
          NAME: "cubicBezier",
          VAL: [
            a,
            b,
            c,
            d
          ]
        };
}

function toString$24(param) {
  if (typeof param !== "object") {
    if (param === "easeInOut") {
      return "ease-in-out";
    } else if (param === "linear") {
      return "linear";
    } else if (param === "stepStart") {
      return "step-start";
    } else if (param === "stepEnd") {
      return "step-end";
    } else if (param === "easeIn") {
      return "ease-in";
    } else if (param === "easeOut") {
      return "ease-out";
    } else {
      return "ease";
    }
  }
  if (param.NAME === "steps") {
    var match = param.VAL;
    var i = match[0];
    if (match[1] === "start") {
      return "steps(" + (i.toString() + ", start)");
    } else {
      return "steps(" + (i.toString() + ", end)");
    }
  }
  var match$1 = param.VAL;
  return "cubic-bezier(" + (match$1[0].toString() + (", " + (match$1[1].toString() + (", " + (match$1[2].toString() + (", " + (match$1[3].toString() + ")")))))));
}

function toString$25(param) {
  if (typeof param === "object") {
    return param.VAL.toString();
  } else if (param === "autoFill") {
    return "auto-fill";
  } else {
    return "auto-fit";
  }
}

var RepeatValue = {
  toString: toString$25
};

function toString$26(param) {
  if (param === "none") {
    return "none";
  } else if (param === "circle") {
    return "circle";
  } else if (param === "lowerGreek") {
    return "lower-greek";
  } else if (param === "square") {
    return "square";
  } else if (param === "lowerAlpha") {
    return "lower-alpha";
  } else if (param === "upperAlpha") {
    return "upper-alpha";
  } else if (param === "decimal") {
    return "decimal";
  } else if (param === "lowerRoman") {
    return "lower-roman";
  } else if (param === "lowerLatin") {
    return "lower-latin";
  } else if (param === "upperRoman") {
    return "upper-roman";
  } else if (param === "upperLatin") {
    return "upper-latin";
  } else {
    return "disc";
  }
}

var ListStyleType = {
  toString: toString$26
};

function toString$27(param) {
  if (param === "inside") {
    return "inside";
  } else {
    return "outside";
  }
}

var ListStylePosition = {
  toString: toString$27
};

function toString$28(param) {
  if (param === "hidden") {
    return "hidden";
  } else if (param === "ridge") {
    return "ridge";
  } else if (param === "solid") {
    return "solid";
  } else if (param === "outset") {
    return "outset";
  } else if (param === "groove") {
    return "grove";
  } else if (param === "dashed") {
    return "dashed";
  } else if (param === "dotted") {
    return "dotted";
  } else if (param === "double") {
    return "double";
  } else if (param === "inset") {
    return "inset";
  } else {
    return "none";
  }
}

var OutlineStyle = {
  toString: toString$28
};

function toString$29(x) {
  if (typeof x === "object") {
    return x.VAL.toString();
  } else if (x === "thin") {
    return "100";
  } else if (x === "semiBold") {
    return "600";
  } else if (x === "bolder") {
    return "bolder";
  } else if (x === "light") {
    return "300";
  } else if (x === "extraBold") {
    return "800";
  } else if (x === "extraLight") {
    return "200";
  } else if (x === "medium") {
    return "500";
  } else if (x === "lighter") {
    return "lighter";
  } else if (x === "normal") {
    return "400";
  } else if (x === "black") {
    return "900";
  } else {
    return "700";
  }
}

var FontWeight = {
  thin: "thin",
  extraLight: "extraLight",
  light: "light",
  medium: "medium",
  semiBold: "semiBold",
  bold: "bold",
  extraBold: "extraBold",
  lighter: "lighter",
  bolder: "bolder",
  toString: toString$29
};

function translate(x, y) {
  return {
          NAME: "translate",
          VAL: [
            x,
            y
          ]
        };
}

function translate3d(x, y, z) {
  return {
          NAME: "translate3d",
          VAL: [
            x,
            y,
            z
          ]
        };
}

function translateX(x) {
  return {
          NAME: "translateX",
          VAL: x
        };
}

function translateY(y) {
  return {
          NAME: "translateY",
          VAL: y
        };
}

function translateZ(z) {
  return {
          NAME: "translateZ",
          VAL: z
        };
}

function scale(x, y) {
  return {
          NAME: "scale",
          VAL: [
            x,
            y
          ]
        };
}

function scale3d(x, y, z) {
  return {
          NAME: "scale3d",
          VAL: [
            x,
            y,
            z
          ]
        };
}

function scaleX(x) {
  return {
          NAME: "scaleX",
          VAL: x
        };
}

function scaleY(x) {
  return {
          NAME: "scaleY",
          VAL: x
        };
}

function scaleZ(x) {
  return {
          NAME: "scaleZ",
          VAL: x
        };
}

function rotate(a) {
  return {
          NAME: "rotate",
          VAL: a
        };
}

function rotate3d(x, y, z, a) {
  return {
          NAME: "rotate3d",
          VAL: [
            x,
            y,
            z,
            a
          ]
        };
}

function rotateX(a) {
  return {
          NAME: "rotateX",
          VAL: a
        };
}

function rotateY(a) {
  return {
          NAME: "rotateY",
          VAL: a
        };
}

function rotateZ(a) {
  return {
          NAME: "rotateZ",
          VAL: a
        };
}

function skew(a, a$p) {
  return {
          NAME: "skew",
          VAL: [
            a,
            a$p
          ]
        };
}

function skewX(a) {
  return {
          NAME: "skewX",
          VAL: a
        };
}

function skewY(a) {
  return {
          NAME: "skewY",
          VAL: a
        };
}

function toString$30(param) {
  var variant = param.NAME;
  if (variant === "translate") {
    var match = param.VAL;
    return "translate(" + (toString$5(match[0]) + (", " + (toString$5(match[1]) + ")")));
  }
  if (variant === "rotate") {
    return "rotate(" + (toString$6(param.VAL) + ")");
  }
  if (variant === "skew") {
    var match$1 = param.VAL;
    return "skew(" + (toString$6(match$1[0]) + (", " + (toString$6(match$1[1]) + ")")));
  }
  if (variant === "scale3d") {
    var match$2 = param.VAL;
    return "scale3d(" + (match$2[0].toString() + (", " + (match$2[1].toString() + (", " + (match$2[2].toString() + ")")))));
  }
  if (variant === "rotateX") {
    return "rotateX(" + (toString$6(param.VAL) + ")");
  }
  if (variant === "rotateY") {
    return "rotateY(" + (toString$6(param.VAL) + ")");
  }
  if (variant === "rotateZ") {
    return "rotateZ(" + (toString$6(param.VAL) + ")");
  }
  if (variant === "scale") {
    var match$3 = param.VAL;
    var x = match$3[0];
    var y = match$3[1];
    return "scale(" + (x.toString() + (", " + (y.toString() + ")")));
  }
  if (variant === "skewX") {
    return "skewX(" + (toString$6(param.VAL) + ")");
  }
  if (variant === "skewY") {
    return "skewY(" + (toString$6(param.VAL) + ")");
  }
  if (variant === "translateX") {
    return "translateX(" + (toString$5(param.VAL) + ")");
  }
  if (variant === "translateY") {
    return "translateY(" + (toString$5(param.VAL) + ")");
  }
  if (variant === "translateZ") {
    return "translateZ(" + (toString$5(param.VAL) + ")");
  }
  if (variant === "rotate3d") {
    var match$4 = param.VAL;
    return "rotate3d(" + (match$4[0].toString() + (", " + (match$4[1].toString() + (", " + (match$4[2].toString() + (", " + (toString$6(match$4[3]) + ")")))))));
  }
  if (variant !== "translate3d") {
    if (variant === "scaleX") {
      return "scaleX(" + (param.VAL.toString() + ")");
    } else if (variant === "scaleY") {
      return "scaleY(" + (param.VAL.toString() + ")");
    } else if (variant === "scaleZ") {
      return "scaleZ(" + (param.VAL.toString() + ")");
    } else {
      return "perspective(" + (param.VAL.toString() + ")");
    }
  }
  var match$5 = param.VAL;
  var x$1 = match$5[0];
  var y$1 = match$5[1];
  var z = match$5[2];
  return "translate3d(" + (toString$5(x$1) + (", " + (toString$5(y$1) + (", " + (toString$5(z) + ")")))));
}

function toString$31(param) {
  if (param === "alternateReverse") {
    return "alternate-reverse";
  } else if (param === "normal") {
    return "normal";
  } else if (param === "alternate") {
    return "alternate";
  } else {
    return "reverse";
  }
}

var AnimationDirection = {
  toString: toString$31
};

function toString$32(param) {
  if (param === "none") {
    return "none";
  } else if (param === "backwards") {
    return "backwards";
  } else if (param === "forwards") {
    return "forwards";
  } else {
    return "both";
  }
}

var AnimationFillMode = {
  toString: toString$32
};

function toString$33(param) {
  if (typeof param === "object") {
    return param.VAL.toString();
  } else {
    return "infinite";
  }
}

var AnimationIterationCount = {
  toString: toString$33
};

function toString$34(param) {
  if (param === "paused") {
    return "paused";
  } else {
    return "running";
  }
}

var AnimationPlayState = {
  toString: toString$34
};

function toString$35(x) {
  if (x === "cell") {
    return "cell";
  } else if (x === "copy") {
    return "copy";
  } else if (x === "swResize") {
    return "sw-resize";
  } else if (x === "grab") {
    return "grab";
  } else if (x === "help") {
    return "help";
  } else if (x === "move") {
    return "move";
  } else if (x === "none") {
    return "none";
  } else if (x === "text") {
    return "text";
  } else if (x === "rowResize") {
    return "row-resize";
  } else if (x === "wait") {
    return "wait";
  } else if (x === "pointer") {
    return "pointer";
  } else if (x === "seResize") {
    return "se-resize";
  } else if (x === "zoomOut") {
    return "zoom-out";
  } else if (x === "sResize") {
    return "s-resize";
  } else if (x === "zoomIn") {
    return "zoom-in";
  } else if (x === "grabbing") {
    return "grabbing";
  } else if (x === "nsResize") {
    return "ns-resize";
  } else if (x === "nwseResize") {
    return "nwse-resize";
  } else if (x === "progress") {
    return "progress";
  } else if (x === "crosshair") {
    return "crosshair";
  } else if (x === "wResize") {
    return "w-resize";
  } else if (x === "noDrop") {
    return "no-drop";
  } else if (x === "allScroll") {
    return "all-scroll";
  } else if (x === "verticalText") {
    return "vertical-text";
  } else if (x === "nResize") {
    return "n-resize";
  } else if (x === "default") {
    return "default";
  } else if (x === "neswResize") {
    return "nesw-resize";
  } else if (x === "alias") {
    return "alias";
  } else if (x === "ewResize") {
    return "ew-resize";
  } else if (x === "eResize") {
    return "e-resize";
  } else if (x === "nwResize") {
    return "nw-resize";
  } else if (x === "contextMenu") {
    return "context-menu";
  } else if (x === "colResize") {
    return "col-resize";
  } else if (x === "notAllowed") {
    return "not-allowed";
  } else if (x === "neResize") {
    return "ne-resize";
  } else {
    return "auto";
  }
}

var Cursor = {
  auto: "auto",
  $$default: "default",
  none: "none",
  contextMenu: "contextMenu",
  help: "help",
  pointer: "pointer",
  progress: "progress",
  wait: "wait",
  cell: "cell",
  crosshair: "crosshair",
  text: "text",
  verticalText: "verticalText",
  alias: "alias",
  copy: "copy",
  move: "move",
  noDrop: "noDrop",
  notAllowed: "notAllowed",
  grab: "grab",
  grabbing: "grabbing",
  allScroll: "allScroll",
  colResize: "colResize",
  rowResize: "rowResize",
  nResize: "nResize",
  eResize: "eResize",
  sResize: "sResize",
  wResize: "wResize",
  neResize: "neResize",
  nwResize: "nwResize",
  seResize: "seResize",
  swResize: "swResize",
  ewResize: "ewResize",
  nsResize: "nsResize",
  neswResize: "neswResize",
  nwseResize: "nwseResize",
  zoomIn: "zoomIn",
  zoomOut: "zoomOut",
  toString: toString$35
};

function rgb(r, g, b) {
  return {
          NAME: "rgb",
          VAL: [
            r,
            g,
            b
          ]
        };
}

function rgba(r, g, b, a) {
  return {
          NAME: "rgba",
          VAL: [
            r,
            g,
            b,
            a
          ]
        };
}

function hsl(h, s, l) {
  return {
          NAME: "hsl",
          VAL: [
            h,
            s,
            l
          ]
        };
}

function hsla(h, s, l, a) {
  return {
          NAME: "hsla",
          VAL: [
            h,
            s,
            l,
            a
          ]
        };
}

function hex(x) {
  return {
          NAME: "hex",
          VAL: x
        };
}

function string_of_alpha(pc) {
  if (pc.NAME === "num") {
    return pc.VAL.toString();
  } else {
    return toString$3(pc);
  }
}

function toString$36(param) {
  if (typeof param !== "object") {
    if (param === "transparent") {
      return "transparent";
    } else {
      return "currentColor";
    }
  }
  var variant = param.NAME;
  if (variant === "rgba") {
    var match = param.VAL;
    return "rgba(" + (match[0].toString() + (", " + (match[1].toString() + (", " + (match[2].toString() + (", " + (string_of_alpha(match[3]) + ")")))))));
  }
  if (variant === "hex") {
    return "#" + param.VAL;
  }
  if (variant === "hsl") {
    var match$1 = param.VAL;
    return "hsl(" + (toString$6(match$1[0]) + (", " + (toString$3(match$1[1]) + (", " + (toString$3(match$1[2]) + ")")))));
  }
  if (variant === "rgb") {
    var match$2 = param.VAL;
    return "rgb(" + (match$2[0].toString() + (", " + (match$2[1].toString() + (", " + (match$2[2].toString() + ")")))));
  }
  var match$3 = param.VAL;
  return "hsla(" + (toString$6(match$3[0]) + (", " + (toString$3(match$3[1]) + (", " + (toString$3(match$3[2]) + (", " + (string_of_alpha(match$3[3]) + ")")))))));
}

function toString$37(param) {
  if (param === "hidden") {
    return "hidden";
  } else if (param === "ridge") {
    return "ridge";
  } else if (param === "solid") {
    return "solid";
  } else if (param === "outset") {
    return "outset";
  } else if (param === "groove") {
    return "groove";
  } else if (param === "dashed") {
    return "dashed";
  } else if (param === "dotted") {
    return "dotted";
  } else if (param === "double") {
    return "double";
  } else if (param === "inset") {
    return "inset";
  } else {
    return "none";
  }
}

var BorderStyle = {
  toString: toString$37
};

function toString$38(param) {
  if (param === "none") {
    return "none";
  } else {
    return "auto";
  }
}

var PointerEvents = {
  toString: toString$38
};

function toString$39(param) {
  return "none";
}

var Perspective = {
  toString: toString$39
};

function toString$40(param) {
  return "normal";
}

var LetterSpacing = {
  normal: "normal",
  toString: toString$40
};

function toString$41(param) {
  if (typeof param === "object") {
    return param.VAL.toString();
  } else {
    return "normal";
  }
}

var LineHeight = {
  toString: toString$41
};

function toString$42(param) {
  return "normal";
}

var WordSpacing = {
  toString: toString$42
};

function toString$43(param) {
  if (param === "inline") {
    return "inline";
  } else if (param === "block") {
    return "block";
  } else {
    return "run-in";
  }
}

var DisplayOutside = {
  toString: toString$43
};

function toString$44(param) {
  if (param === "grid") {
    return "grid";
  } else if (param === "table") {
    return "table";
  } else {
    return "flex";
  }
}

var DisplayInside = {
  toString: toString$44
};

function toString$45(param) {
  return "list-item";
}

var DisplayListItem = {
  toString: toString$45
};

function toString$46(param) {
  if (param === "tableRow") {
    return "table-row";
  } else if (param === "tableRowGroup") {
    return "table-row-group";
  } else if (param === "tableColumn") {
    return "table-column";
  } else if (param === "tableHeaderGroup") {
    return "table-header-group";
  } else if (param === "tableCell") {
    return "table-cell";
  } else if (param === "tableColumnGroup") {
    return "table-column-group";
  } else if (param === "tableCaption") {
    return "table-caption";
  } else {
    return "table-footer-group";
  }
}

var DisplayInternal = {
  toString: toString$46
};

function toString$47(param) {
  if (param === "contents") {
    return "contents";
  } else {
    return "none";
  }
}

var DisplayBox = {
  toString: toString$47
};

function toString$48(param) {
  if (param === "inlineBlock") {
    return "inline-block";
  } else if (param === "inlineFlex") {
    return "inline-flex";
  } else if (param === "inlineGrid") {
    return "inline-grid";
  } else {
    return "inline-table";
  }
}

var DisplayLegacy = {
  toString: toString$48
};

function toString$49(param) {
  if (param === "stretch") {
    return "stretch";
  } else if (param === "normal") {
    return "normal";
  } else {
    return "auto";
  }
}

var JustifySelf = {
  toString: toString$49
};

function toString$50(param) {
  if (param === "left") {
    return "left";
  } else if (param === "right") {
    return "right";
  } else if (param === "selfEnd") {
    return "self-end";
  } else if (param === "start") {
    return "start";
  } else if (param === "center") {
    return "center";
  } else if (param === "flexStart") {
    return "flex-start";
  } else if (param === "flexEnd") {
    return "flex-end";
  } else if (param === "selfStart") {
    return "self-start";
  } else {
    return "end";
  }
}

var PositionalAlignment = {
  toString: toString$50
};

function toString$51(param) {
  if (param.NAME === "unsafe") {
    return "unsafe " + toString$50(param.VAL);
  } else {
    return "safe " + toString$50(param.VAL);
  }
}

var OverflowAlignment = {
  toString: toString$51
};

function toString$52(param) {
  if (param === "firstBaseline") {
    return "first baseline";
  } else if (param === "baseline") {
    return "baseline";
  } else {
    return "last baseline";
  }
}

var BaselineAlignment = {
  toString: toString$52
};

function toString$53(param) {
  return "normal";
}

var NormalAlignment = {
  toString: toString$53
};

function toString$54(param) {
  if (param === "spaceAround") {
    return "space-around";
  } else if (param === "stretch") {
    return "stretch";
  } else if (param === "spaceBetween") {
    return "space-between";
  } else {
    return "space-evenly";
  }
}

var DistributedAlignment = {
  toString: toString$54
};

function toString$55(param) {
  if (param === "legacyLeft") {
    return "legacy left";
  } else if (param === "legacy") {
    return "legacy";
  } else if (param === "legacyRight") {
    return "legacy right";
  } else {
    return "legacy center";
  }
}

var LegacyAlignment = {
  toString: toString$55
};

function toString$56(param) {
  if (param === "right") {
    return "right";
  } else if (param === "justify") {
    return "justify";
  } else if (param === "start") {
    return "start";
  } else if (param === "center") {
    return "center";
  } else {
    return "left";
  }
}

var TextAlign = {
  toString: toString$56
};

function toString$57(param) {
  if (param === "normal") {
    return "normal";
  } else if (param === "keepAll") {
    return "keep-all";
  } else {
    return "break-all";
  }
}

var WordBreak = {
  toString: toString$57
};

function toString$58(param) {
  if (param === "preLine") {
    return "pre-line";
  } else if (param === "preWrap") {
    return "pre-wrap";
  } else if (param === "breakSpaces") {
    return "break-spaces";
  } else if (param === "normal") {
    return "normal";
  } else if (param === "nowrap") {
    return "nowrap";
  } else {
    return "pre";
  }
}

var WhiteSpace = {
  toString: toString$58
};

function toString$59(param) {
  if (param === "normal") {
    return "normal";
  } else {
    return "stretch";
  }
}

var AlignItems = {
  toString: toString$59
};

function toString$60(param) {
  if (param === "stretch") {
    return "stretch";
  } else if (param === "normal") {
    return "normal";
  } else {
    return "auto";
  }
}

var AlignSelf = {
  toString: toString$60
};

function toString$61(param) {
  if (param === "start") {
    return "start";
  } else if (param === "center") {
    return "center";
  } else if (param === "flexStart") {
    return "flex-start";
  } else if (param === "flexEnd") {
    return "flex-end";
  } else {
    return "end";
  }
}

var AlignContent = {
  toString: toString$61
};

function toString$62(param) {
  if (param === "none") {
    return "none";
  } else if (param === "cover") {
    return "cover";
  } else if (param === "contain") {
    return "contain";
  } else if (param === "scaleDown") {
    return "scale-down";
  } else {
    return "fill";
  }
}

var ObjectFit = {
  toString: toString$62
};

function toString$63(param) {
  if (param === "inlineStart") {
    return "inline-start";
  } else if (param === "left") {
    return "left";
  } else if (param === "none") {
    return "none";
  } else if (param === "right") {
    return "right";
  } else if (param === "inlineEnd") {
    return "inline-end";
  } else {
    return "both";
  }
}

var Clear = {
  toString: toString$63
};

function toString$64(param) {
  if (param === "left") {
    return "left";
  } else if (param === "none") {
    return "none";
  } else if (param === "right") {
    return "right";
  } else if (param === "inlineEnd") {
    return "inline-end";
  } else {
    return "inline-start";
  }
}

var Float = {
  toString: toString$64
};

function toString$65(param) {
  if (param === "hidden") {
    return "hidden";
  } else if (param === "visible") {
    return "visible";
  } else {
    return "collapse";
  }
}

var Visibility = {
  toString: toString$65
};

function toString$66(param) {
  if (param === "fixed") {
    return "fixed";
  } else {
    return "auto";
  }
}

var TableLayout = {
  toString: toString$66
};

function toString$67(param) {
  if (param === "separate") {
    return "separate";
  } else {
    return "collapse";
  }
}

var BorderCollapse = {
  toString: toString$67
};

function toString$68(param) {
  if (param === "wrapReverse") {
    return "wrap-reverse";
  } else if (param === "nowrap") {
    return "nowrap";
  } else {
    return "wrap";
  }
}

var FlexWrap = {
  toString: toString$68
};

function toString$69(param) {
  if (param === "row") {
    return "row";
  } else if (param === "columnReverse") {
    return "column-reverse";
  } else if (param === "rowReverse") {
    return "row-reverse";
  } else {
    return "column";
  }
}

var FlexDirection = {
  toString: toString$69
};

function toString$70(param) {
  if (param === "borderBox") {
    return "border-box";
  } else {
    return "content-box";
  }
}

var BoxSizing = {
  toString: toString$70
};

function toString$71(param) {
  if (typeof param === "object") {
    return param.VAL.toString();
  } else {
    return "auto";
  }
}

var ColumnCount = {
  toString: toString$71
};

function toString$72(param) {
  if (param === "none") {
    return "none";
  } else if (param === "text") {
    return "text";
  } else if (param === "all") {
    return "all";
  } else if (param === "contain") {
    return "contain";
  } else {
    return "auto";
  }
}

var UserSelect = {
  toString: toString$72
};

function toString$73(param) {
  if (param === "capitalize") {
    return "capitalize";
  } else if (param === "lowercase") {
    return "lowercase";
  } else if (param === "uppercase") {
    return "uppercase";
  } else {
    return "none";
  }
}

var TextTransform = {
  toString: toString$73
};

function areas(x) {
  return {
          NAME: "areas",
          VAL: x
        };
}

function toString$74(param) {
  if (typeof param === "object") {
    return $$String.trim(List.fold_left((function (carry, elem) {
                      return carry + ("'" + (elem + "' "));
                    }), "", param.VAL));
  } else {
    return "none";
  }
}

var GridTemplateAreas = {
  areas: areas,
  toString: toString$74
};

function ident(x) {
  return {
          NAME: "ident",
          VAL: x
        };
}

function num(x) {
  return {
          NAME: "num",
          VAL: x
        };
}

function numIdent(x, y) {
  return {
          NAME: "numIdent",
          VAL: [
            x,
            y
          ]
        };
}

function span(x) {
  return {
          NAME: "span",
          VAL: x
        };
}

function toString$75(t) {
  if (typeof t !== "object") {
    return "auto";
  }
  var variant = t.NAME;
  if (variant === "numIdent") {
    var match = t.VAL;
    return String(match[0]) + (" " + match[1]);
  }
  if (variant === "num") {
    return String(t.VAL);
  }
  if (variant === "ident") {
    return t.VAL;
  }
  var e = t.VAL;
  return "span " + (
          e.NAME === "ident" ? e.VAL : String(e.VAL)
        );
}

var GridArea = {
  auto: "auto",
  ident: ident,
  num: num,
  numIdent: numIdent,
  span: span,
  toString: toString$75
};

function toString$76(param) {
  if (typeof param !== "object") {
    return "none";
  }
  var variant = param.NAME;
  if (variant === "dropShadow") {
    var match = param.VAL;
    if (match.NAME === "num") {
      return "drop-shadow(" + (String(match.VAL) + ")");
    } else {
      return "drop-shadow(" + (match.VAL.toString() + "%)");
    }
  }
  if (variant === "brightness") {
    var match$1 = param.VAL;
    if (match$1.NAME === "num") {
      return "brightness(" + (String(match$1.VAL) + ")");
    } else {
      return "brightness(" + (match$1.VAL.toString() + "%)");
    }
  }
  if (variant === "opacity") {
    var match$2 = param.VAL;
    if (match$2.NAME === "num") {
      return "opacity(" + (String(match$2.VAL) + ")");
    } else {
      return "opacity(" + (match$2.VAL.toString() + "%)");
    }
  }
  if (variant === "grayscale") {
    var match$3 = param.VAL;
    if (match$3.NAME === "num") {
      return "grayscale(" + (String(match$3.VAL) + ")");
    } else {
      return "grayscale(" + (match$3.VAL.toString() + "%)");
    }
  }
  if (variant === "sepia") {
    var match$4 = param.VAL;
    if (match$4.NAME === "num") {
      return "sepia(" + (String(match$4.VAL) + ")");
    } else {
      return "sepia(" + (match$4.VAL.toString() + "%)");
    }
  }
  if (variant === "saturate") {
    var match$5 = param.VAL;
    if (match$5.NAME === "num") {
      return "saturate(" + (String(match$5.VAL) + ")");
    } else {
      return "saturate(" + (match$5.VAL.toString() + "%)");
    }
  }
  if (variant === "invert") {
    var match$6 = param.VAL;
    if (match$6.NAME === "num") {
      return "invert(" + (String(match$6.VAL) + ")");
    } else {
      return "invert(" + (match$6.VAL.toString() + "%)");
    }
  }
  if (variant === "contrast") {
    var match$7 = param.VAL;
    if (match$7.NAME === "num") {
      return "contrast(" + (String(match$7.VAL) + ")");
    } else {
      return "contrast(" + (match$7.VAL.toString() + "%)");
    }
  }
  if (variant !== "hueRotate") {
    return "blur(" + (toString$5(param.VAL) + ")");
  }
  var h = param.VAL;
  if (typeof h === "object") {
    return "hue-rotate(" + (toString$6(h) + ")");
  } else {
    return "hue-rotate(0deg)";
  }
}

function toString$77(param) {
  if (param === "local") {
    return "local";
  } else if (param === "fixed") {
    return "fixed";
  } else {
    return "scroll";
  }
}

var BackgroundAttachment = {
  toString: toString$77
};

function toString$78(param) {
  if (param === "borderBox") {
    return "border-box";
  } else if (param === "paddingBox") {
    return "padding-box";
  } else {
    return "content-box";
  }
}

var BackgroundClip = {
  toString: toString$78
};

function toString$79(param) {
  if (param === "borderBox") {
    return "border-box";
  } else if (param === "paddingBox") {
    return "padding-box";
  } else {
    return "content-box";
  }
}

var BackgroundOrigin = {
  toString: toString$79
};

function toString$80(param) {
  if (param === "right") {
    return "right";
  } else if (param === "center") {
    return "center";
  } else {
    return "left";
  }
}

var X = {
  toString: toString$80
};

function toString$81(param) {
  if (param === "top") {
    return "top";
  } else if (param === "center") {
    return "center";
  } else {
    return "bottom";
  }
}

var Y = {
  toString: toString$81
};

function toString$82(param) {
  if (param === "bottom") {
    return "bottom";
  } else if (param === "right") {
    return "right";
  } else if (param === "top") {
    return "top";
  } else if (param === "center") {
    return "center";
  } else {
    return "left";
  }
}

var BackgroundPosition = {
  X: X,
  Y: Y,
  toString: toString$82
};

function toString$83(param) {
  if (param === "right") {
    return "right";
  } else if (param === "center") {
    return "center";
  } else {
    return "left";
  }
}

var X$1 = {
  toString: toString$83
};

function toString$84(param) {
  if (param === "top") {
    return "top";
  } else if (param === "center") {
    return "center";
  } else {
    return "bottom";
  }
}

var Y$1 = {
  toString: toString$84
};

function toString$85(param) {
  if (param === "bottom") {
    return "bottom";
  } else if (param === "right") {
    return "right";
  } else if (param === "top") {
    return "top";
  } else if (param === "center") {
    return "center";
  } else {
    return "left";
  }
}

var MaskPosition = {
  X: X$1,
  Y: Y$1,
  toString: toString$85
};

function toString$86(param) {
  if (param === "round") {
    return "round";
  } else if (param === "space") {
    return "space";
  } else if (param === "repeat") {
    return "repeat";
  } else if (param === "repeatX") {
    return "repeat-x";
  } else if (param === "repeatY") {
    return "repeat-y";
  } else {
    return "no-repeat";
  }
}

var BackgroundRepeat = {
  toString: toString$86
};

function toString$87(param) {
  if (typeof param === "object") {
    return param.VAL;
  } else if (param === "ellipsis") {
    return "ellipsis";
  } else {
    return "clip";
  }
}

var TextOverflow = {
  toString: toString$87
};

function toString$88(param) {
  if (param === "none") {
    return "none";
  } else if (param === "underline") {
    return "underline";
  } else if (param === "lineThrough") {
    return "line-through";
  } else if (param === "blink") {
    return "blink";
  } else {
    return "overline";
  }
}

var TextDecorationLine = {
  toString: toString$88
};

function toString$89(param) {
  if (param === "solid") {
    return "solid";
  } else if (param === "dashed") {
    return "dashed";
  } else if (param === "dotted") {
    return "dotted";
  } else if (param === "double") {
    return "double";
  } else {
    return "wavy";
  }
}

var TextDecorationStyle = {
  toString: toString$89
};

function toString$90(param) {
  if (param === "minContent") {
    return "min-content";
  } else if (param === "fitContent") {
    return "fit-content";
  } else if (param === "maxContent") {
    return "max-content";
  } else {
    return "auto";
  }
}

var Width = {
  toString: toString$90
};

function toString$91(param) {
  return "none";
}

var MaxWidth = {
  toString: toString$91
};

function toString$92(param) {
  return "auto";
}

var Height = {
  toString: toString$92
};

function toString$93(param) {
  return "none";
}

var MaxHeight = {
  toString: toString$93
};

function toString$94(param) {
  if (param === "anywhere") {
    return "anywhere";
  } else if (param === "breakWord") {
    return "break-word";
  } else {
    return "normal";
  }
}

var OverflowWrap = {
  toString: toString$94
};

function linearGradient(angle, stops) {
  return {
          NAME: "linearGradient",
          VAL: [
            angle,
            stops
          ]
        };
}

function repeatingLinearGradient(angle, stops) {
  return {
          NAME: "repeatingLinearGradient",
          VAL: [
            angle,
            stops
          ]
        };
}

function radialGradient(stops) {
  return {
          NAME: "radialGradient",
          VAL: stops
        };
}

function repeatingRadialGradient(stops) {
  return {
          NAME: "repeatingRadialGradient",
          VAL: stops
        };
}

function conicGradient(angle, stops) {
  return {
          NAME: "conicGradient",
          VAL: [
            angle,
            stops
          ]
        };
}

function string_of_color(co) {
  if (typeof co !== "object") {
    return toString$36(co);
  }
  var variant = co.NAME;
  if (variant === "var" || variant === "varDefault") {
    return toString$1(co);
  } else {
    return toString$36(co);
  }
}

function string_of_stops(stops) {
  return Belt_Array.map(stops, (function (param) {
                  return string_of_color(param[1]) + (" " + toString$5(param[0]));
                })).join(", ");
}

function toString$95(param) {
  var variant = param.NAME;
  if (variant === "repeatingRadialGradient") {
    return "repeating-radial-gradient(" + (string_of_stops(param.VAL) + ")");
  }
  if (variant === "repeatingLinearGradient") {
    var match = param.VAL;
    return "repeating-linear-gradient(" + (toString$6(match[0]) + (", " + (string_of_stops(match[1]) + ")")));
  }
  if (variant === "radialGradient") {
    return "radial-gradient(" + (string_of_stops(param.VAL) + ")");
  }
  if (variant === "linearGradient") {
    var match$1 = param.VAL;
    return "linear-gradient(" + (toString$6(match$1[0]) + (", " + (string_of_stops(match$1[1]) + ")")));
  }
  var match$2 = param.VAL;
  return "conic-gradient(from " + (toString$6(match$2[0]) + (", " + (string_of_stops(match$2[1]) + ")")));
}

function toString$96(param) {
  return "none";
}

var BackgroundImage = {
  toString: toString$96
};

function toString$97(param) {
  return "none";
}

var MaskImage = {
  toString: toString$97
};

function toString$98(param) {
  if (param === "marginBox") {
    return "margin-box";
  } else if (param === "strokeBox") {
    return "stroke-box";
  } else if (param === "borderBox") {
    return "border-box";
  } else if (param === "fillBox") {
    return "fill-box";
  } else if (param === "viewBox") {
    return "view-box";
  } else if (param === "paddingBox") {
    return "padding-box";
  } else {
    return "content-box";
  }
}

var GeometyBox = {
  marginBox: "marginBox",
  borderBox: "borderBox",
  paddingBox: "paddingBox",
  contentBox: "contentBox",
  fillBox: "fillBox",
  strokeBox: "strokeBox",
  viewBox: "viewBox",
  toString: toString$98
};

function toString$99(param) {
  return "none";
}

var ClipPath = {
  toString: toString$99
};

function toString$100(param) {
  if (param === "visible") {
    return "visible";
  } else {
    return "hidden";
  }
}

var BackfaceVisibility = {
  toString: toString$100
};

function toString$101(param) {
  if (param === "none") {
    return "none";
  } else if (param === "initial") {
    return "initial";
  } else {
    return "auto";
  }
}

var Flex = {
  toString: toString$101
};

function toString$102(param) {
  if (param === "preserve3d") {
    return "preserve-3d";
  } else {
    return "flat";
  }
}

var TransformStyle = {
  toString: toString$102
};

function toString$103(param) {
  return "none";
}

var ListStyleImage = {
  toString: toString$103
};

function toString$104(param) {
  if (typeof param === "object") {
    return param.VAL;
  } else if (param === "cursive") {
    return "cursive";
  } else if (param === "sansSerif") {
    return "sans-serif";
  } else if (param === "monospace") {
    return "monospace";
  } else if (param === "systemUi") {
    return "system-ui";
  } else if (param === "emoji") {
    return "emoji";
  } else if (param === "serif") {
    return "serif";
  } else if (param === "fantasy") {
    return "fantasy";
  } else if (param === "fangsong") {
    return "fangsong";
  } else {
    return "math";
  }
}

function toString$105(param) {
  if (param === "swap") {
    return "swap";
  } else if (param === "optional") {
    return "optional";
  } else if (param === "fallback") {
    return "fallback";
  } else if (param === "block") {
    return "block";
  } else {
    return "auto";
  }
}

var toString$106 = toString$26;

var CounterStyleType = {
  toString: toString$106
};

function counter(styleOpt, name) {
  var style = styleOpt !== undefined ? styleOpt : "unset";
  return {
          NAME: "counter",
          VAL: [
            name,
            style
          ]
        };
}

function toString$107(param) {
  var match = param.VAL;
  var style = match[1];
  var counter = match[0];
  if (style === "unset") {
    return "counter(" + (counter + ")");
  } else {
    return "counter(" + (counter + ("," + (toString$26(style) + ")")));
  }
}

var Counter = {
  counter: counter,
  toString: toString$107
};

function counters(styleOpt, separatorOpt, name) {
  var style = styleOpt !== undefined ? styleOpt : "unset";
  var separator = separatorOpt !== undefined ? separatorOpt : "";
  return {
          NAME: "counters",
          VAL: [
            name,
            separator,
            style
          ]
        };
}

function toString$108(param) {
  var match = param.VAL;
  var style = match[2];
  var separator = match[1];
  var name = match[0];
  if (style === "unset") {
    return "counters(" + (name + (",\"" + (separator + "\")")));
  } else {
    return "counters(" + (name + (",\"" + (separator + ("\"," + (toString$26(style) + ")")))));
  }
}

var Counters = {
  counters: counters,
  toString: toString$108
};

function increment(valueOpt, name) {
  var value = valueOpt !== undefined ? valueOpt : 1;
  return {
          NAME: "increment",
          VAL: [
            name,
            value
          ]
        };
}

function toString$109(param) {
  if (typeof param !== "object") {
    return "none";
  }
  var match = param.VAL;
  return match[0] + (" " + String(match[1]));
}

var CounterIncrement = {
  increment: increment,
  toString: toString$109
};

function reset(valueOpt, name) {
  var value = valueOpt !== undefined ? valueOpt : 0;
  return {
          NAME: "reset",
          VAL: [
            name,
            value
          ]
        };
}

function toString$110(param) {
  if (typeof param !== "object") {
    return "none";
  }
  var match = param.VAL;
  return match[0] + (" " + String(match[1]));
}

var CounterReset = {
  reset: reset,
  toString: toString$110
};

function set(valueOpt, name) {
  var value = valueOpt !== undefined ? valueOpt : 0;
  return {
          NAME: "set",
          VAL: [
            name,
            value
          ]
        };
}

function toString$111(param) {
  if (typeof param !== "object") {
    return "none";
  }
  var match = param.VAL;
  return match[0] + (" " + String(match[1]));
}

var CounterSet = {
  set: set,
  toString: toString$111
};

function toString$112(param) {
  if (typeof param === "object") {
    if (param.NAME === "text") {
      return "\"" + param.VAL + "\"";
    } else {
      return "attr(" + (param.VAL + ")");
    }
  } else if (param === "none") {
    return "none";
  } else if (param === "openQuote") {
    return "open-quote";
  } else if (param === "closeQuote") {
    return "close-quote";
  } else if (param === "normal") {
    return "normal";
  } else if (param === "noOpenQuote") {
    return "no-open-quote";
  } else {
    return "no-close-quote";
  }
}

var Content = {
  toString: toString$112
};

function toString$113(param) {
  if (param === "contextFill") {
    return "context-fill";
  } else if (param === "contextStroke") {
    return "context-stroke";
  } else {
    return "none";
  }
}

var Fill = {
  contextFill: "contextFill",
  contextStroke: "contextStroke",
  toString: toString$113
};

var SVG = {
  Fill: Fill
};

function toString$114(param) {
  if (param === "none") {
    return "none";
  } else if (param === "panX") {
    return "pan-x";
  } else if (param === "panY") {
    return "pan-y";
  } else if (param === "pinchZoom") {
    return "pinch-zoom";
  } else if (param === "manipulation") {
    return "manipulation";
  } else if (param === "panDown") {
    return "pan-down";
  } else if (param === "panLeft") {
    return "pan-left";
  } else if (param === "panUp") {
    return "pan-up";
  } else if (param === "panRight") {
    return "pan-right";
  } else {
    return "auto";
  }
}

var TouchAction = {
  toString: toString$114
};

var Var = {
  $$var: $$var,
  varDefault: varDefault,
  toString: toString$1
};

var RowGap;

var ColumnGap;

var TimingFunction = {
  linear: "linear",
  ease: "ease",
  easeIn: "easeIn",
  easeOut: "easeOut",
  easeInOut: "easeInOut",
  stepStart: "stepStart",
  stepEnd: "stepEnd",
  steps: steps,
  cubicBezier: cubicBezier,
  toString: toString$24
};

var Transform = {
  translate: translate,
  translate3d: translate3d,
  translateX: translateX,
  translateY: translateY,
  translateZ: translateZ,
  scale: scale,
  scale3d: scale3d,
  scaleX: scaleX,
  scaleY: scaleY,
  scaleZ: scaleZ,
  rotate: rotate,
  rotate3d: rotate3d,
  rotateX: rotateX,
  rotateY: rotateY,
  rotateZ: rotateZ,
  skew: skew,
  skewX: skewX,
  skewY: skewY,
  toString: toString$30
};

var Color = {
  rgb: rgb,
  rgba: rgba,
  hsl: hsl,
  hsla: hsla,
  hex: hex,
  transparent: "transparent",
  currentColor: "currentColor",
  toString: toString$36
};

var BackdropFilter = {
  toString: toString$76
};

var Gradient = {
  linearGradient: linearGradient,
  radialGradient: radialGradient,
  repeatingLinearGradient: repeatingLinearGradient,
  repeatingRadialGradient: repeatingRadialGradient,
  conicGradient: conicGradient,
  toString: toString$95
};

var FontFamilyName = {
  toString: toString$104
};

var FontDisplay = {
  toString: toString$105
};

exports.Cascading = Cascading;
exports.Var = Var;
exports.Time = Time;
exports.Percentage = Percentage;
exports.Url = Url;
exports.Length = Length;
exports.Angle = Angle;
exports.Direction = Direction;
exports.Position = Position;
exports.Isolation = Isolation;
exports.Resize = Resize;
exports.FontVariant = FontVariant;
exports.FontStyle = FontStyle;
exports.FlexBasis = FlexBasis;
exports.Overflow = Overflow;
exports.Margin = Margin;
exports.GridAutoFlow = GridAutoFlow;
exports.Gap = Gap;
exports.RowGap = RowGap;
exports.ColumnGap = ColumnGap;
exports.ScrollBehavior = ScrollBehavior;
exports.OverscrollBehavior = OverscrollBehavior;
exports.OverflowAnchor = OverflowAnchor;
exports.ColumnWidth = ColumnWidth;
exports.CaretColor = CaretColor;
exports.VerticalAlign = VerticalAlign;
exports.TimingFunction = TimingFunction;
exports.RepeatValue = RepeatValue;
exports.ListStyleType = ListStyleType;
exports.ListStylePosition = ListStylePosition;
exports.OutlineStyle = OutlineStyle;
exports.FontWeight = FontWeight;
exports.Transform = Transform;
exports.AnimationDirection = AnimationDirection;
exports.AnimationFillMode = AnimationFillMode;
exports.AnimationIterationCount = AnimationIterationCount;
exports.AnimationPlayState = AnimationPlayState;
exports.Cursor = Cursor;
exports.Color = Color;
exports.BorderStyle = BorderStyle;
exports.PointerEvents = PointerEvents;
exports.Perspective = Perspective;
exports.LetterSpacing = LetterSpacing;
exports.LineHeight = LineHeight;
exports.WordSpacing = WordSpacing;
exports.DisplayOutside = DisplayOutside;
exports.DisplayInside = DisplayInside;
exports.DisplayListItem = DisplayListItem;
exports.DisplayInternal = DisplayInternal;
exports.DisplayBox = DisplayBox;
exports.DisplayLegacy = DisplayLegacy;
exports.JustifySelf = JustifySelf;
exports.PositionalAlignment = PositionalAlignment;
exports.OverflowAlignment = OverflowAlignment;
exports.BaselineAlignment = BaselineAlignment;
exports.NormalAlignment = NormalAlignment;
exports.DistributedAlignment = DistributedAlignment;
exports.LegacyAlignment = LegacyAlignment;
exports.TextAlign = TextAlign;
exports.WordBreak = WordBreak;
exports.WhiteSpace = WhiteSpace;
exports.AlignItems = AlignItems;
exports.AlignSelf = AlignSelf;
exports.AlignContent = AlignContent;
exports.ObjectFit = ObjectFit;
exports.Clear = Clear;
exports.Float = Float;
exports.Visibility = Visibility;
exports.TableLayout = TableLayout;
exports.BorderCollapse = BorderCollapse;
exports.FlexWrap = FlexWrap;
exports.FlexDirection = FlexDirection;
exports.BoxSizing = BoxSizing;
exports.ColumnCount = ColumnCount;
exports.UserSelect = UserSelect;
exports.TextTransform = TextTransform;
exports.GridTemplateAreas = GridTemplateAreas;
exports.GridArea = GridArea;
exports.BackdropFilter = BackdropFilter;
exports.BackgroundAttachment = BackgroundAttachment;
exports.BackgroundClip = BackgroundClip;
exports.BackgroundOrigin = BackgroundOrigin;
exports.BackgroundPosition = BackgroundPosition;
exports.MaskPosition = MaskPosition;
exports.BackgroundRepeat = BackgroundRepeat;
exports.TextOverflow = TextOverflow;
exports.TextDecorationLine = TextDecorationLine;
exports.TextDecorationStyle = TextDecorationStyle;
exports.Width = Width;
exports.MaxWidth = MaxWidth;
exports.Height = Height;
exports.MaxHeight = MaxHeight;
exports.OverflowWrap = OverflowWrap;
exports.Gradient = Gradient;
exports.BackgroundImage = BackgroundImage;
exports.MaskImage = MaskImage;
exports.GeometyBox = GeometyBox;
exports.ClipPath = ClipPath;
exports.BackfaceVisibility = BackfaceVisibility;
exports.Flex = Flex;
exports.TransformStyle = TransformStyle;
exports.ListStyleImage = ListStyleImage;
exports.FontFamilyName = FontFamilyName;
exports.FontDisplay = FontDisplay;
exports.CounterStyleType = CounterStyleType;
exports.Counter = Counter;
exports.Counters = Counters;
exports.CounterIncrement = CounterIncrement;
exports.CounterReset = CounterReset;
exports.CounterSet = CounterSet;
exports.Content = Content;
exports.SVG = SVG;
exports.TouchAction = TouchAction;
/* No side effect */


/***/ }),

/***/ 49323:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE


var Css_AtomicTypes = __webpack_require__(82974);

var aliceblue = Css_AtomicTypes.Color.hex("F0F8FF");

var antiquewhite = Css_AtomicTypes.Color.hex("FAEBD7");

var aqua = Css_AtomicTypes.Color.hex("00FFFF");

var aquamarine = Css_AtomicTypes.Color.hex("7FFFD4");

var azure = Css_AtomicTypes.Color.hex("F0FFFF");

var beige = Css_AtomicTypes.Color.hex("F5F5DC");

var bisque = Css_AtomicTypes.Color.hex("FFE4C4");

var black = Css_AtomicTypes.Color.hex("000000");

var blanchedalmond = Css_AtomicTypes.Color.hex("FFEBCD");

var blue = Css_AtomicTypes.Color.hex("0000FF");

var blueviolet = Css_AtomicTypes.Color.hex("8A2BE2");

var brown = Css_AtomicTypes.Color.hex("A52A2A");

var burlywood = Css_AtomicTypes.Color.hex("DEB887");

var cadetblue = Css_AtomicTypes.Color.hex("5F9EA0");

var chartreuse = Css_AtomicTypes.Color.hex("7FFF00");

var chocolate = Css_AtomicTypes.Color.hex("D2691E");

var coral = Css_AtomicTypes.Color.hex("FF7F50");

var cornflowerblue = Css_AtomicTypes.Color.hex("6495ED");

var cornsilk = Css_AtomicTypes.Color.hex("FFF8DC");

var crimson = Css_AtomicTypes.Color.hex("DC143C");

var cyan = Css_AtomicTypes.Color.hex("00FFFF");

var darkblue = Css_AtomicTypes.Color.hex("00008B");

var darkcyan = Css_AtomicTypes.Color.hex("008B8B");

var darkgoldenrod = Css_AtomicTypes.Color.hex("B8860B");

var darkgray = Css_AtomicTypes.Color.hex("A9A9A9");

var darkgreen = Css_AtomicTypes.Color.hex("006400");

var darkgrey = Css_AtomicTypes.Color.hex("A9A9A9");

var darkkhaki = Css_AtomicTypes.Color.hex("BDB76B");

var darkmagenta = Css_AtomicTypes.Color.hex("8B008B");

var darkolivegreen = Css_AtomicTypes.Color.hex("556B2F");

var darkorange = Css_AtomicTypes.Color.hex("FF8C00");

var darkorchid = Css_AtomicTypes.Color.hex("9932CC");

var darkred = Css_AtomicTypes.Color.hex("8B0000");

var darksalmon = Css_AtomicTypes.Color.hex("E9967A");

var darkseagreen = Css_AtomicTypes.Color.hex("8FBC8F");

var darkslateblue = Css_AtomicTypes.Color.hex("483D8B");

var darkslategray = Css_AtomicTypes.Color.hex("2F4F4F");

var darkslategrey = Css_AtomicTypes.Color.hex("2F4F4F");

var darkturquoise = Css_AtomicTypes.Color.hex("00CED1");

var darkviolet = Css_AtomicTypes.Color.hex("9400D3");

var deeppink = Css_AtomicTypes.Color.hex("FF1493");

var deepskyblue = Css_AtomicTypes.Color.hex("00BFFF");

var dimgray = Css_AtomicTypes.Color.hex("696969");

var dimgrey = Css_AtomicTypes.Color.hex("696969");

var dodgerblue = Css_AtomicTypes.Color.hex("1E90FF");

var firebrick = Css_AtomicTypes.Color.hex("B22222");

var floralwhite = Css_AtomicTypes.Color.hex("FFFAF0");

var forestgreen = Css_AtomicTypes.Color.hex("228B22");

var fuchsia = Css_AtomicTypes.Color.hex("FF00FF");

var gainsboro = Css_AtomicTypes.Color.hex("DCDCDC");

var ghostwhite = Css_AtomicTypes.Color.hex("F8F8FF");

var gold = Css_AtomicTypes.Color.hex("FFD700");

var goldenrod = Css_AtomicTypes.Color.hex("DAA520");

var gray = Css_AtomicTypes.Color.hex("808080");

var green = Css_AtomicTypes.Color.hex("008000");

var greenyellow = Css_AtomicTypes.Color.hex("ADFF2F");

var grey = Css_AtomicTypes.Color.hex("808080");

var honeydew = Css_AtomicTypes.Color.hex("F0FFF0");

var hotpink = Css_AtomicTypes.Color.hex("FF69B4");

var indianred = Css_AtomicTypes.Color.hex("CD5C5C");

var indigo = Css_AtomicTypes.Color.hex("4B0082");

var ivory = Css_AtomicTypes.Color.hex("FFFFF0");

var khaki = Css_AtomicTypes.Color.hex("F0E68C");

var lavender = Css_AtomicTypes.Color.hex("E6E6FA");

var lavenderblush = Css_AtomicTypes.Color.hex("FFF0F5");

var lawngreen = Css_AtomicTypes.Color.hex("7CFC00");

var lemonchiffon = Css_AtomicTypes.Color.hex("FFFACD");

var lightblue = Css_AtomicTypes.Color.hex("ADD8E6");

var lightcoral = Css_AtomicTypes.Color.hex("F08080");

var lightcyan = Css_AtomicTypes.Color.hex("E0FFFF");

var lightgoldenrodyellow = Css_AtomicTypes.Color.hex("FAFAD2");

var lightgray = Css_AtomicTypes.Color.hex("D3D3D3");

var lightgreen = Css_AtomicTypes.Color.hex("90EE90");

var lightgrey = Css_AtomicTypes.Color.hex("D3D3D3");

var lightpink = Css_AtomicTypes.Color.hex("FFB6C1");

var lightsalmon = Css_AtomicTypes.Color.hex("FFA07A");

var lightseagreen = Css_AtomicTypes.Color.hex("20B2AA");

var lightskyblue = Css_AtomicTypes.Color.hex("87CEFA");

var lightslategray = Css_AtomicTypes.Color.hex("778899");

var lightslategrey = Css_AtomicTypes.Color.hex("778899");

var lightsteelblue = Css_AtomicTypes.Color.hex("B0C4DE");

var lightyellow = Css_AtomicTypes.Color.hex("FFFFE0");

var lime = Css_AtomicTypes.Color.hex("00FF00");

var limegreen = Css_AtomicTypes.Color.hex("32CD32");

var linen = Css_AtomicTypes.Color.hex("FAF0E6");

var magenta = Css_AtomicTypes.Color.hex("FF00FF");

var maroon = Css_AtomicTypes.Color.hex("800000");

var mediumaquamarine = Css_AtomicTypes.Color.hex("66CDAA");

var mediumblue = Css_AtomicTypes.Color.hex("0000CD");

var mediumorchid = Css_AtomicTypes.Color.hex("BA55D3");

var mediumpurple = Css_AtomicTypes.Color.hex("9370DB");

var mediumseagreen = Css_AtomicTypes.Color.hex("3CB371");

var mediumslateblue = Css_AtomicTypes.Color.hex("7B68EE");

var mediumspringgreen = Css_AtomicTypes.Color.hex("00FA9A");

var mediumturquoise = Css_AtomicTypes.Color.hex("48D1CC");

var mediumvioletred = Css_AtomicTypes.Color.hex("C71585");

var midnightblue = Css_AtomicTypes.Color.hex("191970");

var mintcream = Css_AtomicTypes.Color.hex("F5FFFA");

var mistyrose = Css_AtomicTypes.Color.hex("FFE4E1");

var moccasin = Css_AtomicTypes.Color.hex("FFE4B5");

var navajowhite = Css_AtomicTypes.Color.hex("FFDEAD");

var navy = Css_AtomicTypes.Color.hex("000080");

var oldlace = Css_AtomicTypes.Color.hex("FDF5E6");

var olive = Css_AtomicTypes.Color.hex("808000");

var olivedrab = Css_AtomicTypes.Color.hex("6B8E23");

var orange = Css_AtomicTypes.Color.hex("FFA500");

var orangered = Css_AtomicTypes.Color.hex("FF4500");

var orchid = Css_AtomicTypes.Color.hex("DA70D6");

var palegoldenrod = Css_AtomicTypes.Color.hex("EEE8AA");

var palegreen = Css_AtomicTypes.Color.hex("98FB98");

var paleturquoise = Css_AtomicTypes.Color.hex("AFEEEE");

var palevioletred = Css_AtomicTypes.Color.hex("DB7093");

var papayawhip = Css_AtomicTypes.Color.hex("FFEFD5");

var peachpuff = Css_AtomicTypes.Color.hex("FFDAB9");

var peru = Css_AtomicTypes.Color.hex("CD853F");

var pink = Css_AtomicTypes.Color.hex("FFC0CB");

var plum = Css_AtomicTypes.Color.hex("DDA0DD");

var powderblue = Css_AtomicTypes.Color.hex("B0E0E6");

var purple = Css_AtomicTypes.Color.hex("800080");

var rebeccapurple = Css_AtomicTypes.Color.hex("663399");

var red = Css_AtomicTypes.Color.hex("FF0000");

var rosybrown = Css_AtomicTypes.Color.hex("BC8F8F");

var royalblue = Css_AtomicTypes.Color.hex("4169E1");

var saddlebrown = Css_AtomicTypes.Color.hex("8B4513");

var salmon = Css_AtomicTypes.Color.hex("FA8072");

var sandybrown = Css_AtomicTypes.Color.hex("F4A460");

var seagreen = Css_AtomicTypes.Color.hex("2E8B57");

var seashell = Css_AtomicTypes.Color.hex("FFF5EE");

var sienna = Css_AtomicTypes.Color.hex("A0522D");

var silver = Css_AtomicTypes.Color.hex("C0C0C0");

var skyblue = Css_AtomicTypes.Color.hex("87CEEB");

var slateblue = Css_AtomicTypes.Color.hex("6A5ACD");

var slategray = Css_AtomicTypes.Color.hex("708090");

var slategrey = Css_AtomicTypes.Color.hex("708090");

var snow = Css_AtomicTypes.Color.hex("FFFAFA");

var springgreen = Css_AtomicTypes.Color.hex("00FF7F");

var steelblue = Css_AtomicTypes.Color.hex("4682B4");

var tan = Css_AtomicTypes.Color.hex("D2B48C");

var teal = Css_AtomicTypes.Color.hex("008080");

var thistle = Css_AtomicTypes.Color.hex("D8BFD8");

var tomato = Css_AtomicTypes.Color.hex("FF6347");

var turquoise = Css_AtomicTypes.Color.hex("40E0D0");

var violet = Css_AtomicTypes.Color.hex("EE82EE");

var wheat = Css_AtomicTypes.Color.hex("F5DEB3");

var white = Css_AtomicTypes.Color.hex("FFFFFF");

var whitesmoke = Css_AtomicTypes.Color.hex("F5F5F5");

var yellow = Css_AtomicTypes.Color.hex("FFFF00");

var yellowgreen = Css_AtomicTypes.Color.hex("9ACD32");

var transparent = Css_AtomicTypes.Color.transparent;

exports.aliceblue = aliceblue;
exports.antiquewhite = antiquewhite;
exports.aqua = aqua;
exports.aquamarine = aquamarine;
exports.azure = azure;
exports.beige = beige;
exports.bisque = bisque;
exports.black = black;
exports.blanchedalmond = blanchedalmond;
exports.blue = blue;
exports.blueviolet = blueviolet;
exports.brown = brown;
exports.burlywood = burlywood;
exports.cadetblue = cadetblue;
exports.chartreuse = chartreuse;
exports.chocolate = chocolate;
exports.coral = coral;
exports.cornflowerblue = cornflowerblue;
exports.cornsilk = cornsilk;
exports.crimson = crimson;
exports.cyan = cyan;
exports.darkblue = darkblue;
exports.darkcyan = darkcyan;
exports.darkgoldenrod = darkgoldenrod;
exports.darkgray = darkgray;
exports.darkgreen = darkgreen;
exports.darkgrey = darkgrey;
exports.darkkhaki = darkkhaki;
exports.darkmagenta = darkmagenta;
exports.darkolivegreen = darkolivegreen;
exports.darkorange = darkorange;
exports.darkorchid = darkorchid;
exports.darkred = darkred;
exports.darksalmon = darksalmon;
exports.darkseagreen = darkseagreen;
exports.darkslateblue = darkslateblue;
exports.darkslategray = darkslategray;
exports.darkslategrey = darkslategrey;
exports.darkturquoise = darkturquoise;
exports.darkviolet = darkviolet;
exports.deeppink = deeppink;
exports.deepskyblue = deepskyblue;
exports.dimgray = dimgray;
exports.dimgrey = dimgrey;
exports.dodgerblue = dodgerblue;
exports.firebrick = firebrick;
exports.floralwhite = floralwhite;
exports.forestgreen = forestgreen;
exports.fuchsia = fuchsia;
exports.gainsboro = gainsboro;
exports.ghostwhite = ghostwhite;
exports.gold = gold;
exports.goldenrod = goldenrod;
exports.gray = gray;
exports.green = green;
exports.greenyellow = greenyellow;
exports.grey = grey;
exports.honeydew = honeydew;
exports.hotpink = hotpink;
exports.indianred = indianred;
exports.indigo = indigo;
exports.ivory = ivory;
exports.khaki = khaki;
exports.lavender = lavender;
exports.lavenderblush = lavenderblush;
exports.lawngreen = lawngreen;
exports.lemonchiffon = lemonchiffon;
exports.lightblue = lightblue;
exports.lightcoral = lightcoral;
exports.lightcyan = lightcyan;
exports.lightgoldenrodyellow = lightgoldenrodyellow;
exports.lightgray = lightgray;
exports.lightgreen = lightgreen;
exports.lightgrey = lightgrey;
exports.lightpink = lightpink;
exports.lightsalmon = lightsalmon;
exports.lightseagreen = lightseagreen;
exports.lightskyblue = lightskyblue;
exports.lightslategray = lightslategray;
exports.lightslategrey = lightslategrey;
exports.lightsteelblue = lightsteelblue;
exports.lightyellow = lightyellow;
exports.lime = lime;
exports.limegreen = limegreen;
exports.linen = linen;
exports.magenta = magenta;
exports.maroon = maroon;
exports.mediumaquamarine = mediumaquamarine;
exports.mediumblue = mediumblue;
exports.mediumorchid = mediumorchid;
exports.mediumpurple = mediumpurple;
exports.mediumseagreen = mediumseagreen;
exports.mediumslateblue = mediumslateblue;
exports.mediumspringgreen = mediumspringgreen;
exports.mediumturquoise = mediumturquoise;
exports.mediumvioletred = mediumvioletred;
exports.midnightblue = midnightblue;
exports.mintcream = mintcream;
exports.mistyrose = mistyrose;
exports.moccasin = moccasin;
exports.navajowhite = navajowhite;
exports.navy = navy;
exports.oldlace = oldlace;
exports.olive = olive;
exports.olivedrab = olivedrab;
exports.orange = orange;
exports.orangered = orangered;
exports.orchid = orchid;
exports.palegoldenrod = palegoldenrod;
exports.palegreen = palegreen;
exports.paleturquoise = paleturquoise;
exports.palevioletred = palevioletred;
exports.papayawhip = papayawhip;
exports.peachpuff = peachpuff;
exports.peru = peru;
exports.pink = pink;
exports.plum = plum;
exports.powderblue = powderblue;
exports.purple = purple;
exports.rebeccapurple = rebeccapurple;
exports.red = red;
exports.rosybrown = rosybrown;
exports.royalblue = royalblue;
exports.saddlebrown = saddlebrown;
exports.salmon = salmon;
exports.sandybrown = sandybrown;
exports.seagreen = seagreen;
exports.seashell = seashell;
exports.sienna = sienna;
exports.silver = silver;
exports.skyblue = skyblue;
exports.slateblue = slateblue;
exports.slategray = slategray;
exports.slategrey = slategrey;
exports.snow = snow;
exports.springgreen = springgreen;
exports.steelblue = steelblue;
exports.tan = tan;
exports.teal = teal;
exports.thistle = thistle;
exports.tomato = tomato;
exports.turquoise = turquoise;
exports.violet = violet;
exports.wheat = wheat;
exports.white = white;
exports.whitesmoke = whitesmoke;
exports.yellow = yellow;
exports.yellowgreen = yellowgreen;
exports.transparent = transparent;
/* aliceblue Not a pure module */


/***/ }),

/***/ 48050:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE


var List = __webpack_require__(68724);
var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var $$String = __webpack_require__(65760);
var Belt_List = __webpack_require__(11332);
var Js_option = __webpack_require__(10354);
var Belt_Option = __webpack_require__(46517);
var Css_AtomicTypes = __webpack_require__(82974);

function ruleToDict(dict, rule) {
  switch (rule.TAG | 0) {
    case /* D */0 :
        var value = rule._1;
        var name = rule._0;
        if (name === "content") {
          dict[name] = value === "" ? "\"\"" : value;
        } else {
          dict[name] = value;
        }
        break;
    case /* S */1 :
        dict[rule._0] = toJson(rule._1);
        break;
    case /* PseudoClass */2 :
        dict[":" + rule._0] = toJson(rule._1);
        break;
    case /* PseudoClassParam */3 :
        dict[":" + (rule._0 + ("(" + (rule._1 + ")")))] = toJson(rule._2);
        break;
    
  }
  return dict;
}

function toJson(rules) {
  return Belt_List.reduce(rules, {}, ruleToDict);
}

function addStop(dict, param) {
  dict[param[0].toString() + "%"] = toJson(param[1]);
  return dict;
}

function Make(CssImpl) {
  var insertRule = function (css) {
    return CssImpl.injectRaw(css);
  };
  var renderRule = function (renderer, css) {
    return CssImpl.renderRaw(renderer, css);
  };
  var $$global = function (selector, rules) {
    return CssImpl.injectRules(selector, toJson(rules));
  };
  var renderGlobal = function (renderer, selector, rules) {
    return CssImpl.renderRules(renderer, selector, toJson(rules));
  };
  var style = function (rules) {
    return CssImpl.make(toJson(rules));
  };
  var merge = function (styles) {
    return CssImpl.mergeStyles($$Array.of_list(styles));
  };
  var merge2 = function (s, s2) {
    return CssImpl.mergeStyles($$Array.of_list({
                    hd: s,
                    tl: {
                      hd: s2,
                      tl: /* [] */0
                    }
                  }));
  };
  var merge3 = function (s, s2, s3) {
    return CssImpl.mergeStyles($$Array.of_list({
                    hd: s,
                    tl: {
                      hd: s2,
                      tl: {
                        hd: s3,
                        tl: /* [] */0
                      }
                    }
                  }));
  };
  var merge4 = function (s, s2, s3, s4) {
    return CssImpl.mergeStyles($$Array.of_list({
                    hd: s,
                    tl: {
                      hd: s2,
                      tl: {
                        hd: s3,
                        tl: {
                          hd: s4,
                          tl: /* [] */0
                        }
                      }
                    }
                  }));
  };
  var keyframes = function (frames) {
    return CssImpl.makeKeyframes(List.fold_left(addStop, {}, frames));
  };
  var renderKeyframes = function (renderer, frames) {
    return CssImpl.renderKeyframes(renderer, List.fold_left(addStop, {}, frames));
  };
  return {
          insertRule: insertRule,
          renderRule: renderRule,
          $$global: $$global,
          renderGlobal: renderGlobal,
          style: style,
          merge: merge,
          merge2: merge2,
          merge3: merge3,
          merge4: merge4,
          keyframes: keyframes,
          renderKeyframes: renderKeyframes
        };
}

function join(strings, separator) {
  var _strings = strings;
  var _acc = "";
  while(true) {
    var acc = _acc;
    var strings$1 = _strings;
    if (!strings$1) {
      return acc;
    }
    var xs = strings$1.tl;
    var x = strings$1.hd;
    if (!xs) {
      return acc + x;
    }
    _acc = acc + (x + separator);
    _strings = xs;
    continue ;
  };
}

function string_of_content(x) {
  if (typeof x !== "object") {
    if (x === "unset" || x === "inherit_" || x === "initial") {
      return Css_AtomicTypes.Cascading.toString(x);
    } else {
      return Css_AtomicTypes.Content.toString(x);
    }
  }
  var variant = x.NAME;
  if (variant === "linearGradient" || variant === "radialGradient" || variant === "repeatingLinearGradient" || variant === "repeatingRadialGradient" || variant === "conicGradient") {
    return Css_AtomicTypes.Gradient.toString(x);
  } else if (variant === "var" || variant === "varDefault") {
    return Css_AtomicTypes.Var.toString(x);
  } else if (variant === "url") {
    return Css_AtomicTypes.Url.toString(x);
  } else if (variant === "counters") {
    return Css_AtomicTypes.Counters.toString(x);
  } else if (variant === "counter") {
    return Css_AtomicTypes.Counter.toString(x);
  } else {
    return Css_AtomicTypes.Content.toString(x);
  }
}

function string_of_counter_increment(x) {
  if (typeof x === "object") {
    if (x.NAME === "increment") {
      return Css_AtomicTypes.CounterIncrement.toString(x);
    } else {
      return Css_AtomicTypes.Var.toString(x);
    }
  } else if (x === "unset" || x === "inherit_" || x === "initial") {
    return Css_AtomicTypes.Cascading.toString(x);
  } else {
    return Css_AtomicTypes.CounterIncrement.toString(x);
  }
}

function string_of_counter_reset(x) {
  if (typeof x !== "object") {
    if (x === "unset" || x === "inherit_" || x === "initial") {
      return Css_AtomicTypes.Cascading.toString(x);
    } else {
      return Css_AtomicTypes.CounterReset.toString(x);
    }
  }
  var variant = x.NAME;
  if (variant === "var" || variant === "varDefault") {
    return Css_AtomicTypes.Var.toString(x);
  } else {
    return Css_AtomicTypes.CounterReset.toString(x);
  }
}

function string_of_counter_set(x) {
  if (typeof x === "object") {
    if (x.NAME === "set") {
      return Css_AtomicTypes.CounterSet.toString(x);
    } else {
      return Css_AtomicTypes.Var.toString(x);
    }
  } else if (x === "unset" || x === "inherit_" || x === "initial") {
    return Css_AtomicTypes.Cascading.toString(x);
  } else {
    return Css_AtomicTypes.CounterSet.toString(x);
  }
}

function string_of_column_gap(gcg) {
  if (typeof gcg !== "object") {
    if (gcg === "zero") {
      return Css_AtomicTypes.Length.toString(gcg);
    } else if (gcg === "normal") {
      return Css_AtomicTypes.Gap.toString(gcg);
    } else {
      return Css_AtomicTypes.Cascading.toString(gcg);
    }
  }
  var variant = gcg.NAME;
  if (variant === "var" || variant === "varDefault") {
    return Css_AtomicTypes.Var.toString(gcg);
  } else if (variant === "percent") {
    return Css_AtomicTypes.Percentage.toString(gcg);
  } else {
    return Css_AtomicTypes.Length.toString(gcg);
  }
}

function string_of_row_gap(rg) {
  if (typeof rg !== "object") {
    if (rg === "zero") {
      return Css_AtomicTypes.Length.toString(rg);
    } else if (rg === "normal") {
      return Css_AtomicTypes.Gap.toString(rg);
    } else {
      return Css_AtomicTypes.Cascading.toString(rg);
    }
  }
  var variant = rg.NAME;
  if (variant === "var" || variant === "varDefault") {
    return Css_AtomicTypes.Var.toString(rg);
  } else if (variant === "percent") {
    return Css_AtomicTypes.Percentage.toString(rg);
  } else {
    return Css_AtomicTypes.Length.toString(rg);
  }
}

function string_of_gap(rg) {
  if (typeof rg !== "object") {
    if (rg === "zero") {
      return Css_AtomicTypes.Length.toString(rg);
    } else if (rg === "normal") {
      return Css_AtomicTypes.Gap.toString(rg);
    } else {
      return Css_AtomicTypes.Cascading.toString(rg);
    }
  }
  var variant = rg.NAME;
  if (variant === "var" || variant === "varDefault") {
    return Css_AtomicTypes.Var.toString(rg);
  } else if (variant === "percent") {
    return Css_AtomicTypes.Percentage.toString(rg);
  } else {
    return Css_AtomicTypes.Length.toString(rg);
  }
}

function string_of_position(l) {
  if (typeof l !== "object") {
    if (l === "unset" || l === "inherit_" || l === "initial") {
      return Css_AtomicTypes.Cascading.toString(l);
    } else if (l === "zero") {
      return Css_AtomicTypes.Length.toString(l);
    } else {
      return "auto";
    }
  }
  var variant = l.NAME;
  if (variant === "var" || variant === "varDefault") {
    return Css_AtomicTypes.Var.toString(l);
  } else {
    return Css_AtomicTypes.Length.toString(l);
  }
}

function string_of_color(co) {
  if (typeof co !== "object") {
    return Css_AtomicTypes.Color.toString(co);
  }
  var variant = co.NAME;
  if (variant === "var" || variant === "varDefault") {
    return Css_AtomicTypes.Var.toString(co);
  } else {
    return Css_AtomicTypes.Color.toString(co);
  }
}

function string_of_dasharray(p) {
  if (typeof p === "object" && p.NAME === "percent") {
    return Css_AtomicTypes.Percentage.toString(p);
  } else {
    return Css_AtomicTypes.Length.toString(p);
  }
}

function important(v) {
  if (v.TAG === /* D */0) {
    return {
            TAG: /* D */0,
            _0: v._0,
            _1: v._1 + " !important"
          };
  } else {
    return v;
  }
}

function label(label$1) {
  return {
          TAG: /* D */0,
          _0: "label",
          _1: label$1
        };
}

function alignContent(x) {
  return {
          TAG: /* D */0,
          _0: "alignContent",
          _1: typeof x === "object" ? Css_AtomicTypes.Var.toString(x) : (
              x === "spaceBetween" || x === "stretch" || x === "spaceAround" || x === "spaceEvenly" ? Css_AtomicTypes.DistributedAlignment.toString(x) : (
                  x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : (
                      x === "baseline" || x === "firstBaseline" || x === "lastBaseline" ? Css_AtomicTypes.BaselineAlignment.toString(x) : (
                          x === "normal" ? Css_AtomicTypes.NormalAlignment.toString(x) : Css_AtomicTypes.AlignContent.toString(x)
                        )
                    )
                )
            )
        };
}

function alignItems(x) {
  return {
          TAG: /* D */0,
          _0: "alignItems",
          _1: typeof x === "object" ? Css_AtomicTypes.Var.toString(x) : (
              x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : (
                  x === "baseline" || x === "firstBaseline" || x === "lastBaseline" ? Css_AtomicTypes.BaselineAlignment.toString(x) : (
                      x === "normal" || x === "stretch" ? Css_AtomicTypes.AlignItems.toString(x) : Css_AtomicTypes.PositionalAlignment.toString(x)
                    )
                )
            )
        };
}

function alignSelf(x) {
  return {
          TAG: /* D */0,
          _0: "alignSelf",
          _1: typeof x === "object" ? Css_AtomicTypes.Var.toString(x) : (
              x === "selfStart" || x === "flexEnd" || x === "flexStart" || x === "center" || x === "start" || x === "selfEnd" || x === "right" || x === "left" || x === "end_" ? Css_AtomicTypes.PositionalAlignment.toString(x) : (
                  x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : (
                      x === "baseline" || x === "firstBaseline" || x === "lastBaseline" ? Css_AtomicTypes.BaselineAlignment.toString(x) : Css_AtomicTypes.AlignSelf.toString(x)
                    )
                )
            )
        };
}

function animationDelay(x) {
  return {
          TAG: /* D */0,
          _0: "animationDelay",
          _1: x.toString() + "ms"
        };
}

function animationDirection(x) {
  return {
          TAG: /* D */0,
          _0: "animationDirection",
          _1: Css_AtomicTypes.AnimationDirection.toString(x)
        };
}

function animationDuration(x) {
  return {
          TAG: /* D */0,
          _0: "animationDuration",
          _1: x.toString() + "ms"
        };
}

function animationFillMode(x) {
  return {
          TAG: /* D */0,
          _0: "animationFillMode",
          _1: Css_AtomicTypes.AnimationFillMode.toString(x)
        };
}

function animationIterationCount(x) {
  return {
          TAG: /* D */0,
          _0: "animationIterationCount",
          _1: Css_AtomicTypes.AnimationIterationCount.toString(x)
        };
}

function animationPlayState(x) {
  return {
          TAG: /* D */0,
          _0: "animationPlayState",
          _1: Css_AtomicTypes.AnimationPlayState.toString(x)
        };
}

function animationTimingFunction(x) {
  return {
          TAG: /* D */0,
          _0: "animationTimingFunction",
          _1: Css_AtomicTypes.TimingFunction.toString(x)
        };
}

function backfaceVisibility(x) {
  return {
          TAG: /* D */0,
          _0: "backfaceVisibility",
          _1: typeof x === "object" ? Css_AtomicTypes.Var.toString(x) : (
              x === "visible" || x === "hidden" ? Css_AtomicTypes.BackfaceVisibility.toString(x) : Css_AtomicTypes.Cascading.toString(x)
            )
        };
}

function backdropFilter(x) {
  return {
          TAG: /* D */0,
          _0: "backdropFilter",
          _1: join(Belt_List.map(x, Css_AtomicTypes.BackdropFilter.toString), ", ")
        };
}

function backgroundAttachment(x) {
  return {
          TAG: /* D */0,
          _0: "backgroundAttachment",
          _1: typeof x === "object" ? Css_AtomicTypes.Var.toString(x) : (
              x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : Css_AtomicTypes.BackgroundAttachment.toString(x)
            )
        };
}

function backgroundColor(x) {
  return {
          TAG: /* D */0,
          _0: "backgroundColor",
          _1: string_of_color(x)
        };
}

function backgroundClip(x) {
  return {
          TAG: /* D */0,
          _0: "backgroundClip",
          _1: typeof x === "object" ? Css_AtomicTypes.Var.toString(x) : (
              x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : Css_AtomicTypes.BackgroundClip.toString(x)
            )
        };
}

function backgroundImage(x) {
  return {
          TAG: /* D */0,
          _0: "backgroundImage",
          _1: typeof x === "object" ? (
              x.NAME === "url" ? Css_AtomicTypes.Url.toString(x) : Css_AtomicTypes.Gradient.toString(x)
            ) : Css_AtomicTypes.BackgroundImage.toString(x)
        };
}

function maskImage(x) {
  return {
          TAG: /* D */0,
          _0: "maskImage",
          _1: typeof x === "object" ? (
              x.NAME === "url" ? Css_AtomicTypes.Url.toString(x) : Css_AtomicTypes.Gradient.toString(x)
            ) : Css_AtomicTypes.MaskImage.toString(x)
        };
}

function backgroundOrigin(x) {
  return {
          TAG: /* D */0,
          _0: "backgroundOrigin",
          _1: typeof x === "object" ? Css_AtomicTypes.Var.toString(x) : (
              x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : Css_AtomicTypes.BackgroundOrigin.toString(x)
            )
        };
}

function string_of_backgroundposition(bp) {
  if (typeof bp !== "object") {
    if (bp === "unset" || bp === "inherit_" || bp === "initial") {
      return Css_AtomicTypes.Cascading.toString(bp);
    } else if (bp === "zero") {
      return Css_AtomicTypes.Length.toString(bp);
    } else {
      return Css_AtomicTypes.BackgroundPosition.toString(bp);
    }
  }
  var variant = bp.NAME;
  if (variant === "var" || variant === "varDefault") {
    return Css_AtomicTypes.Var.toString(bp);
  }
  if (variant !== "hv") {
    return Css_AtomicTypes.Length.toString(bp);
  }
  var match = bp.VAL;
  var v = match[1];
  var h = match[0];
  return (
          typeof h === "object" || h === "zero" ? Css_AtomicTypes.Length.toString(h) : Curry._1(Css_AtomicTypes.BackgroundPosition.X.toString, h)
        ) + (" " + (
            typeof v === "object" || !(v === "center" || v === "top" || v === "bottom") ? Css_AtomicTypes.Length.toString(v) : Curry._1(Css_AtomicTypes.BackgroundPosition.Y.toString, v)
          ));
}

function backgroundPosition(x) {
  return {
          TAG: /* D */0,
          _0: "backgroundPosition",
          _1: string_of_backgroundposition(x)
        };
}

function backgroundPositions(bp) {
  return {
          TAG: /* D */0,
          _0: "backgroundPosition",
          _1: join(Belt_List.map(bp, string_of_backgroundposition), ", ")
        };
}

function backgroundPosition4(x, offsetX, y, offsetY) {
  return {
          TAG: /* D */0,
          _0: "backgroundPosition",
          _1: Curry._1(Css_AtomicTypes.BackgroundPosition.X.toString, x) + (" " + (Css_AtomicTypes.Length.toString(offsetX) + (" " + (Curry._1(Css_AtomicTypes.BackgroundPosition.Y.toString, y) + (" " + Css_AtomicTypes.Length.toString(offsetY))))))
        };
}

function backgroundRepeat(x) {
  var tmp;
  if (typeof x === "object") {
    if (x.NAME === "hv") {
      var match = x.VAL;
      tmp = Css_AtomicTypes.BackgroundRepeat.toString(match[0]) + (" " + Css_AtomicTypes.BackgroundRepeat.toString(match[1]));
    } else {
      tmp = Css_AtomicTypes.Var.toString(x);
    }
  } else {
    tmp = x === "repeatY" || x === "repeatX" || x === "repeat" || x === "space" || x === "round" || x === "noRepeat" ? Css_AtomicTypes.BackgroundRepeat.toString(x) : Css_AtomicTypes.Cascading.toString(x);
  }
  return {
          TAG: /* D */0,
          _0: "backgroundRepeat",
          _1: tmp
        };
}

function string_of_maskposition(mp) {
  if (typeof mp !== "object") {
    if (mp === "unset" || mp === "inherit_" || mp === "initial") {
      return Css_AtomicTypes.Cascading.toString(mp);
    } else if (mp === "zero") {
      return Css_AtomicTypes.Length.toString(mp);
    } else {
      return Css_AtomicTypes.MaskPosition.toString(mp);
    }
  }
  var variant = mp.NAME;
  if (variant === "var" || variant === "varDefault") {
    return Css_AtomicTypes.Var.toString(mp);
  }
  if (variant !== "hv") {
    return Css_AtomicTypes.Length.toString(mp);
  }
  var match = mp.VAL;
  var v = match[1];
  var h = match[0];
  return (
          typeof h === "object" || h === "zero" ? Css_AtomicTypes.Length.toString(h) : Curry._1(Css_AtomicTypes.MaskPosition.X.toString, h)
        ) + (" " + (
            typeof v === "object" || !(v === "center" || v === "top" || v === "bottom") ? Css_AtomicTypes.Length.toString(v) : Curry._1(Css_AtomicTypes.MaskPosition.Y.toString, v)
          ));
}

function maskPosition(x) {
  return {
          TAG: /* D */0,
          _0: "maskPosition",
          _1: string_of_maskposition(x)
        };
}

function maskPositions(mp) {
  return {
          TAG: /* D */0,
          _0: "maskPosition",
          _1: join(Belt_List.map(mp, string_of_maskposition), ", ")
        };
}

function borderBottomColor(x) {
  return {
          TAG: /* D */0,
          _0: "borderBottomColor",
          _1: string_of_color(x)
        };
}

function borderBottomLeftRadius(x) {
  return {
          TAG: /* D */0,
          _0: "borderBottomLeftRadius",
          _1: Css_AtomicTypes.Length.toString(x)
        };
}

function borderBottomRightRadius(x) {
  return {
          TAG: /* D */0,
          _0: "borderBottomRightRadius",
          _1: Css_AtomicTypes.Length.toString(x)
        };
}

function borderBottomWidth(x) {
  return {
          TAG: /* D */0,
          _0: "borderBottomWidth",
          _1: Css_AtomicTypes.Length.toString(x)
        };
}

function borderCollapse(x) {
  return {
          TAG: /* D */0,
          _0: "borderCollapse",
          _1: typeof x === "object" ? Css_AtomicTypes.Var.toString(x) : (
              x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : Css_AtomicTypes.BorderCollapse.toString(x)
            )
        };
}

function borderColor(x) {
  return {
          TAG: /* D */0,
          _0: "borderColor",
          _1: string_of_color(x)
        };
}

function borderLeftColor(x) {
  return {
          TAG: /* D */0,
          _0: "borderLeftColor",
          _1: string_of_color(x)
        };
}

function borderLeftWidth(x) {
  return {
          TAG: /* D */0,
          _0: "borderLeftWidth",
          _1: Css_AtomicTypes.Length.toString(x)
        };
}

function borderSpacing(x) {
  return {
          TAG: /* D */0,
          _0: "borderSpacing",
          _1: Css_AtomicTypes.Length.toString(x)
        };
}

function borderRadius(x) {
  return {
          TAG: /* D */0,
          _0: "borderRadius",
          _1: Css_AtomicTypes.Length.toString(x)
        };
}

function borderRightColor(x) {
  return {
          TAG: /* D */0,
          _0: "borderRightColor",
          _1: string_of_color(x)
        };
}

function borderRightWidth(x) {
  return {
          TAG: /* D */0,
          _0: "borderRightWidth",
          _1: Css_AtomicTypes.Length.toString(x)
        };
}

function borderTopColor(x) {
  return {
          TAG: /* D */0,
          _0: "borderTopColor",
          _1: string_of_color(x)
        };
}

function borderTopLeftRadius(x) {
  return {
          TAG: /* D */0,
          _0: "borderTopLeftRadius",
          _1: Css_AtomicTypes.Length.toString(x)
        };
}

function borderTopRightRadius(x) {
  return {
          TAG: /* D */0,
          _0: "borderTopRightRadius",
          _1: Css_AtomicTypes.Length.toString(x)
        };
}

function borderTopWidth(x) {
  return {
          TAG: /* D */0,
          _0: "borderTopWidth",
          _1: Css_AtomicTypes.Length.toString(x)
        };
}

function borderWidth(x) {
  return {
          TAG: /* D */0,
          _0: "borderWidth",
          _1: Css_AtomicTypes.Length.toString(x)
        };
}

function bottom(x) {
  return {
          TAG: /* D */0,
          _0: "bottom",
          _1: string_of_position(x)
        };
}

function boxSizing(x) {
  return {
          TAG: /* D */0,
          _0: "boxSizing",
          _1: typeof x === "object" ? Css_AtomicTypes.Var.toString(x) : (
              x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : Css_AtomicTypes.BoxSizing.toString(x)
            )
        };
}

function clear(x) {
  return {
          TAG: /* D */0,
          _0: "clear",
          _1: typeof x === "object" ? Css_AtomicTypes.Var.toString(x) : (
              x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : Css_AtomicTypes.Clear.toString(x)
            )
        };
}

function clipPath(x) {
  return {
          TAG: /* D */0,
          _0: "clipPath",
          _1: typeof x === "object" ? (
              x.NAME === "url" ? Css_AtomicTypes.Url.toString(x) : Css_AtomicTypes.Var.toString(x)
            ) : (
              x === "none" ? Css_AtomicTypes.ClipPath.toString(x) : (
                  x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : Css_AtomicTypes.GeometyBox.toString(x)
                )
            )
        };
}

function color(x) {
  return {
          TAG: /* D */0,
          _0: "color",
          _1: string_of_color(x)
        };
}

function columnCount(x) {
  var tmp;
  if (typeof x === "object") {
    var variant = x.NAME;
    tmp = variant === "var" || variant === "varDefault" ? Css_AtomicTypes.Var.toString(x) : Css_AtomicTypes.ColumnCount.toString(x);
  } else {
    tmp = x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : Css_AtomicTypes.ColumnCount.toString(x);
  }
  return {
          TAG: /* D */0,
          _0: "columnCount",
          _1: tmp
        };
}

function columnGap(x) {
  return {
          TAG: /* D */0,
          _0: "columnGap",
          _1: string_of_column_gap(x)
        };
}

function rowGap(x) {
  return {
          TAG: /* D */0,
          _0: "rowGap",
          _1: string_of_row_gap(x)
        };
}

function contentRule(x) {
  return {
          TAG: /* D */0,
          _0: "content",
          _1: string_of_content(x)
        };
}

function contentRules(xs) {
  return {
          TAG: /* D */0,
          _0: "content",
          _1: join(Belt_List.map(xs, string_of_content), " ")
        };
}

function counterIncrement(x) {
  return {
          TAG: /* D */0,
          _0: "counterIncrement",
          _1: string_of_counter_increment(x)
        };
}

function countersIncrement(xs) {
  return {
          TAG: /* D */0,
          _0: "counterIncrement",
          _1: join(Belt_List.map(xs, string_of_counter_increment), " ")
        };
}

function counterReset(x) {
  return {
          TAG: /* D */0,
          _0: "counterReset",
          _1: string_of_counter_reset(x)
        };
}

function countersReset(xs) {
  return {
          TAG: /* D */0,
          _0: "counterReset",
          _1: join(Belt_List.map(xs, string_of_counter_reset), " ")
        };
}

function counterSet(x) {
  return {
          TAG: /* D */0,
          _0: "counterSet",
          _1: string_of_counter_set(x)
        };
}

function countersSet(xs) {
  return {
          TAG: /* D */0,
          _0: "counterSet",
          _1: join(Belt_List.map(xs, string_of_counter_set), " ")
        };
}

function cursor(x) {
  return {
          TAG: /* D */0,
          _0: "cursor",
          _1: Css_AtomicTypes.Cursor.toString(x)
        };
}

function direction(x) {
  return {
          TAG: /* D */0,
          _0: "direction",
          _1: typeof x === "object" ? Css_AtomicTypes.Var.toString(x) : (
              x === "rtl" || x === "ltr" ? Css_AtomicTypes.Direction.toString(x) : Css_AtomicTypes.Cascading.toString(x)
            )
        };
}

function display(x) {
  return {
          TAG: /* D */0,
          _0: "display",
          _1: typeof x === "object" ? Css_AtomicTypes.Var.toString(x) : (
              x === "table" || x === "grid" || x === "flex" ? Css_AtomicTypes.DisplayInside.toString(x) : (
                  x === "contents" || x === "none" ? Css_AtomicTypes.DisplayBox.toString(x) : (
                      x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : (
                          x === "inlineGrid" || x === "inlineFlex" || x === "inlineBlock" || x === "inlineTable" ? Css_AtomicTypes.DisplayLegacy.toString(x) : (
                              x === "block" || x === "inline" || x === "runIn" ? Css_AtomicTypes.DisplayOutside.toString(x) : (
                                  x === "listItem" ? Css_AtomicTypes.DisplayListItem.toString(x) : Css_AtomicTypes.DisplayInternal.toString(x)
                                )
                            )
                        )
                    )
                )
            )
        };
}

function flex(x) {
  return {
          TAG: /* D */0,
          _0: "flex",
          _1: typeof x === "object" ? x.VAL.toString() : Css_AtomicTypes.Flex.toString(x)
        };
}

function flexDirection(x) {
  return {
          TAG: /* D */0,
          _0: "flexDirection",
          _1: typeof x === "object" ? Css_AtomicTypes.Var.toString(x) : (
              x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : Css_AtomicTypes.FlexDirection.toString(x)
            )
        };
}

function flexGrow(x) {
  return {
          TAG: /* D */0,
          _0: "flexGrow",
          _1: x.toString()
        };
}

function flexShrink(x) {
  return {
          TAG: /* D */0,
          _0: "flexShrink",
          _1: x.toString()
        };
}

function flexWrap(x) {
  return {
          TAG: /* D */0,
          _0: "flexWrap",
          _1: typeof x === "object" ? Css_AtomicTypes.Var.toString(x) : (
              x === "nowrap" || x === "wrapReverse" || x === "wrap" ? Css_AtomicTypes.FlexWrap.toString(x) : Css_AtomicTypes.Cascading.toString(x)
            )
        };
}

function $$float(x) {
  return {
          TAG: /* D */0,
          _0: "float",
          _1: typeof x === "object" ? Css_AtomicTypes.Var.toString(x) : (
              x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : Css_AtomicTypes.Float.toString(x)
            )
        };
}

function fontFamily(x) {
  return {
          TAG: /* D */0,
          _0: "fontFamily",
          _1: typeof x === "object" ? (
              x.NAME === "custom" ? Css_AtomicTypes.FontFamilyName.toString(x) : Css_AtomicTypes.Var.toString(x)
            ) : (
              x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : Css_AtomicTypes.FontFamilyName.toString(x)
            )
        };
}

function fontFamilies(xs) {
  return {
          TAG: /* D */0,
          _0: "fontFamily",
          _1: join(Belt_List.map(xs, Css_AtomicTypes.FontFamilyName.toString), ", ")
        };
}

function fontSize(x) {
  var tmp;
  if (typeof x === "object") {
    var variant = x.NAME;
    tmp = variant === "var" || variant === "varDefault" ? Css_AtomicTypes.Var.toString(x) : Css_AtomicTypes.Length.toString(x);
  } else {
    tmp = x === "zero" ? Css_AtomicTypes.Length.toString(x) : Css_AtomicTypes.Cascading.toString(x);
  }
  return {
          TAG: /* D */0,
          _0: "fontSize",
          _1: tmp
        };
}

function fontStyle(x) {
  return {
          TAG: /* D */0,
          _0: "fontStyle",
          _1: typeof x === "object" ? Css_AtomicTypes.Var.toString(x) : (
              x === "normal" || x === "oblique" || x === "italic" ? Css_AtomicTypes.FontStyle.toString(x) : Css_AtomicTypes.Cascading.toString(x)
            )
        };
}

function fontVariant(x) {
  return {
          TAG: /* D */0,
          _0: "fontVariant",
          _1: typeof x === "object" ? Css_AtomicTypes.Var.toString(x) : (
              x === "normal" || x === "smallCaps" ? Css_AtomicTypes.FontVariant.toString(x) : Css_AtomicTypes.Cascading.toString(x)
            )
        };
}

function fontWeight(x) {
  return {
          TAG: /* D */0,
          _0: "fontWeight",
          _1: typeof x === "object" ? (
              x.NAME === "num" ? Css_AtomicTypes.FontWeight.toString(x) : Css_AtomicTypes.Var.toString(x)
            ) : (
              x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : Css_AtomicTypes.FontWeight.toString(x)
            )
        };
}

function gridAutoFlow(x) {
  return {
          TAG: /* D */0,
          _0: "gridAutoFlow",
          _1: typeof x === "object" ? Css_AtomicTypes.Var.toString(x) : (
              x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : Css_AtomicTypes.GridAutoFlow.toString(x)
            )
        };
}

function gridColumn(start, end$p) {
  return {
          TAG: /* D */0,
          _0: "gridColumn",
          _1: start.toString() + (" / " + end$p.toString())
        };
}

function gridColumnGap(x) {
  return {
          TAG: /* D */0,
          _0: "gridColumnGap",
          _1: string_of_column_gap(x)
        };
}

function gridColumnStart(n) {
  return {
          TAG: /* D */0,
          _0: "gridColumnStart",
          _1: n.toString()
        };
}

function gridColumnEnd(n) {
  return {
          TAG: /* D */0,
          _0: "gridColumnEnd",
          _1: n.toString()
        };
}

function gridRow(start, end$p) {
  return {
          TAG: /* D */0,
          _0: "gridRow",
          _1: start.toString() + (" / " + end$p.toString())
        };
}

function gap(x) {
  return {
          TAG: /* D */0,
          _0: "gap",
          _1: string_of_gap(x)
        };
}

function gridGap(x) {
  return {
          TAG: /* D */0,
          _0: "gridGap",
          _1: string_of_gap(x)
        };
}

function gap2(rowGap, columnGap) {
  return {
          TAG: /* D */0,
          _0: "gap",
          _1: string_of_gap(rowGap) + (" " + string_of_gap(columnGap))
        };
}

function gridRowGap(x) {
  var tmp;
  if (typeof x === "object") {
    var variant = x.NAME;
    tmp = variant === "var" || variant === "varDefault" ? Css_AtomicTypes.Var.toString(x) : (
        variant === "percent" ? Css_AtomicTypes.Percentage.toString(x) : Css_AtomicTypes.Length.toString(x)
      );
  } else {
    tmp = x === "zero" ? Css_AtomicTypes.Length.toString(x) : Css_AtomicTypes.Cascading.toString(x);
  }
  return {
          TAG: /* D */0,
          _0: "gridRowGap",
          _1: tmp
        };
}

function gridRowEnd(n) {
  return {
          TAG: /* D */0,
          _0: "gridRowEnd",
          _1: n.toString()
        };
}

function gridRowStart(n) {
  return {
          TAG: /* D */0,
          _0: "gridRowStart",
          _1: n.toString()
        };
}

function height(x) {
  var tmp;
  if (typeof x === "object") {
    var variant = x.NAME;
    tmp = variant === "var" || variant === "varDefault" ? Css_AtomicTypes.Var.toString(x) : (
        variant === "percent" ? Css_AtomicTypes.Percentage.toString(x) : Css_AtomicTypes.Length.toString(x)
      );
  } else {
    tmp = x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : (
        x === "zero" ? Css_AtomicTypes.Length.toString(x) : Css_AtomicTypes.Height.toString(x)
      );
  }
  return {
          TAG: /* D */0,
          _0: "height",
          _1: tmp
        };
}

function justifyContent(x) {
  return {
          TAG: /* D */0,
          _0: "justifyContent",
          _1: typeof x === "object" ? Css_AtomicTypes.Var.toString(x) : (
              x === "spaceBetween" || x === "stretch" || x === "spaceAround" || x === "spaceEvenly" ? Css_AtomicTypes.DistributedAlignment.toString(x) : (
                  x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : (
                      x === "normal" ? Css_AtomicTypes.NormalAlignment.toString(x) : Css_AtomicTypes.PositionalAlignment.toString(x)
                    )
                )
            )
        };
}

function justifyItems(x) {
  var tmp;
  if (typeof x === "object") {
    var variant = x.NAME;
    tmp = variant === "var" || variant === "varDefault" ? Css_AtomicTypes.Var.toString(x) : Css_AtomicTypes.OverflowAlignment.toString(x);
  } else {
    tmp = x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : (
        x === "legacyRight" || x === "legacy" || x === "legacyLeft" || x === "legacyCenter" ? Css_AtomicTypes.LegacyAlignment.toString(x) : (
            x === "baseline" || x === "firstBaseline" || x === "lastBaseline" ? Css_AtomicTypes.BaselineAlignment.toString(x) : (
                x === "normal" ? Css_AtomicTypes.NormalAlignment.toString(x) : Css_AtomicTypes.PositionalAlignment.toString(x)
              )
          )
      );
  }
  return {
          TAG: /* D */0,
          _0: "justifyItems",
          _1: tmp
        };
}

function left(x) {
  return {
          TAG: /* D */0,
          _0: "left",
          _1: string_of_position(x)
        };
}

function letterSpacing(x) {
  var tmp;
  if (typeof x === "object") {
    var variant = x.NAME;
    tmp = variant === "var" || variant === "varDefault" ? Css_AtomicTypes.Var.toString(x) : Css_AtomicTypes.Length.toString(x);
  } else {
    tmp = x === "zero" ? Css_AtomicTypes.Length.toString(x) : (
        x === "normal" ? Css_AtomicTypes.LetterSpacing.toString(x) : Css_AtomicTypes.Cascading.toString(x)
      );
  }
  return {
          TAG: /* D */0,
          _0: "letterSpacing",
          _1: tmp
        };
}

function lineHeight(x) {
  var tmp;
  if (typeof x === "object") {
    var variant = x.NAME;
    tmp = variant === "var" || variant === "varDefault" ? Css_AtomicTypes.Var.toString(x) : (
        variant === "abs" ? Css_AtomicTypes.LineHeight.toString(x) : Css_AtomicTypes.Length.toString(x)
      );
  } else {
    tmp = x === "zero" ? Css_AtomicTypes.Length.toString(x) : (
        x === "normal" ? Css_AtomicTypes.LineHeight.toString(x) : Css_AtomicTypes.Cascading.toString(x)
      );
  }
  return {
          TAG: /* D */0,
          _0: "lineHeight",
          _1: tmp
        };
}

function listStyle(style, position, image) {
  return {
          TAG: /* D */0,
          _0: "listStyle",
          _1: Css_AtomicTypes.ListStyleType.toString(style) + (" " + (Css_AtomicTypes.ListStylePosition.toString(position) + (" " + (
                  typeof image === "object" ? Css_AtomicTypes.Url.toString(image) : Css_AtomicTypes.ListStyleImage.toString(image)
                ))))
        };
}

function listStyleImage(x) {
  return {
          TAG: /* D */0,
          _0: "listStyleImage",
          _1: typeof x === "object" ? (
              x.NAME === "url" ? Css_AtomicTypes.Url.toString(x) : Css_AtomicTypes.Var.toString(x)
            ) : (
              x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : Css_AtomicTypes.ListStyleImage.toString(x)
            )
        };
}

function listStyleType(x) {
  return {
          TAG: /* D */0,
          _0: "listStyleType",
          _1: typeof x === "object" ? Css_AtomicTypes.Var.toString(x) : (
              x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : Css_AtomicTypes.ListStyleType.toString(x)
            )
        };
}

function listStylePosition(x) {
  return {
          TAG: /* D */0,
          _0: "listStylePosition",
          _1: typeof x === "object" ? Css_AtomicTypes.Var.toString(x) : (
              x === "inside" || x === "outside" ? Css_AtomicTypes.ListStylePosition.toString(x) : Css_AtomicTypes.Cascading.toString(x)
            )
        };
}

function marginToString(x) {
  if (typeof x !== "object") {
    if (x === "unset" || x === "inherit_" || x === "initial") {
      return Css_AtomicTypes.Cascading.toString(x);
    } else if (x === "zero") {
      return Css_AtomicTypes.Length.toString(x);
    } else {
      return Css_AtomicTypes.Margin.toString(x);
    }
  }
  var variant = x.NAME;
  if (variant === "var" || variant === "varDefault") {
    return Css_AtomicTypes.Var.toString(x);
  } else {
    return Css_AtomicTypes.Length.toString(x);
  }
}

function margin(x) {
  return {
          TAG: /* D */0,
          _0: "margin",
          _1: marginToString(x)
        };
}

function margin2(v, h) {
  return {
          TAG: /* D */0,
          _0: "margin",
          _1: marginToString(v) + (" " + marginToString(h))
        };
}

function margin3(top, h, bottom) {
  return {
          TAG: /* D */0,
          _0: "margin",
          _1: marginToString(top) + (" " + (marginToString(h) + (" " + marginToString(bottom))))
        };
}

function margin4(top, right, bottom, left) {
  return {
          TAG: /* D */0,
          _0: "margin",
          _1: marginToString(top) + (" " + (marginToString(right) + (" " + (marginToString(bottom) + (" " + marginToString(left))))))
        };
}

function marginLeft(x) {
  return {
          TAG: /* D */0,
          _0: "marginLeft",
          _1: marginToString(x)
        };
}

function marginRight(x) {
  return {
          TAG: /* D */0,
          _0: "marginRight",
          _1: marginToString(x)
        };
}

function marginTop(x) {
  return {
          TAG: /* D */0,
          _0: "marginTop",
          _1: marginToString(x)
        };
}

function marginBottom(x) {
  return {
          TAG: /* D */0,
          _0: "marginBottom",
          _1: marginToString(x)
        };
}

function maxHeight(x) {
  var tmp;
  if (typeof x === "object") {
    var variant = x.NAME;
    tmp = variant === "var" || variant === "varDefault" ? Css_AtomicTypes.Var.toString(x) : (
        variant === "percent" ? Css_AtomicTypes.Percentage.toString(x) : Css_AtomicTypes.Length.toString(x)
      );
  } else {
    tmp = x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : (
        x === "zero" ? Css_AtomicTypes.Length.toString(x) : Css_AtomicTypes.MaxHeight.toString(x)
      );
  }
  return {
          TAG: /* D */0,
          _0: "maxHeight",
          _1: tmp
        };
}

function maxWidth(x) {
  var tmp;
  if (typeof x === "object") {
    var variant = x.NAME;
    tmp = variant === "var" || variant === "varDefault" ? Css_AtomicTypes.Var.toString(x) : (
        variant === "percent" ? Css_AtomicTypes.Percentage.toString(x) : Css_AtomicTypes.Length.toString(x)
      );
  } else {
    tmp = x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : (
        x === "zero" ? Css_AtomicTypes.Length.toString(x) : Css_AtomicTypes.MaxWidth.toString(x)
      );
  }
  return {
          TAG: /* D */0,
          _0: "maxWidth",
          _1: tmp
        };
}

function minHeight(x) {
  var tmp;
  if (typeof x === "object") {
    var variant = x.NAME;
    tmp = variant === "var" || variant === "varDefault" ? Css_AtomicTypes.Var.toString(x) : (
        variant === "percent" ? Css_AtomicTypes.Percentage.toString(x) : Css_AtomicTypes.Length.toString(x)
      );
  } else {
    tmp = x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : (
        x === "zero" ? Css_AtomicTypes.Length.toString(x) : Css_AtomicTypes.Height.toString(x)
      );
  }
  return {
          TAG: /* D */0,
          _0: "minHeight",
          _1: tmp
        };
}

function minWidth(x) {
  var tmp;
  if (typeof x === "object") {
    var variant = x.NAME;
    tmp = variant === "var" || variant === "varDefault" ? Css_AtomicTypes.Var.toString(x) : (
        variant === "percent" ? Css_AtomicTypes.Percentage.toString(x) : Css_AtomicTypes.Length.toString(x)
      );
  } else {
    tmp = x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : (
        x === "zero" ? Css_AtomicTypes.Length.toString(x) : Css_AtomicTypes.Width.toString(x)
      );
  }
  return {
          TAG: /* D */0,
          _0: "minWidth",
          _1: tmp
        };
}

function objectFit(x) {
  return {
          TAG: /* D */0,
          _0: "objectFit",
          _1: typeof x === "object" ? Css_AtomicTypes.Var.toString(x) : (
              x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : Css_AtomicTypes.ObjectFit.toString(x)
            )
        };
}

function objectPosition(x) {
  return {
          TAG: /* D */0,
          _0: "objectPosition",
          _1: string_of_backgroundposition(x)
        };
}

function opacity(x) {
  return {
          TAG: /* D */0,
          _0: "opacity",
          _1: x.toString()
        };
}

function outline(size, style, color) {
  return {
          TAG: /* D */0,
          _0: "outline",
          _1: Css_AtomicTypes.Length.toString(size) + (" " + (Css_AtomicTypes.OutlineStyle.toString(style) + (" " + string_of_color(color))))
        };
}

function outlineColor(x) {
  return {
          TAG: /* D */0,
          _0: "outlineColor",
          _1: string_of_color(x)
        };
}

function outlineOffset(x) {
  return {
          TAG: /* D */0,
          _0: "outlineOffset",
          _1: Css_AtomicTypes.Length.toString(x)
        };
}

function outlineStyle(x) {
  return {
          TAG: /* D */0,
          _0: "outlineStyle",
          _1: Css_AtomicTypes.OutlineStyle.toString(x)
        };
}

function outlineWidth(x) {
  return {
          TAG: /* D */0,
          _0: "outlineWidth",
          _1: Css_AtomicTypes.Length.toString(x)
        };
}

function overflow(x) {
  return {
          TAG: /* D */0,
          _0: "overflow",
          _1: Css_AtomicTypes.Overflow.toString(x)
        };
}

function overflowX(x) {
  return {
          TAG: /* D */0,
          _0: "overflowX",
          _1: Css_AtomicTypes.Overflow.toString(x)
        };
}

function overflowY(x) {
  return {
          TAG: /* D */0,
          _0: "overflowY",
          _1: Css_AtomicTypes.Overflow.toString(x)
        };
}

function overflowWrap(x) {
  return {
          TAG: /* D */0,
          _0: "overflowWrap",
          _1: typeof x === "object" ? Css_AtomicTypes.Var.toString(x) : (
              x === "breakWord" || x === "anywhere" || x === "normal" ? Css_AtomicTypes.OverflowWrap.toString(x) : Css_AtomicTypes.Cascading.toString(x)
            )
        };
}

function padding(x) {
  return {
          TAG: /* D */0,
          _0: "padding",
          _1: Css_AtomicTypes.Length.toString(x)
        };
}

function padding2(v, h) {
  return {
          TAG: /* D */0,
          _0: "padding",
          _1: Css_AtomicTypes.Length.toString(v) + (" " + Css_AtomicTypes.Length.toString(h))
        };
}

function padding3(top, h, bottom) {
  return {
          TAG: /* D */0,
          _0: "padding",
          _1: Css_AtomicTypes.Length.toString(top) + (" " + (Css_AtomicTypes.Length.toString(h) + (" " + Css_AtomicTypes.Length.toString(bottom))))
        };
}

function padding4(top, right, bottom, left) {
  return {
          TAG: /* D */0,
          _0: "padding",
          _1: Css_AtomicTypes.Length.toString(top) + (" " + (Css_AtomicTypes.Length.toString(right) + (" " + (Css_AtomicTypes.Length.toString(bottom) + (" " + Css_AtomicTypes.Length.toString(left))))))
        };
}

function paddingBottom(x) {
  return {
          TAG: /* D */0,
          _0: "paddingBottom",
          _1: Css_AtomicTypes.Length.toString(x)
        };
}

function paddingLeft(x) {
  return {
          TAG: /* D */0,
          _0: "paddingLeft",
          _1: Css_AtomicTypes.Length.toString(x)
        };
}

function paddingRight(x) {
  return {
          TAG: /* D */0,
          _0: "paddingRight",
          _1: Css_AtomicTypes.Length.toString(x)
        };
}

function paddingTop(x) {
  return {
          TAG: /* D */0,
          _0: "paddingTop",
          _1: Css_AtomicTypes.Length.toString(x)
        };
}

function perspective(x) {
  var tmp;
  if (typeof x === "object") {
    var variant = x.NAME;
    tmp = variant === "var" || variant === "varDefault" ? Css_AtomicTypes.Var.toString(x) : Css_AtomicTypes.Length.toString(x);
  } else {
    tmp = x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : (
        x === "zero" ? Css_AtomicTypes.Length.toString(x) : Css_AtomicTypes.Perspective.toString(x)
      );
  }
  return {
          TAG: /* D */0,
          _0: "perspective",
          _1: tmp
        };
}

function perspectiveOrigin(x, y) {
  return {
          TAG: /* D */0,
          _0: "perspectiveOrigin",
          _1: (
            typeof x === "object" || x === "zero" ? Css_AtomicTypes.Length.toString(x) : Css_AtomicTypes.Perspective.toString(x)
          ) + (" " + (
              typeof y === "object" || y === "zero" ? Css_AtomicTypes.Length.toString(y) : Css_AtomicTypes.Perspective.toString(y)
            ))
        };
}

function pointerEvents(x) {
  return {
          TAG: /* D */0,
          _0: "pointerEvents",
          _1: typeof x === "object" ? Css_AtomicTypes.Var.toString(x) : (
              x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : Css_AtomicTypes.PointerEvents.toString(x)
            )
        };
}

function position(x) {
  return {
          TAG: /* D */0,
          _0: "position",
          _1: typeof x === "object" ? Css_AtomicTypes.Var.toString(x) : (
              x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : Css_AtomicTypes.Position.toString(x)
            )
        };
}

function isolation(x) {
  return {
          TAG: /* D */0,
          _0: "isolation",
          _1: x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : Css_AtomicTypes.Isolation.toString(x)
        };
}

function justifySelf(x) {
  return {
          TAG: /* D */0,
          _0: "justifySelf",
          _1: typeof x === "object" ? Css_AtomicTypes.Var.toString(x) : (
              x === "selfStart" || x === "flexEnd" || x === "flexStart" || x === "center" || x === "start" || x === "selfEnd" || x === "right" || x === "left" || x === "end_" ? Css_AtomicTypes.PositionalAlignment.toString(x) : (
                  x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : (
                      x === "baseline" || x === "firstBaseline" || x === "lastBaseline" ? Css_AtomicTypes.BaselineAlignment.toString(x) : Css_AtomicTypes.JustifySelf.toString(x)
                    )
                )
            )
        };
}

function resize(x) {
  return {
          TAG: /* D */0,
          _0: "resize",
          _1: typeof x === "object" ? Css_AtomicTypes.Var.toString(x) : (
              x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : Css_AtomicTypes.Resize.toString(x)
            )
        };
}

function right(x) {
  return {
          TAG: /* D */0,
          _0: "right",
          _1: string_of_position(x)
        };
}

function tableLayout(x) {
  return {
          TAG: /* D */0,
          _0: "tableLayout",
          _1: typeof x === "object" ? Css_AtomicTypes.Var.toString(x) : (
              x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : Css_AtomicTypes.TableLayout.toString(x)
            )
        };
}

function textAlign(x) {
  return {
          TAG: /* D */0,
          _0: "textAlign",
          _1: typeof x === "object" ? Css_AtomicTypes.Var.toString(x) : (
              x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : Css_AtomicTypes.TextAlign.toString(x)
            )
        };
}

function textDecorationColor(x) {
  var tmp;
  if (typeof x === "object") {
    var variant = x.NAME;
    tmp = variant === "var" || variant === "varDefault" ? Css_AtomicTypes.Var.toString(x) : Css_AtomicTypes.Color.toString(x);
  } else {
    tmp = x === "transparent" || x === "currentColor" ? Css_AtomicTypes.Color.toString(x) : Css_AtomicTypes.Cascading.toString(x);
  }
  return {
          TAG: /* D */0,
          _0: "textDecorationColor",
          _1: tmp
        };
}

function textDecorationLine(x) {
  return {
          TAG: /* D */0,
          _0: "textDecorationLine",
          _1: typeof x === "object" ? Css_AtomicTypes.Var.toString(x) : (
              x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : Css_AtomicTypes.TextDecorationLine.toString(x)
            )
        };
}

function textDecorationStyle(x) {
  return {
          TAG: /* D */0,
          _0: "textDecorationStyle",
          _1: typeof x === "object" ? Css_AtomicTypes.Var.toString(x) : (
              x === "double" || x === "dotted" || x === "dashed" || x === "solid" || x === "wavy" ? Css_AtomicTypes.TextDecorationStyle.toString(x) : Css_AtomicTypes.Cascading.toString(x)
            )
        };
}

function textIndent(x) {
  var tmp;
  if (typeof x === "object") {
    var variant = x.NAME;
    tmp = variant === "var" || variant === "varDefault" ? Css_AtomicTypes.Var.toString(x) : (
        variant === "percent" ? Css_AtomicTypes.Percentage.toString(x) : Css_AtomicTypes.Length.toString(x)
      );
  } else {
    tmp = x === "zero" ? Css_AtomicTypes.Length.toString(x) : Css_AtomicTypes.Cascading.toString(x);
  }
  return {
          TAG: /* D */0,
          _0: "textIndent",
          _1: tmp
        };
}

function textOverflow(x) {
  return {
          TAG: /* D */0,
          _0: "textOverflow",
          _1: typeof x === "object" ? (
              x.NAME === "string" ? Css_AtomicTypes.TextOverflow.toString(x) : Css_AtomicTypes.Var.toString(x)
            ) : (
              x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : Css_AtomicTypes.TextOverflow.toString(x)
            )
        };
}

function textTransform(x) {
  return {
          TAG: /* D */0,
          _0: "textTransform",
          _1: typeof x === "object" ? Css_AtomicTypes.Var.toString(x) : (
              x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : Css_AtomicTypes.TextTransform.toString(x)
            )
        };
}

function top(x) {
  return {
          TAG: /* D */0,
          _0: "top",
          _1: string_of_position(x)
        };
}

function transform(x) {
  return {
          TAG: /* D */0,
          _0: "transform",
          _1: typeof x === "object" ? Css_AtomicTypes.Transform.toString(x) : "none"
        };
}

function transforms(x) {
  return {
          TAG: /* D */0,
          _0: "transform",
          _1: join(Belt_List.map(x, Css_AtomicTypes.Transform.toString), " ")
        };
}

function transformOrigin(x, y) {
  return {
          TAG: /* D */0,
          _0: "transformOrigin",
          _1: Css_AtomicTypes.Length.toString(x) + (" " + Css_AtomicTypes.Length.toString(y))
        };
}

function transformOrigin3d(x, y, z) {
  return {
          TAG: /* D */0,
          _0: "transformOrigin",
          _1: Css_AtomicTypes.Length.toString(x) + (" " + (Css_AtomicTypes.Length.toString(y) + (" " + (Css_AtomicTypes.Length.toString(z) + " "))))
        };
}

function unsafe(property, value) {
  return {
          TAG: /* D */0,
          _0: property,
          _1: value
        };
}

function userSelect(x) {
  return {
          TAG: /* D */0,
          _0: "userSelect",
          _1: typeof x === "object" ? Css_AtomicTypes.Var.toString(x) : (
              x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : Css_AtomicTypes.UserSelect.toString(x)
            )
        };
}

function verticalAlign(x) {
  var tmp;
  if (typeof x === "object") {
    var variant = x.NAME;
    tmp = variant === "var" || variant === "varDefault" ? Css_AtomicTypes.Var.toString(x) : Css_AtomicTypes.Length.toString(x);
  } else {
    tmp = x === "textTop" || x === "textBottom" || x === "baseline" || x === "super" || x === "top" || x === "sub" || x === "bottom" || x === "middle" ? Css_AtomicTypes.VerticalAlign.toString(x) : (
        x === "zero" ? Css_AtomicTypes.Length.toString(x) : Css_AtomicTypes.Cascading.toString(x)
      );
  }
  return {
          TAG: /* D */0,
          _0: "verticalAlign",
          _1: tmp
        };
}

function visibility(x) {
  return {
          TAG: /* D */0,
          _0: "visibility",
          _1: typeof x === "object" ? Css_AtomicTypes.Var.toString(x) : (
              x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : Css_AtomicTypes.Visibility.toString(x)
            )
        };
}

function scrollBehavior(x) {
  return {
          TAG: /* D */0,
          _0: "scrollBehavior",
          _1: typeof x === "object" ? Css_AtomicTypes.Var.toString(x) : (
              x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : Css_AtomicTypes.ScrollBehavior.toString(x)
            )
        };
}

function overscrollBehavior(x) {
  return {
          TAG: /* D */0,
          _0: "overscrollBehavior",
          _1: typeof x === "object" ? Css_AtomicTypes.Var.toString(x) : (
              x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : Css_AtomicTypes.OverscrollBehavior.toString(x)
            )
        };
}

function overflowAnchor(x) {
  return {
          TAG: /* D */0,
          _0: "overflowAnchor",
          _1: typeof x === "object" ? Css_AtomicTypes.Var.toString(x) : (
              x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : Css_AtomicTypes.OverflowAnchor.toString(x)
            )
        };
}

function columnWidth(x) {
  var tmp;
  if (typeof x === "object") {
    var variant = x.NAME;
    tmp = variant === "var" || variant === "varDefault" ? Css_AtomicTypes.Var.toString(x) : Css_AtomicTypes.Length.toString(x);
  } else {
    tmp = x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : (
        x === "zero" ? Css_AtomicTypes.Length.toString(x) : Css_AtomicTypes.ColumnWidth.toString(x)
      );
  }
  return {
          TAG: /* D */0,
          _0: "columnWidth",
          _1: tmp
        };
}

function caretColor(x) {
  var tmp;
  if (typeof x === "object") {
    var variant = x.NAME;
    tmp = variant === "var" || variant === "varDefault" ? Css_AtomicTypes.Var.toString(x) : Css_AtomicTypes.Color.toString(x);
  } else {
    tmp = x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : (
        x === "transparent" || x === "currentColor" ? Css_AtomicTypes.Color.toString(x) : Css_AtomicTypes.CaretColor.toString(x)
      );
  }
  return {
          TAG: /* D */0,
          _0: "caretColor",
          _1: tmp
        };
}

function width(x) {
  var tmp;
  if (typeof x === "object") {
    var variant = x.NAME;
    tmp = variant === "var" || variant === "varDefault" ? Css_AtomicTypes.Var.toString(x) : (
        variant === "percent" ? Css_AtomicTypes.Percentage.toString(x) : Css_AtomicTypes.Length.toString(x)
      );
  } else {
    tmp = x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : (
        x === "zero" ? Css_AtomicTypes.Length.toString(x) : Css_AtomicTypes.Width.toString(x)
      );
  }
  return {
          TAG: /* D */0,
          _0: "width",
          _1: tmp
        };
}

function whiteSpace(x) {
  return {
          TAG: /* D */0,
          _0: "whiteSpace",
          _1: typeof x === "object" ? Css_AtomicTypes.Var.toString(x) : (
              x === "nowrap" || x === "normal" || x === "breakSpaces" || x === "preWrap" || x === "preLine" || x === "pre" ? Css_AtomicTypes.WhiteSpace.toString(x) : Css_AtomicTypes.Cascading.toString(x)
            )
        };
}

function wordBreak(x) {
  return {
          TAG: /* D */0,
          _0: "wordBreak",
          _1: typeof x === "object" ? Css_AtomicTypes.Var.toString(x) : (
              x === "keepAll" || x === "normal" || x === "breakAll" ? Css_AtomicTypes.WordBreak.toString(x) : Css_AtomicTypes.Cascading.toString(x)
            )
        };
}

function wordSpacing(x) {
  var tmp;
  if (typeof x === "object") {
    var variant = x.NAME;
    tmp = variant === "var" || variant === "varDefault" ? Css_AtomicTypes.Var.toString(x) : (
        variant === "percent" ? Css_AtomicTypes.Percentage.toString(x) : Css_AtomicTypes.Length.toString(x)
      );
  } else {
    tmp = x === "zero" ? Css_AtomicTypes.Length.toString(x) : (
        x === "normal" ? Css_AtomicTypes.WordSpacing.toString(x) : Css_AtomicTypes.Cascading.toString(x)
      );
  }
  return {
          TAG: /* D */0,
          _0: "wordSpacing",
          _1: tmp
        };
}

function zIndex(x) {
  return {
          TAG: /* D */0,
          _0: "zIndex",
          _1: x.toString()
        };
}

function media(query, rules) {
  return {
          TAG: /* S */1,
          _0: "@media " + query,
          _1: rules
        };
}

function selector(selector$1, rules) {
  return {
          TAG: /* S */1,
          _0: selector$1,
          _1: rules
        };
}

function active(param) {
  return {
          TAG: /* PseudoClass */2,
          _0: "active",
          _1: param
        };
}

function checked(param) {
  return {
          TAG: /* PseudoClass */2,
          _0: "checked",
          _1: param
        };
}

function $$default(param) {
  return {
          TAG: /* PseudoClass */2,
          _0: "default",
          _1: param
        };
}

function defined(param) {
  return {
          TAG: /* PseudoClass */2,
          _0: "defined",
          _1: param
        };
}

function disabled(param) {
  return {
          TAG: /* PseudoClass */2,
          _0: "disabled",
          _1: param
        };
}

function empty(param) {
  return {
          TAG: /* PseudoClass */2,
          _0: "empty",
          _1: param
        };
}

function enabled(param) {
  return {
          TAG: /* PseudoClass */2,
          _0: "enabled",
          _1: param
        };
}

function first(param) {
  return {
          TAG: /* PseudoClass */2,
          _0: "first",
          _1: param
        };
}

function firstChild(param) {
  return {
          TAG: /* PseudoClass */2,
          _0: "first-child",
          _1: param
        };
}

function firstOfType(param) {
  return {
          TAG: /* PseudoClass */2,
          _0: "first-of-type",
          _1: param
        };
}

function focus(param) {
  return {
          TAG: /* PseudoClass */2,
          _0: "focus",
          _1: param
        };
}

function focusVisible(param) {
  return {
          TAG: /* PseudoClass */2,
          _0: "focus-visible",
          _1: param
        };
}

function focusWithin(param) {
  return {
          TAG: /* PseudoClass */2,
          _0: "focus-within",
          _1: param
        };
}

function host(selector, rules) {
  if (selector !== undefined) {
    return {
            TAG: /* PseudoClassParam */3,
            _0: "host",
            _1: selector,
            _2: rules
          };
  } else {
    return {
            TAG: /* PseudoClass */2,
            _0: "host",
            _1: rules
          };
  }
}

function hover(param) {
  return {
          TAG: /* PseudoClass */2,
          _0: "hover",
          _1: param
        };
}

function indeterminate(param) {
  return {
          TAG: /* PseudoClass */2,
          _0: "indeterminate",
          _1: param
        };
}

function inRange(param) {
  return {
          TAG: /* PseudoClass */2,
          _0: "in-range",
          _1: param
        };
}

function invalid(param) {
  return {
          TAG: /* PseudoClass */2,
          _0: "invalid",
          _1: param
        };
}

function lang(code, rules) {
  return {
          TAG: /* PseudoClassParam */3,
          _0: "lang",
          _1: code,
          _2: rules
        };
}

function lastChild(param) {
  return {
          TAG: /* PseudoClass */2,
          _0: "last-child",
          _1: param
        };
}

function lastOfType(param) {
  return {
          TAG: /* PseudoClass */2,
          _0: "last-of-type",
          _1: param
        };
}

function link(param) {
  return {
          TAG: /* PseudoClass */2,
          _0: "link",
          _1: param
        };
}

function not__(selector, rules) {
  return {
          TAG: /* PseudoClassParam */3,
          _0: "not",
          _1: selector,
          _2: rules
        };
}

function toString(param) {
  if (typeof param !== "object") {
    if (param === "odd") {
      return "odd";
    } else {
      return "even";
    }
  }
  if (param.NAME !== "add") {
    return param.VAL.toString() + "n";
  }
  var match = param.VAL;
  return match[0].toString() + ("n+" + match[1].toString());
}

var Nth = {
  toString: toString
};

function nthChild(x, rules) {
  return {
          TAG: /* PseudoClassParam */3,
          _0: "nth-child",
          _1: toString(x),
          _2: rules
        };
}

function nthLastChild(x, rules) {
  return {
          TAG: /* PseudoClassParam */3,
          _0: "nth-last-child",
          _1: toString(x),
          _2: rules
        };
}

function nthLastOfType(x, rules) {
  return {
          TAG: /* PseudoClassParam */3,
          _0: "nth-last-of-type",
          _1: toString(x),
          _2: rules
        };
}

function nthOfType(x, rules) {
  return {
          TAG: /* PseudoClassParam */3,
          _0: "nth-of-type",
          _1: toString(x),
          _2: rules
        };
}

function onlyChild(param) {
  return {
          TAG: /* PseudoClass */2,
          _0: "only-child",
          _1: param
        };
}

function onlyOfType(param) {
  return {
          TAG: /* PseudoClass */2,
          _0: "only-of-type",
          _1: param
        };
}

function optional(param) {
  return {
          TAG: /* PseudoClass */2,
          _0: "optional",
          _1: param
        };
}

function outOfRange(param) {
  return {
          TAG: /* PseudoClass */2,
          _0: "out-of-range",
          _1: param
        };
}

function readOnly(param) {
  return {
          TAG: /* PseudoClass */2,
          _0: "read-only",
          _1: param
        };
}

function readWrite(param) {
  return {
          TAG: /* PseudoClass */2,
          _0: "read-write",
          _1: param
        };
}

function required(param) {
  return {
          TAG: /* PseudoClass */2,
          _0: "required",
          _1: param
        };
}

function root(param) {
  return {
          TAG: /* PseudoClass */2,
          _0: "root",
          _1: param
        };
}

function scope(param) {
  return {
          TAG: /* PseudoClass */2,
          _0: "scope",
          _1: param
        };
}

function target(param) {
  return {
          TAG: /* PseudoClass */2,
          _0: "target",
          _1: param
        };
}

function valid(param) {
  return {
          TAG: /* PseudoClass */2,
          _0: "valid",
          _1: param
        };
}

function visited(param) {
  return {
          TAG: /* PseudoClass */2,
          _0: "visited",
          _1: param
        };
}

function after(param) {
  return {
          TAG: /* S */1,
          _0: "::after",
          _1: param
        };
}

function before(param) {
  return {
          TAG: /* S */1,
          _0: "::before",
          _1: param
        };
}

function firstLetter(param) {
  return {
          TAG: /* S */1,
          _0: "::first-letter",
          _1: param
        };
}

function firstLine(param) {
  return {
          TAG: /* S */1,
          _0: "::first-line",
          _1: param
        };
}

function selection(param) {
  return {
          TAG: /* S */1,
          _0: "::selection",
          _1: param
        };
}

function child(x) {
  var partial_arg = " > " + x;
  return function (param) {
    return {
            TAG: /* S */1,
            _0: partial_arg,
            _1: param
          };
  };
}

function children(param) {
  return {
          TAG: /* S */1,
          _0: " > *",
          _1: param
        };
}

function directSibling(param) {
  return {
          TAG: /* S */1,
          _0: " + ",
          _1: param
        };
}

function placeholder(param) {
  return {
          TAG: /* S */1,
          _0: "::placeholder",
          _1: param
        };
}

function siblings(param) {
  return {
          TAG: /* S */1,
          _0: " ~ ",
          _1: param
        };
}

function anyLink(param) {
  return {
          TAG: /* S */1,
          _0: ":any-link",
          _1: param
        };
}

var initial = Css_AtomicTypes.Cascading.initial;

var inherit_ = Css_AtomicTypes.Cascading.inherit_;

var unset = Css_AtomicTypes.Cascading.unset;

var $$var = Css_AtomicTypes.Var.$$var;

var varDefault = Css_AtomicTypes.Var.varDefault;

var pct = Css_AtomicTypes.Percentage.pct;

var ch = Css_AtomicTypes.Length.ch;

var cm = Css_AtomicTypes.Length.cm;

var em = Css_AtomicTypes.Length.em;

var ex = Css_AtomicTypes.Length.ex;

var mm = Css_AtomicTypes.Length.mm;

var pt = Css_AtomicTypes.Length.pt;

var px = Css_AtomicTypes.Length.px;

var pxFloat = Css_AtomicTypes.Length.pxFloat;

var rem = Css_AtomicTypes.Length.rem;

var vh = Css_AtomicTypes.Length.vh;

var vmin = Css_AtomicTypes.Length.vmin;

var vmax = Css_AtomicTypes.Length.vmax;

var zero = Css_AtomicTypes.Length.zero;

var deg = Css_AtomicTypes.Angle.deg;

var rad = Css_AtomicTypes.Angle.rad;

var grad = Css_AtomicTypes.Angle.grad;

var turn = Css_AtomicTypes.Angle.turn;

var ltr = Css_AtomicTypes.Direction.ltr;

var rtl = Css_AtomicTypes.Direction.rtl;

var absolute = Css_AtomicTypes.Position.absolute;

var relative = Css_AtomicTypes.Position.relative;

var $$static = Css_AtomicTypes.Position.$$static;

var sticky = Css_AtomicTypes.Position.sticky;

var horizontal = Css_AtomicTypes.Resize.horizontal;

var vertical = Css_AtomicTypes.Resize.vertical;

var smallCaps = Css_AtomicTypes.FontVariant.smallCaps;

var italic = Css_AtomicTypes.FontStyle.italic;

var oblique = Css_AtomicTypes.FontStyle.oblique;

var rgb = Css_AtomicTypes.Color.rgb;

var rgba = Css_AtomicTypes.Color.rgba;

var hsl = Css_AtomicTypes.Color.hsl;

var hsla = Css_AtomicTypes.Color.hsla;

var hex = Css_AtomicTypes.Color.hex;

var currentColor = Css_AtomicTypes.Color.currentColor;

var transparent = Css_AtomicTypes.Color.transparent;

var linear = Css_AtomicTypes.TimingFunction.linear;

var ease = Css_AtomicTypes.TimingFunction.ease;

var easeIn = Css_AtomicTypes.TimingFunction.easeIn;

var easeInOut = Css_AtomicTypes.TimingFunction.easeInOut;

var easeOut = Css_AtomicTypes.TimingFunction.easeOut;

var stepStart = Css_AtomicTypes.TimingFunction.stepStart;

var stepEnd = Css_AtomicTypes.TimingFunction.stepEnd;

var steps = Css_AtomicTypes.TimingFunction.steps;

var cubicBezier = Css_AtomicTypes.TimingFunction.cubicBezier;

var marginBox = Css_AtomicTypes.GeometyBox.marginBox;

var fillBox = Css_AtomicTypes.GeometyBox.fillBox;

var strokeBox = Css_AtomicTypes.GeometyBox.strokeBox;

var viewBox = Css_AtomicTypes.GeometyBox.viewBox;

var translate = Css_AtomicTypes.Transform.translate;

var translate3d = Css_AtomicTypes.Transform.translate3d;

var translateX = Css_AtomicTypes.Transform.translateX;

var translateY = Css_AtomicTypes.Transform.translateY;

var translateZ = Css_AtomicTypes.Transform.translateZ;

var scaleX = Css_AtomicTypes.Transform.scaleX;

var scaleY = Css_AtomicTypes.Transform.scaleY;

var scaleZ = Css_AtomicTypes.Transform.scaleZ;

var rotateX = Css_AtomicTypes.Transform.rotateX;

var rotateY = Css_AtomicTypes.Transform.rotateY;

var rotateZ = Css_AtomicTypes.Transform.rotateZ;

var scale = Css_AtomicTypes.Transform.scale;

var scale3d = Css_AtomicTypes.Transform.scale3d;

var skew = Css_AtomicTypes.Transform.skew;

var skewX = Css_AtomicTypes.Transform.skewX;

var skewY = Css_AtomicTypes.Transform.skewY;

var thin = Css_AtomicTypes.FontWeight.thin;

var extraLight = Css_AtomicTypes.FontWeight.extraLight;

var light = Css_AtomicTypes.FontWeight.light;

var medium = Css_AtomicTypes.FontWeight.medium;

var semiBold = Css_AtomicTypes.FontWeight.semiBold;

var bold = Css_AtomicTypes.FontWeight.bold;

var extraBold = Css_AtomicTypes.FontWeight.extraBold;

var lighter = Css_AtomicTypes.FontWeight.lighter;

var bolder = Css_AtomicTypes.FontWeight.bolder;

var linearGradient = Css_AtomicTypes.Gradient.linearGradient;

var repeatingLinearGradient = Css_AtomicTypes.Gradient.repeatingLinearGradient;

var radialGradient = Css_AtomicTypes.Gradient.radialGradient;

var repeatingRadialGradient = Css_AtomicTypes.Gradient.repeatingRadialGradient;

var conicGradient = Css_AtomicTypes.Gradient.conicGradient;

var areas = Css_AtomicTypes.GridTemplateAreas.areas;

var ident = Css_AtomicTypes.GridArea.ident;

var numIdent = Css_AtomicTypes.GridArea.numIdent;

var contextMenu = Css_AtomicTypes.Cursor.contextMenu;

var help = Css_AtomicTypes.Cursor.help;

var pointer = Css_AtomicTypes.Cursor.pointer;

var progress = Css_AtomicTypes.Cursor.progress;

var wait = Css_AtomicTypes.Cursor.wait;

var cell = Css_AtomicTypes.Cursor.cell;

var crosshair = Css_AtomicTypes.Cursor.crosshair;

var verticalText = Css_AtomicTypes.Cursor.verticalText;

var alias = Css_AtomicTypes.Cursor.alias;

var copy = Css_AtomicTypes.Cursor.copy;

var move = Css_AtomicTypes.Cursor.move;

var noDrop = Css_AtomicTypes.Cursor.noDrop;

var notAllowed = Css_AtomicTypes.Cursor.notAllowed;

var grab = Css_AtomicTypes.Cursor.grab;

var grabbing = Css_AtomicTypes.Cursor.grabbing;

var allScroll = Css_AtomicTypes.Cursor.allScroll;

var colResize = Css_AtomicTypes.Cursor.colResize;

var rowResize = Css_AtomicTypes.Cursor.rowResize;

var nResize = Css_AtomicTypes.Cursor.nResize;

var eResize = Css_AtomicTypes.Cursor.eResize;

var sResize = Css_AtomicTypes.Cursor.sResize;

var wResize = Css_AtomicTypes.Cursor.wResize;

var neResize = Css_AtomicTypes.Cursor.neResize;

var nwResize = Css_AtomicTypes.Cursor.nwResize;

var seResize = Css_AtomicTypes.Cursor.seResize;

var swResize = Css_AtomicTypes.Cursor.swResize;

var ewResize = Css_AtomicTypes.Cursor.ewResize;

var nsResize = Css_AtomicTypes.Cursor.nsResize;

var neswResize = Css_AtomicTypes.Cursor.neswResize;

var nwseResize = Css_AtomicTypes.Cursor.nwseResize;

var zoomIn = Css_AtomicTypes.Cursor.zoomIn;

var zoomOut = Css_AtomicTypes.Cursor.zoomOut;

function vw(x) {
  return {
          NAME: "vw",
          VAL: x
        };
}

function fr(x) {
  return {
          NAME: "fr",
          VAL: x
        };
}

function $neg(a, b) {
  return {
          NAME: "calc",
          VAL: [
            "sub",
            a,
            b
          ]
        };
}

function $plus(a, b) {
  return {
          NAME: "calc",
          VAL: [
            "add",
            a,
            b
          ]
        };
}

var Calc = {
  $neg: $neg,
  $plus: $plus
};

function size(x, y) {
  return {
          NAME: "size",
          VAL: [
            x,
            y
          ]
        };
}

function count(x) {
  return {
          NAME: "count",
          VAL: x
        };
}

function localUrl(x) {
  return {
          NAME: "localUrl",
          VAL: x
        };
}

function rotate(a) {
  return {
          NAME: "rotate",
          VAL: a
        };
}

function rotate3d(x, y, z, a) {
  return {
          NAME: "rotate3d",
          VAL: [
            x,
            y,
            z,
            a
          ]
        };
}

function url(x) {
  return {
          NAME: "url",
          VAL: x
        };
}

function flex3(grow, shrink, basis) {
  return {
          TAG: /* D */0,
          _0: "flex",
          _1: grow.toString() + (" " + (shrink.toString() + (" " + (
                  typeof basis === "object" || basis === "zero" ? Css_AtomicTypes.Length.toString(basis) : Css_AtomicTypes.FlexBasis.toString(basis)
                ))))
        };
}

function flexBasis(x) {
  return {
          TAG: /* D */0,
          _0: "flexBasis",
          _1: typeof x === "object" || x === "zero" ? Css_AtomicTypes.Length.toString(x) : Css_AtomicTypes.FlexBasis.toString(x)
        };
}

function order(x) {
  return {
          TAG: /* D */0,
          _0: "order",
          _1: x.toString()
        };
}

function string_of_minmax(param) {
  if (typeof param !== "object") {
    if (param === "zero") {
      return "0";
    } else if (param === "minContent") {
      return "min-content";
    } else if (param === "maxContent") {
      return "max-content";
    } else {
      return "auto";
    }
  }
  var variant = param.NAME;
  if (variant === "pxFloat") {
    return param.VAL.toString() + "px";
  }
  if (variant === "inch") {
    return param.VAL.toString() + "in";
  }
  if (variant === "vmax") {
    return param.VAL.toString() + "vmax";
  }
  if (variant === "vmin") {
    return param.VAL.toString() + "vmin";
  }
  if (variant === "percent") {
    return param.VAL.toString() + "%";
  }
  if (variant === "ch") {
    return param.VAL.toString() + "ch";
  }
  if (variant === "cm") {
    return param.VAL.toString() + "cm";
  }
  if (variant === "em") {
    return param.VAL.toString() + "em";
  }
  if (variant === "ex") {
    return param.VAL.toString() + "ex";
  }
  if (variant === "fr") {
    return param.VAL.toString() + "fr";
  }
  if (variant === "mm") {
    return param.VAL.toString() + "mm";
  }
  if (variant === "pc") {
    return param.VAL.toString() + "pc";
  }
  if (variant === "pt") {
    return param.VAL.toString() + "pt";
  }
  if (variant === "px") {
    return param.VAL.toString() + "px";
  }
  if (variant === "vh") {
    return param.VAL.toString() + "vh";
  }
  if (variant === "vw") {
    return param.VAL.toString() + "vw";
  }
  if (variant === "rem") {
    return param.VAL.toString() + "rem";
  }
  var match = param.VAL;
  if (match[0] === "sub") {
    return "calc(" + (Css_AtomicTypes.Length.toString(match[1]) + (" - " + (Css_AtomicTypes.Length.toString(match[2]) + ")")));
  } else {
    return "calc(" + (Css_AtomicTypes.Length.toString(match[1]) + (" + " + (Css_AtomicTypes.Length.toString(match[2]) + ")")));
  }
}

function string_of_dimension(param) {
  if (typeof param !== "object") {
    if (param === "none") {
      return "none";
    } else if (param === "zero") {
      return "0";
    } else if (param === "minContent") {
      return "min-content";
    } else if (param === "fitContent") {
      return "fit-content";
    } else if (param === "maxContent") {
      return "max-content";
    } else {
      return "auto";
    }
  }
  var variant = param.NAME;
  if (variant === "pxFloat") {
    return param.VAL.toString() + "px";
  }
  if (variant === "inch") {
    return param.VAL.toString() + "in";
  }
  if (variant === "vmax") {
    return param.VAL.toString() + "vmax";
  }
  if (variant === "vmin") {
    return param.VAL.toString() + "vmin";
  }
  if (variant === "minmax") {
    var match = param.VAL;
    return "minmax(" + (string_of_minmax(match[0]) + ("," + (string_of_minmax(match[1]) + ")")));
  }
  if (variant === "percent") {
    return param.VAL.toString() + "%";
  }
  if (variant === "ch") {
    return param.VAL.toString() + "ch";
  }
  if (variant === "cm") {
    return param.VAL.toString() + "cm";
  }
  if (variant === "em") {
    return param.VAL.toString() + "em";
  }
  if (variant === "ex") {
    return param.VAL.toString() + "ex";
  }
  if (variant === "fr") {
    return param.VAL.toString() + "fr";
  }
  if (variant === "mm") {
    return param.VAL.toString() + "mm";
  }
  if (variant === "pc") {
    return param.VAL.toString() + "pc";
  }
  if (variant === "pt") {
    return param.VAL.toString() + "pt";
  }
  if (variant === "px") {
    return param.VAL.toString() + "px";
  }
  if (variant === "vh") {
    return param.VAL.toString() + "vh";
  }
  if (variant === "vw") {
    return param.VAL.toString() + "vw";
  }
  if (variant === "rem") {
    return param.VAL.toString() + "rem";
  }
  var match$1 = param.VAL;
  if (match$1[0] === "sub") {
    return "calc(" + (Css_AtomicTypes.Length.toString(match$1[1]) + (" - " + (Css_AtomicTypes.Length.toString(match$1[2]) + ")")));
  } else {
    return "calc(" + (Css_AtomicTypes.Length.toString(match$1[1]) + (" + " + (Css_AtomicTypes.Length.toString(match$1[2]) + ")")));
  }
}

function gridLengthToJs(param) {
  if (typeof param !== "object") {
    if (param === "zero") {
      return "0";
    } else if (param === "minContent") {
      return "min-content";
    } else if (param === "maxContent") {
      return "max-content";
    } else {
      return "auto";
    }
  }
  var variant = param.NAME;
  if (variant === "pxFloat") {
    return param.VAL.toString() + "px";
  }
  if (variant === "inch") {
    return param.VAL.toString() + "in";
  }
  if (variant === "vmax") {
    return param.VAL.toString() + "vmax";
  }
  if (variant === "vmin") {
    return param.VAL.toString() + "vmin";
  }
  if (variant === "minmax") {
    var match = param.VAL;
    return "minmax(" + (string_of_minmax(match[0]) + ("," + (string_of_minmax(match[1]) + ")")));
  }
  if (variant === "percent") {
    return param.VAL.toString() + "%";
  }
  if (variant === "ch") {
    return param.VAL.toString() + "ch";
  }
  if (variant === "cm") {
    return param.VAL.toString() + "cm";
  }
  if (variant === "em") {
    return param.VAL.toString() + "em";
  }
  if (variant === "ex") {
    return param.VAL.toString() + "ex";
  }
  if (variant === "fr") {
    return param.VAL.toString() + "fr";
  }
  if (variant === "mm") {
    return param.VAL.toString() + "mm";
  }
  if (variant === "pc") {
    return param.VAL.toString() + "pc";
  }
  if (variant === "pt") {
    return param.VAL.toString() + "pt";
  }
  if (variant === "px") {
    return param.VAL.toString() + "px";
  }
  if (variant === "vh") {
    return param.VAL.toString() + "vh";
  }
  if (variant === "vw") {
    return param.VAL.toString() + "vw";
  }
  if (variant === "rem") {
    return param.VAL.toString() + "rem";
  }
  if (variant === "repeat") {
    var match$1 = param.VAL;
    return "repeat(" + (Css_AtomicTypes.RepeatValue.toString(match$1[0]) + (", " + (string_of_dimension(match$1[1]) + ")")));
  }
  var match$2 = param.VAL;
  if (match$2[0] === "sub") {
    return "calc(" + (Css_AtomicTypes.Length.toString(match$2[1]) + (" - " + (Css_AtomicTypes.Length.toString(match$2[2]) + ")")));
  } else {
    return "calc(" + (Css_AtomicTypes.Length.toString(match$2[1]) + (" + " + (Css_AtomicTypes.Length.toString(match$2[2]) + ")")));
  }
}

function string_of_dimensions(dimensions) {
  return $$String.concat(" ", List.map(gridLengthToJs, dimensions));
}

function gridTemplateColumns(dimensions) {
  return {
          TAG: /* D */0,
          _0: "gridTemplateColumns",
          _1: string_of_dimensions(dimensions)
        };
}

function gridTemplateRows(dimensions) {
  return {
          TAG: /* D */0,
          _0: "gridTemplateRows",
          _1: string_of_dimensions(dimensions)
        };
}

function gridAutoColumns(dimensions) {
  return {
          TAG: /* D */0,
          _0: "gridAutoColumns",
          _1: string_of_dimension(dimensions)
        };
}

function gridAutoRows(dimensions) {
  return {
          TAG: /* D */0,
          _0: "gridAutoRows",
          _1: string_of_dimension(dimensions)
        };
}

function gridArea(s) {
  var tmp;
  if (typeof s === "object") {
    var variant = s.NAME;
    tmp = variant === "var" || variant === "varDefault" ? Css_AtomicTypes.Var.toString(s) : Css_AtomicTypes.GridArea.toString(s);
  } else {
    tmp = s === "unset" || s === "inherit_" || s === "initial" ? Css_AtomicTypes.Cascading.toString(s) : Css_AtomicTypes.GridArea.toString(s);
  }
  return {
          TAG: /* D */0,
          _0: "gridArea",
          _1: tmp
        };
}

function gridArea2(s, s2) {
  return {
          TAG: /* D */0,
          _0: "gridArea",
          _1: Css_AtomicTypes.GridArea.toString(s) + (" / " + Css_AtomicTypes.GridArea.toString(s2))
        };
}

function gridArea3(s, s2, s3) {
  return {
          TAG: /* D */0,
          _0: "gridArea",
          _1: Css_AtomicTypes.GridArea.toString(s) + (" / " + (Css_AtomicTypes.GridArea.toString(s2) + (" / " + Css_AtomicTypes.GridArea.toString(s3))))
        };
}

function gridArea4(s, s2, s3, s4) {
  return {
          TAG: /* D */0,
          _0: "gridArea",
          _1: Css_AtomicTypes.GridArea.toString(s) + (" / " + (Css_AtomicTypes.GridArea.toString(s2) + (" / " + (Css_AtomicTypes.GridArea.toString(s3) + (" / " + Css_AtomicTypes.GridArea.toString(s4))))))
        };
}

function gridTemplateAreas(l) {
  return {
          TAG: /* D */0,
          _0: "gridTemplateAreas",
          _1: typeof l === "object" ? (
              l.NAME === "areas" ? Css_AtomicTypes.GridTemplateAreas.toString(l) : Css_AtomicTypes.Var.toString(l)
            ) : (
              l === "unset" || l === "inherit_" || l === "initial" ? Css_AtomicTypes.Cascading.toString(l) : Css_AtomicTypes.GridTemplateAreas.toString(l)
            )
        };
}

function string_of_filter(u) {
  if (typeof u !== "object") {
    if (u === "unset" || u === "inherit_" || u === "initial") {
      return Css_AtomicTypes.Cascading.toString(u);
    } else {
      return "none";
    }
  }
  var variant = u.NAME;
  if (variant !== "dropShadow") {
    if (variant === "brightness") {
      return "brightness(" + (u.VAL.toString() + "%)");
    } else if (variant === "opacity") {
      return "opacity(" + (u.VAL.toString() + "%)");
    } else if (variant === "var" || variant === "varDefault") {
      return Css_AtomicTypes.Var.toString(u);
    } else if (variant === "grayscale") {
      return "grayscale(" + (u.VAL.toString() + "%)");
    } else if (variant === "sepia") {
      return "sepia(" + (u.VAL.toString() + "%)");
    } else if (variant === "saturate") {
      return "saturate(" + (u.VAL.toString() + "%)");
    } else if (variant === "url") {
      return Css_AtomicTypes.Url.toString(u);
    } else if (variant === "invert") {
      return "invert(" + (u.VAL.toString() + "%)");
    } else if (variant === "contrast") {
      return "contrast(" + (u.VAL.toString() + "%)");
    } else if (variant === "hueRotate") {
      return "hue-rotate(" + (Css_AtomicTypes.Angle.toString(u.VAL) + ")");
    } else {
      return "blur(" + (Css_AtomicTypes.Length.toString(u.VAL) + ")");
    }
  }
  var match = u.VAL;
  return "drop-shadow(" + (Css_AtomicTypes.Length.toString(match[0]) + (" " + (Css_AtomicTypes.Length.toString(match[1]) + (" " + (Css_AtomicTypes.Length.toString(match[2]) + (" " + (Css_AtomicTypes.Color.toString(match[3]) + ")")))))));
}

function filter(x) {
  return {
          TAG: /* D */0,
          _0: "filter",
          _1: join(Belt_List.map(x, string_of_filter), " ")
        };
}

function box(xOpt, yOpt, blurOpt, spreadOpt, insetOpt, color) {
  var x = xOpt !== undefined ? xOpt : zero;
  var y = yOpt !== undefined ? yOpt : zero;
  var blur = blurOpt !== undefined ? blurOpt : zero;
  var spread = spreadOpt !== undefined ? spreadOpt : zero;
  var inset = insetOpt !== undefined ? insetOpt : false;
  return {
          NAME: "shadow",
          VAL: Css_AtomicTypes.Length.toString(x) + (" " + (Css_AtomicTypes.Length.toString(y) + (" " + (Css_AtomicTypes.Length.toString(blur) + (" " + (Css_AtomicTypes.Length.toString(spread) + (" " + (string_of_color(color) + (
                            inset ? " inset" : ""
                          )))))))))
        };
}

function text(xOpt, yOpt, blurOpt, color) {
  var x = xOpt !== undefined ? xOpt : zero;
  var y = yOpt !== undefined ? yOpt : zero;
  var blur = blurOpt !== undefined ? blurOpt : zero;
  return {
          NAME: "shadow",
          VAL: Css_AtomicTypes.Length.toString(x) + (" " + (Css_AtomicTypes.Length.toString(y) + (" " + (Css_AtomicTypes.Length.toString(blur) + (" " + string_of_color(color))))))
        };
}

function toString$1(param) {
  if (typeof param === "object") {
    return param.VAL;
  } else {
    return "none";
  }
}

var Shadow = {
  box: box,
  text: text,
  toString: toString$1
};

function boxShadow(x) {
  return {
          TAG: /* D */0,
          _0: "boxShadow",
          _1: typeof x === "object" ? (
              x.NAME === "shadow" ? toString$1(x) : Css_AtomicTypes.Var.toString(x)
            ) : (
              x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : toString$1(x)
            )
        };
}

function boxShadows(x) {
  return {
          TAG: /* D */0,
          _0: "boxShadow",
          _1: join(Belt_List.map(x, toString$1), ", ")
        };
}

function string_of_borderstyle(b) {
  if (typeof b === "object") {
    return Css_AtomicTypes.Var.toString(b);
  } else if (b === "unset" || b === "inherit_" || b === "initial") {
    return Css_AtomicTypes.Cascading.toString(b);
  } else {
    return Css_AtomicTypes.BorderStyle.toString(b);
  }
}

function border(px, style, color) {
  return {
          TAG: /* D */0,
          _0: "border",
          _1: Css_AtomicTypes.Length.toString(px) + (" " + (string_of_borderstyle(style) + (" " + string_of_color(color))))
        };
}

function borderStyle(x) {
  return {
          TAG: /* D */0,
          _0: "borderStyle",
          _1: string_of_borderstyle(x)
        };
}

function borderLeft(px, style, color) {
  return {
          TAG: /* D */0,
          _0: "borderLeft",
          _1: Css_AtomicTypes.Length.toString(px) + (" " + (string_of_borderstyle(style) + (" " + string_of_color(color))))
        };
}

function borderLeftStyle(x) {
  return {
          TAG: /* D */0,
          _0: "borderLeftStyle",
          _1: string_of_borderstyle(x)
        };
}

function borderRight(px, style, color) {
  return {
          TAG: /* D */0,
          _0: "borderRight",
          _1: Css_AtomicTypes.Length.toString(px) + (" " + (string_of_borderstyle(style) + (" " + string_of_color(color))))
        };
}

function borderRightStyle(x) {
  return {
          TAG: /* D */0,
          _0: "borderRightStyle",
          _1: string_of_borderstyle(x)
        };
}

function borderTop(px, style, color) {
  return {
          TAG: /* D */0,
          _0: "borderTop",
          _1: Css_AtomicTypes.Length.toString(px) + (" " + (string_of_borderstyle(style) + (" " + string_of_color(color))))
        };
}

function borderTopStyle(x) {
  return {
          TAG: /* D */0,
          _0: "borderTopStyle",
          _1: string_of_borderstyle(x)
        };
}

function borderBottom(px, style, color) {
  return {
          TAG: /* D */0,
          _0: "borderBottom",
          _1: Css_AtomicTypes.Length.toString(px) + (" " + (string_of_borderstyle(style) + (" " + string_of_color(color))))
        };
}

function borderBottomStyle(x) {
  return {
          TAG: /* D */0,
          _0: "borderBottomStyle",
          _1: string_of_borderstyle(x)
        };
}

function background(x) {
  var tmp;
  if (typeof x === "object") {
    var variant = x.NAME;
    tmp = variant === "linearGradient" || variant === "radialGradient" || variant === "repeatingLinearGradient" || variant === "repeatingRadialGradient" || variant === "conicGradient" ? Css_AtomicTypes.Gradient.toString(x) : (
        variant === "url" ? Css_AtomicTypes.Url.toString(x) : Css_AtomicTypes.Color.toString(x)
      );
  } else {
    tmp = x === "transparent" || x === "currentColor" ? Css_AtomicTypes.Color.toString(x) : "none";
  }
  return {
          TAG: /* D */0,
          _0: "background",
          _1: tmp
        };
}

function backgrounds(x) {
  return {
          TAG: /* D */0,
          _0: "background",
          _1: join(Belt_List.map(x, (function (item) {
                      if (typeof item !== "object") {
                        if (item === "transparent" || item === "currentColor") {
                          return Css_AtomicTypes.Color.toString(item);
                        } else {
                          return "none";
                        }
                      }
                      var variant = item.NAME;
                      if (variant === "linearGradient" || variant === "radialGradient" || variant === "repeatingLinearGradient" || variant === "repeatingRadialGradient" || variant === "conicGradient") {
                        return Css_AtomicTypes.Gradient.toString(item);
                      } else if (variant === "url") {
                        return Css_AtomicTypes.Url.toString(item);
                      } else {
                        return Css_AtomicTypes.Color.toString(item);
                      }
                    })), ", ")
        };
}

function backgroundSize(x) {
  var tmp;
  if (typeof x === "object") {
    var match = x.VAL;
    tmp = Css_AtomicTypes.Length.toString(match[0]) + (" " + Css_AtomicTypes.Length.toString(match[1]));
  } else {
    tmp = x === "cover" ? "cover" : (
        x === "contain" ? "contain" : "auto"
      );
  }
  return {
          TAG: /* D */0,
          _0: "backgroundSize",
          _1: tmp
        };
}

function fontFace(fontFamily, src, fontStyle, fontWeight, fontDisplay, param) {
  var fontStyle$1 = Js_option.map((function (value) {
          return Css_AtomicTypes.FontStyle.toString(value);
        }), fontStyle);
  var src$1 = $$String.concat(", ", List.map((function (param) {
              if (param.NAME === "url") {
                return "url(\"" + param.VAL + "\")";
              } else {
                return "local(\"" + param.VAL + "\")";
              }
            }), src));
  var fontStyle$2 = Belt_Option.mapWithDefault(fontStyle$1, "", (function (s) {
          return "font-style: " + (s + ";");
        }));
  var fontWeight$1 = Belt_Option.mapWithDefault(fontWeight, "", (function (w) {
          return "font-weight: " + ((
                    typeof w === "object" ? (
                        w.NAME === "num" ? Css_AtomicTypes.FontWeight.toString(w) : Css_AtomicTypes.Var.toString(w)
                      ) : (
                        w === "unset" || w === "inherit_" || w === "initial" ? Css_AtomicTypes.Cascading.toString(w) : Css_AtomicTypes.FontWeight.toString(w)
                      )
                  ) + ";");
        }));
  var fontDisplay$1 = Belt_Option.mapWithDefault(fontDisplay, "", (function (f) {
          return "font-display: " + (Css_AtomicTypes.FontDisplay.toString(f) + ";");
        }));
  return "@font-face {\r\n     font-family: " + fontFamily + ";\r\n     src: " + src$1 + ";\r\n     " + fontStyle$2 + "\r\n     " + fontWeight$1 + "\r\n     " + fontDisplay$1 + "\r\n   }";
}

function textDecoration(x) {
  return {
          TAG: /* D */0,
          _0: "textDecoration",
          _1: typeof x === "object" ? Css_AtomicTypes.Var.toString(x) : (
              x === "none" ? "none" : (
                  x === "initial" ? "initial" : (
                      x === "inherit_" ? "inherit" : (
                          x === "underline" ? "underline" : (
                              x === "lineThrough" ? "line-through" : (
                                  x === "unset" ? "unset" : "overline"
                                )
                            )
                        )
                    )
                )
            )
        };
}

function textShadow(x) {
  return {
          TAG: /* D */0,
          _0: "textShadow",
          _1: typeof x === "object" ? (
              x.NAME === "shadow" ? toString$1(x) : Css_AtomicTypes.Var.toString(x)
            ) : (
              x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : toString$1(x)
            )
        };
}

function textShadows(x) {
  return {
          TAG: /* D */0,
          _0: "textShadow",
          _1: join(Belt_List.map(x, toString$1), ", ")
        };
}

function transformStyle(x) {
  return {
          TAG: /* D */0,
          _0: "transformStyle",
          _1: typeof x === "object" ? Css_AtomicTypes.Var.toString(x) : (
              x === "unset" || x === "inherit_" || x === "initial" ? Css_AtomicTypes.Cascading.toString(x) : Css_AtomicTypes.TransformStyle.toString(x)
            )
        };
}

function shorthand(durationOpt, delayOpt, timingFunctionOpt, property) {
  var duration = durationOpt !== undefined ? durationOpt : 0;
  var delay = delayOpt !== undefined ? delayOpt : 0;
  var timingFunction = timingFunctionOpt !== undefined ? timingFunctionOpt : "ease";
  return {
          NAME: "value",
          VAL: duration.toString() + "ms " + (Css_AtomicTypes.TimingFunction.toString(timingFunction) + (" " + (delay.toString() + "ms " + property)))
        };
}

function toString$2(param) {
  return param.VAL;
}

var Transition = {
  shorthand: shorthand,
  toString: toString$2
};

function transitionValue(x) {
  return {
          TAG: /* D */0,
          _0: "transition",
          _1: x.VAL
        };
}

function transitionList(x) {
  return {
          TAG: /* D */0,
          _0: "transition",
          _1: join(Belt_List.map(x, toString$2), ", ")
        };
}

function transition(duration, delay, timingFunction, property) {
  var x = shorthand(duration, delay, timingFunction, property);
  return {
          TAG: /* D */0,
          _0: "transition",
          _1: x.VAL
        };
}

function transitionDelay(i) {
  return {
          TAG: /* D */0,
          _0: "transitionDelay",
          _1: i.toString() + "ms"
        };
}

function transitionDuration(i) {
  return {
          TAG: /* D */0,
          _0: "transitionDuration",
          _1: i.toString() + "ms"
        };
}

function transitionTimingFunction(x) {
  return {
          TAG: /* D */0,
          _0: "transitionTimingFunction",
          _1: Css_AtomicTypes.TimingFunction.toString(x)
        };
}

function transitionProperty(x) {
  return {
          TAG: /* D */0,
          _0: "transitionProperty",
          _1: x
        };
}

function shorthand$1(durationOpt, delayOpt, directionOpt, timingFunctionOpt, fillModeOpt, playStateOpt, iterationCountOpt, name) {
  var duration = durationOpt !== undefined ? durationOpt : 0;
  var delay = delayOpt !== undefined ? delayOpt : 0;
  var direction = directionOpt !== undefined ? directionOpt : "normal";
  var timingFunction = timingFunctionOpt !== undefined ? timingFunctionOpt : "ease";
  var fillMode = fillModeOpt !== undefined ? fillModeOpt : "none";
  var playState = playStateOpt !== undefined ? playStateOpt : "running";
  var iterationCount = iterationCountOpt !== undefined ? iterationCountOpt : ({
        NAME: "count",
        VAL: 1
      });
  return {
          NAME: "value",
          VAL: name + (" " + (duration.toString() + "ms " + (Css_AtomicTypes.TimingFunction.toString(timingFunction) + (" " + (delay.toString() + "ms " + (Css_AtomicTypes.AnimationIterationCount.toString(iterationCount) + (" " + (Css_AtomicTypes.AnimationDirection.toString(direction) + (" " + (Css_AtomicTypes.AnimationFillMode.toString(fillMode) + (" " + Css_AtomicTypes.AnimationPlayState.toString(playState))))))))))))
        };
}

function toString$3(param) {
  return param.VAL;
}

var Animation = {
  shorthand: shorthand$1,
  toString: toString$3
};

function animationValue(x) {
  return {
          TAG: /* D */0,
          _0: "animation",
          _1: x.VAL
        };
}

function animation(duration, delay, direction, timingFunction, fillMode, playState, iterationCount, name) {
  var x = shorthand$1(duration, delay, direction, timingFunction, fillMode, playState, iterationCount, name);
  return {
          TAG: /* D */0,
          _0: "animation",
          _1: x.VAL
        };
}

function animations(x) {
  return {
          TAG: /* D */0,
          _0: "animation",
          _1: join(Belt_List.map(x, toString$3), ", ")
        };
}

function animationName(x) {
  return {
          TAG: /* D */0,
          _0: "animationName",
          _1: x
        };
}

function fill(x) {
  var tmp;
  if (typeof x === "object") {
    var variant = x.NAME;
    tmp = variant === "var" || variant === "varDefault" ? Css_AtomicTypes.Var.toString(x) : (
        variant === "url" ? Css_AtomicTypes.Url.toString(x) : Css_AtomicTypes.Color.toString(x)
      );
  } else {
    tmp = x === "transparent" || x === "currentColor" ? Css_AtomicTypes.Color.toString(x) : Curry._1(Css_AtomicTypes.SVG.Fill.toString, x);
  }
  return {
          TAG: /* D */0,
          _0: "fill",
          _1: tmp
        };
}

function fillOpacity(opacity) {
  return {
          TAG: /* D */0,
          _0: "fillOpacity",
          _1: opacity.toString()
        };
}

function fillRule(x) {
  return {
          TAG: /* D */0,
          _0: "fillRule",
          _1: x === "evenodd" ? "evenodd" : "nonzero"
        };
}

function stroke(x) {
  return {
          TAG: /* D */0,
          _0: "stroke",
          _1: string_of_color(x)
        };
}

function strokeDasharray(x) {
  return {
          TAG: /* D */0,
          _0: "strokeDasharray",
          _1: typeof x === "object" ? join(Belt_List.map(x.VAL, string_of_dasharray), " ") : "none"
        };
}

function strokeWidth(x) {
  return {
          TAG: /* D */0,
          _0: "strokeWidth",
          _1: Css_AtomicTypes.Length.toString(x)
        };
}

function strokeOpacity(opacity) {
  return {
          TAG: /* D */0,
          _0: "strokeOpacity",
          _1: opacity.toString()
        };
}

function strokeMiterlimit(x) {
  return {
          TAG: /* D */0,
          _0: "strokeMiterlimit",
          _1: x.toString()
        };
}

function strokeLinecap(x) {
  return {
          TAG: /* D */0,
          _0: "strokeLinecap",
          _1: x === "square" ? "square" : (
              x === "round" ? "round" : "butt"
            )
        };
}

function strokeLinejoin(x) {
  return {
          TAG: /* D */0,
          _0: "strokeLinejoin",
          _1: x === "miter" ? "miter" : (
              x === "bevel" ? "bevel" : "round"
            )
        };
}

function stopColor(x) {
  return {
          TAG: /* D */0,
          _0: "stopColor",
          _1: string_of_color(x)
        };
}

function stopOpacity(x) {
  return {
          TAG: /* D */0,
          _0: "stopOpacity",
          _1: x.toString()
        };
}

function touchAction(x) {
  return {
          TAG: /* D */0,
          _0: "touchAction",
          _1: Css_AtomicTypes.TouchAction.toString(x)
        };
}

var Types;

var wordWrap = overflowWrap;

var auto = "auto";

var none = "none";

var text$1 = "text";

var fixed = "fixed";

var isolate = "isolate";

var hidden = "hidden";

var visible = "visible";

var scroll = "scroll";

var local = "local";

var paddingBox = "paddingBox";

var borderBox = "borderBox";

var contentBox = "contentBox";

var noRepeat = "noRepeat";

var space = "space";

var repeat = "repeat";

var minmax = "minmax";

var repeatX = "repeatX";

var repeatY = "repeatY";

var contain = "contain";

var cover = "cover";

var row = "row";

var rowReverse = "rowReverse";

var column = "column";

var columnReverse = "columnReverse";

var wrap = "wrap";

var nowrap = "nowrap";

var wrapReverse = "wrapReverse";

var inline = "inline";

var block = "block";

var contents = "contents";

var flexBox = "flex";

var grid = "grid";

var inlineBlock = "inlineBlock";

var inlineFlex = "inlineFlex";

var inlineGrid = "inlineGrid";

var inlineTable = "inlineTable";

var listItem = "listItem";

var runIn = "runIn";

var table = "table";

var tableCaption = "tableCaption";

var tableColumnGroup = "tableColumnGroup";

var tableHeaderGroup = "tableHeaderGroup";

var tableFooterGroup = "tableFooterGroup";

var tableRowGroup = "tableRowGroup";

var tableCell = "tableCell";

var tableColumn = "tableColumn";

var tableRow = "tableRow";

var flexStart = "flexStart";

var flexEnd = "flexEnd";

var center = "center";

var stretch = "stretch";

var spaceBetween = "spaceBetween";

var spaceAround = "spaceAround";

var spaceEvenly = "spaceEvenly";

var baseline = "baseline";

var forwards = "forwards";

var backwards = "backwards";

var both = "both";

var infinite = "infinite";

var paused = "paused";

var running = "running";

var inside = "inside";

var outside = "outside";

var solid = "solid";

var dotted = "dotted";

var dashed = "dashed";

var underline = "underline";

var overline = "overline";

var lineThrough = "lineThrough";

var clip = "clip";

var ellipsis = "ellipsis";

var wavy = "wavy";

var $$double = "double";

var uppercase = "uppercase";

var lowercase = "lowercase";

var capitalize = "capitalize";

var sub = "sub";

var $$super = "super";

var textTop = "textTop";

var textBottom = "textBottom";

var middle = "middle";

var normal = "normal";

var breakAll = "breakAll";

var keepAll = "keepAll";

var breakWord = "breakWord";

var reverse = "reverse";

var alternate = "alternate";

var alternateReverse = "alternateReverse";

var fill$1 = "fill";

var content = "content";

var maxContent = "maxContent";

var minContent = "minContent";

var fitContent = "fitContent";

var all = "all";

var round = "round";

var miter = "miter";

var bevel = "bevel";

var butt = "butt";

var square = "square";

var panX = "panX";

var panY = "panY";

var panLeft = "panLeft";

var panRight = "panRight";

var panUp = "panUp";

var panDown = "panDown";

var pinchZoom = "pinchZoom";

var manipulation = "manipulation";

var transitions = transitionList;

var SVG = {
  fill: fill,
  fillRule: fillRule,
  fillOpacity: fillOpacity,
  stroke: stroke,
  strokeDasharray: strokeDasharray,
  strokeLinecap: strokeLinecap,
  strokeLinejoin: strokeLinejoin,
  strokeMiterlimit: strokeMiterlimit,
  strokeWidth: strokeWidth,
  strokeOpacity: strokeOpacity,
  stopColor: stopColor,
  stopOpacity: stopOpacity
};

exports.Types = Types;
exports.Make = Make;
exports.toJson = toJson;
exports.important = important;
exports.label = label;
exports.Shadow = Shadow;
exports.unsafe = unsafe;
exports.alignContent = alignContent;
exports.alignItems = alignItems;
exports.alignSelf = alignSelf;
exports.animationDelay = animationDelay;
exports.animationDirection = animationDirection;
exports.animationDuration = animationDuration;
exports.animationFillMode = animationFillMode;
exports.animationIterationCount = animationIterationCount;
exports.animationPlayState = animationPlayState;
exports.animationTimingFunction = animationTimingFunction;
exports.backdropFilter = backdropFilter;
exports.backfaceVisibility = backfaceVisibility;
exports.backgroundAttachment = backgroundAttachment;
exports.backgroundColor = backgroundColor;
exports.backgroundClip = backgroundClip;
exports.backgroundImage = backgroundImage;
exports.maskImage = maskImage;
exports.backgroundOrigin = backgroundOrigin;
exports.backgroundPosition = backgroundPosition;
exports.backgroundPositions = backgroundPositions;
exports.backgroundPosition4 = backgroundPosition4;
exports.backgroundRepeat = backgroundRepeat;
exports.maskPosition = maskPosition;
exports.maskPositions = maskPositions;
exports.borderBottom = borderBottom;
exports.borderBottomColor = borderBottomColor;
exports.borderBottomLeftRadius = borderBottomLeftRadius;
exports.borderBottomRightRadius = borderBottomRightRadius;
exports.borderBottomStyle = borderBottomStyle;
exports.borderBottomWidth = borderBottomWidth;
exports.borderCollapse = borderCollapse;
exports.borderColor = borderColor;
exports.borderLeft = borderLeft;
exports.borderLeftColor = borderLeftColor;
exports.borderLeftStyle = borderLeftStyle;
exports.borderLeftWidth = borderLeftWidth;
exports.borderRight = borderRight;
exports.borderRightColor = borderRightColor;
exports.borderRightStyle = borderRightStyle;
exports.borderRightWidth = borderRightWidth;
exports.borderRadius = borderRadius;
exports.borderSpacing = borderSpacing;
exports.borderStyle = borderStyle;
exports.borderTopColor = borderTopColor;
exports.borderTopLeftRadius = borderTopLeftRadius;
exports.borderTopRightRadius = borderTopRightRadius;
exports.borderTopStyle = borderTopStyle;
exports.borderTopWidth = borderTopWidth;
exports.borderWidth = borderWidth;
exports.bottom = bottom;
exports.boxSizing = boxSizing;
exports.boxShadow = boxShadow;
exports.boxShadows = boxShadows;
exports.clear = clear;
exports.clipPath = clipPath;
exports.color = color;
exports.columnCount = columnCount;
exports.contentRule = contentRule;
exports.contentRules = contentRules;
exports.counterIncrement = counterIncrement;
exports.countersIncrement = countersIncrement;
exports.counterReset = counterReset;
exports.countersReset = countersReset;
exports.counterSet = counterSet;
exports.countersSet = countersSet;
exports.cursor = cursor;
exports.direction = direction;
exports.display = display;
exports.flex = flex;
exports.flexBasis = flexBasis;
exports.flexDirection = flexDirection;
exports.flexGrow = flexGrow;
exports.flexShrink = flexShrink;
exports.flexWrap = flexWrap;
exports.$$float = $$float;
exports.fontFamily = fontFamily;
exports.fontFamilies = fontFamilies;
exports.fontSize = fontSize;
exports.fontStyle = fontStyle;
exports.fontVariant = fontVariant;
exports.fontWeight = fontWeight;
exports.gridArea = gridArea;
exports.gridArea2 = gridArea2;
exports.gridArea3 = gridArea3;
exports.gridArea4 = gridArea4;
exports.gridAutoFlow = gridAutoFlow;
exports.gridColumn = gridColumn;
exports.gridColumnEnd = gridColumnEnd;
exports.columnGap = columnGap;
exports.scrollBehavior = scrollBehavior;
exports.overscrollBehavior = overscrollBehavior;
exports.overflowAnchor = overflowAnchor;
exports.columnWidth = columnWidth;
exports.caretColor = caretColor;
exports.rowGap = rowGap;
exports.gridColumnGap = gridColumnGap;
exports.gridColumnStart = gridColumnStart;
exports.gap = gap;
exports.gap2 = gap2;
exports.gridGap = gridGap;
exports.gridRow = gridRow;
exports.gridRowEnd = gridRowEnd;
exports.gridRowGap = gridRowGap;
exports.gridRowStart = gridRowStart;
exports.gridTemplateAreas = gridTemplateAreas;
exports.height = height;
exports.justifyContent = justifyContent;
exports.justifyItems = justifyItems;
exports.justifySelf = justifySelf;
exports.left = left;
exports.letterSpacing = letterSpacing;
exports.lineHeight = lineHeight;
exports.listStyle = listStyle;
exports.listStyleImage = listStyleImage;
exports.listStyleType = listStyleType;
exports.listStylePosition = listStylePosition;
exports.margin = margin;
exports.margin2 = margin2;
exports.margin3 = margin3;
exports.margin4 = margin4;
exports.marginLeft = marginLeft;
exports.marginRight = marginRight;
exports.marginTop = marginTop;
exports.marginBottom = marginBottom;
exports.maxHeight = maxHeight;
exports.maxWidth = maxWidth;
exports.minHeight = minHeight;
exports.minWidth = minWidth;
exports.objectFit = objectFit;
exports.objectPosition = objectPosition;
exports.opacity = opacity;
exports.order = order;
exports.outline = outline;
exports.outlineColor = outlineColor;
exports.outlineOffset = outlineOffset;
exports.outlineStyle = outlineStyle;
exports.outlineWidth = outlineWidth;
exports.overflow = overflow;
exports.overflowX = overflowX;
exports.overflowY = overflowY;
exports.overflowWrap = overflowWrap;
exports.padding = padding;
exports.padding2 = padding2;
exports.padding3 = padding3;
exports.padding4 = padding4;
exports.paddingLeft = paddingLeft;
exports.paddingRight = paddingRight;
exports.paddingTop = paddingTop;
exports.paddingBottom = paddingBottom;
exports.perspective = perspective;
exports.perspectiveOrigin = perspectiveOrigin;
exports.pointerEvents = pointerEvents;
exports.position = position;
exports.isolation = isolation;
exports.resize = resize;
exports.right = right;
exports.tableLayout = tableLayout;
exports.textAlign = textAlign;
exports.textDecorationColor = textDecorationColor;
exports.textDecorationLine = textDecorationLine;
exports.textDecorationStyle = textDecorationStyle;
exports.textIndent = textIndent;
exports.textOverflow = textOverflow;
exports.textShadow = textShadow;
exports.textShadows = textShadows;
exports.textTransform = textTransform;
exports.top = top;
exports.transform = transform;
exports.transforms = transforms;
exports.transformOrigin = transformOrigin;
exports.transformOrigin3d = transformOrigin3d;
exports.transitionDelay = transitionDelay;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
exports.transformStyle = transformStyle;
exports.transitionTimingFunction = transitionTimingFunction;
exports.userSelect = userSelect;
exports.verticalAlign = verticalAlign;
exports.visibility = visibility;
exports.width = width;
exports.whiteSpace = whiteSpace;
exports.wordBreak = wordBreak;
exports.wordSpacing = wordSpacing;
exports.wordWrap = wordWrap;
exports.zIndex = zIndex;
exports.selector = selector;
exports.media = media;
exports.active = active;
exports.checked = checked;
exports.$$default = $$default;
exports["default"] = $$default;
exports.__esModule = true;
exports.defined = defined;
exports.disabled = disabled;
exports.empty = empty;
exports.enabled = enabled;
exports.first = first;
exports.firstChild = firstChild;
exports.firstOfType = firstOfType;
exports.focus = focus;
exports.focusVisible = focusVisible;
exports.focusWithin = focusWithin;
exports.host = host;
exports.hover = hover;
exports.indeterminate = indeterminate;
exports.inRange = inRange;
exports.invalid = invalid;
exports.lang = lang;
exports.lastChild = lastChild;
exports.lastOfType = lastOfType;
exports.link = link;
exports.not__ = not__;
exports.Nth = Nth;
exports.nthChild = nthChild;
exports.nthLastChild = nthLastChild;
exports.nthLastOfType = nthLastOfType;
exports.nthOfType = nthOfType;
exports.onlyChild = onlyChild;
exports.onlyOfType = onlyOfType;
exports.optional = optional;
exports.outOfRange = outOfRange;
exports.readOnly = readOnly;
exports.readWrite = readWrite;
exports.required = required;
exports.root = root;
exports.scope = scope;
exports.target = target;
exports.valid = valid;
exports.visited = visited;
exports.after = after;
exports.before = before;
exports.firstLetter = firstLetter;
exports.firstLine = firstLine;
exports.placeholder = placeholder;
exports.selection = selection;
exports.child = child;
exports.children = children;
exports.directSibling = directSibling;
exports.siblings = siblings;
exports.anyLink = anyLink;
exports.initial = initial;
exports.inherit_ = inherit_;
exports.unset = unset;
exports.$$var = $$var;
exports.varDefault = varDefault;
exports.auto = auto;
exports.none = none;
exports.text = text$1;
exports.pct = pct;
exports.ch = ch;
exports.cm = cm;
exports.em = em;
exports.ex = ex;
exports.mm = mm;
exports.pt = pt;
exports.px = px;
exports.pxFloat = pxFloat;
exports.rem = rem;
exports.vh = vh;
exports.vmin = vmin;
exports.vmax = vmax;
exports.zero = zero;
exports.deg = deg;
exports.rad = rad;
exports.grad = grad;
exports.turn = turn;
exports.ltr = ltr;
exports.rtl = rtl;
exports.absolute = absolute;
exports.relative = relative;
exports.$$static = $$static;
exports.fixed = fixed;
exports.sticky = sticky;
exports.isolate = isolate;
exports.horizontal = horizontal;
exports.vertical = vertical;
exports.smallCaps = smallCaps;
exports.italic = italic;
exports.oblique = oblique;
exports.hidden = hidden;
exports.visible = visible;
exports.scroll = scroll;
exports.rgb = rgb;
exports.rgba = rgba;
exports.hsl = hsl;
exports.hsla = hsla;
exports.hex = hex;
exports.transparent = transparent;
exports.currentColor = currentColor;
exports.local = local;
exports.paddingBox = paddingBox;
exports.borderBox = borderBox;
exports.contentBox = contentBox;
exports.noRepeat = noRepeat;
exports.space = space;
exports.repeat = repeat;
exports.minmax = minmax;
exports.repeatX = repeatX;
exports.repeatY = repeatY;
exports.contain = contain;
exports.cover = cover;
exports.row = row;
exports.rowReverse = rowReverse;
exports.column = column;
exports.columnReverse = columnReverse;
exports.wrap = wrap;
exports.nowrap = nowrap;
exports.wrapReverse = wrapReverse;
exports.inline = inline;
exports.block = block;
exports.contents = contents;
exports.flexBox = flexBox;
exports.grid = grid;
exports.inlineBlock = inlineBlock;
exports.inlineFlex = inlineFlex;
exports.inlineGrid = inlineGrid;
exports.inlineTable = inlineTable;
exports.listItem = listItem;
exports.runIn = runIn;
exports.table = table;
exports.tableCaption = tableCaption;
exports.tableColumnGroup = tableColumnGroup;
exports.tableHeaderGroup = tableHeaderGroup;
exports.tableFooterGroup = tableFooterGroup;
exports.tableRowGroup = tableRowGroup;
exports.tableCell = tableCell;
exports.tableColumn = tableColumn;
exports.tableRow = tableRow;
exports.flexStart = flexStart;
exports.flexEnd = flexEnd;
exports.center = center;
exports.stretch = stretch;
exports.spaceBetween = spaceBetween;
exports.spaceAround = spaceAround;
exports.spaceEvenly = spaceEvenly;
exports.baseline = baseline;
exports.forwards = forwards;
exports.backwards = backwards;
exports.both = both;
exports.infinite = infinite;
exports.count = count;
exports.paused = paused;
exports.running = running;
exports.inside = inside;
exports.outside = outside;
exports.solid = solid;
exports.dotted = dotted;
exports.dashed = dashed;
exports.underline = underline;
exports.overline = overline;
exports.lineThrough = lineThrough;
exports.clip = clip;
exports.ellipsis = ellipsis;
exports.wavy = wavy;
exports.$$double = $$double;
exports.uppercase = uppercase;
exports.lowercase = lowercase;
exports.capitalize = capitalize;
exports.sub = sub;
exports.$$super = $$super;
exports.textTop = textTop;
exports.textBottom = textBottom;
exports.middle = middle;
exports.normal = normal;
exports.breakAll = breakAll;
exports.keepAll = keepAll;
exports.breakWord = breakWord;
exports.reverse = reverse;
exports.alternate = alternate;
exports.alternateReverse = alternateReverse;
exports.fill = fill$1;
exports.content = content;
exports.maxContent = maxContent;
exports.minContent = minContent;
exports.fitContent = fitContent;
exports.all = all;
exports.round = round;
exports.miter = miter;
exports.bevel = bevel;
exports.butt = butt;
exports.square = square;
exports.panX = panX;
exports.panY = panY;
exports.panLeft = panLeft;
exports.panRight = panRight;
exports.panUp = panUp;
exports.panDown = panDown;
exports.pinchZoom = pinchZoom;
exports.manipulation = manipulation;
exports.thin = thin;
exports.extraLight = extraLight;
exports.light = light;
exports.medium = medium;
exports.semiBold = semiBold;
exports.bold = bold;
exports.extraBold = extraBold;
exports.lighter = lighter;
exports.bolder = bolder;
exports.fr = fr;
exports.vw = vw;
exports.localUrl = localUrl;
exports.url = url;
exports.linear = linear;
exports.ease = ease;
exports.easeIn = easeIn;
exports.easeOut = easeOut;
exports.easeInOut = easeInOut;
exports.stepStart = stepStart;
exports.stepEnd = stepEnd;
exports.steps = steps;
exports.cubicBezier = cubicBezier;
exports.marginBox = marginBox;
exports.fillBox = fillBox;
exports.strokeBox = strokeBox;
exports.viewBox = viewBox;
exports.translate = translate;
exports.translate3d = translate3d;
exports.translateX = translateX;
exports.translateY = translateY;
exports.translateZ = translateZ;
exports.scale = scale;
exports.scale3d = scale3d;
exports.scaleX = scaleX;
exports.scaleY = scaleY;
exports.scaleZ = scaleZ;
exports.rotate = rotate;
exports.rotate3d = rotate3d;
exports.rotateX = rotateX;
exports.rotateY = rotateY;
exports.rotateZ = rotateZ;
exports.skew = skew;
exports.skewX = skewX;
exports.skewY = skewY;
exports.linearGradient = linearGradient;
exports.repeatingLinearGradient = repeatingLinearGradient;
exports.radialGradient = radialGradient;
exports.repeatingRadialGradient = repeatingRadialGradient;
exports.conicGradient = conicGradient;
exports.areas = areas;
exports.ident = ident;
exports.numIdent = numIdent;
exports.contextMenu = contextMenu;
exports.help = help;
exports.pointer = pointer;
exports.progress = progress;
exports.wait = wait;
exports.cell = cell;
exports.crosshair = crosshair;
exports.verticalText = verticalText;
exports.alias = alias;
exports.copy = copy;
exports.move = move;
exports.noDrop = noDrop;
exports.notAllowed = notAllowed;
exports.grab = grab;
exports.grabbing = grabbing;
exports.allScroll = allScroll;
exports.colResize = colResize;
exports.rowResize = rowResize;
exports.nResize = nResize;
exports.eResize = eResize;
exports.sResize = sResize;
exports.wResize = wResize;
exports.neResize = neResize;
exports.nwResize = nwResize;
exports.seResize = seResize;
exports.swResize = swResize;
exports.ewResize = ewResize;
exports.nsResize = nsResize;
exports.neswResize = neswResize;
exports.nwseResize = nwseResize;
exports.zoomIn = zoomIn;
exports.zoomOut = zoomOut;
exports.flex3 = flex3;
exports.border = border;
exports.borderTop = borderTop;
exports.backgroundSize = backgroundSize;
exports.textDecoration = textDecoration;
exports.background = background;
exports.backgrounds = backgrounds;
exports.gridAutoColumns = gridAutoColumns;
exports.gridAutoRows = gridAutoRows;
exports.gridTemplateColumns = gridTemplateColumns;
exports.gridTemplateRows = gridTemplateRows;
exports.Calc = Calc;
exports.size = size;
exports.filter = filter;
exports.fontFace = fontFace;
exports.Transition = Transition;
exports.transitionValue = transitionValue;
exports.transitionList = transitionList;
exports.transition = transition;
exports.transitions = transitions;
exports.Animation = Animation;
exports.animationValue = animationValue;
exports.animation = animation;
exports.animations = animations;
exports.animationName = animationName;
exports.SVG = SVG;
exports.touchAction = touchAction;
/* No side effect */


/***/ }),

/***/ 78219:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE


var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Js_math = __webpack_require__(84763);
var Belt_Array = __webpack_require__(2971);
var Caml_int64 = __webpack_require__(77893);
var Belt_Result = __webpack_require__(86369);
var Caml_option = __webpack_require__(57175);
var Decco_Codecs = __webpack_require__(63781);

function error(path, message, value) {
  var path$1 = path !== undefined ? path : "";
  return {
          TAG: /* Error */1,
          _0: {
            path: path$1,
            message: message,
            value: value
          }
        };
}

function stringToJson(s) {
  return s;
}

function stringFromJson(j) {
  var s = Js_json.decodeString(j);
  if (s !== undefined) {
    return {
            TAG: /* Ok */0,
            _0: s
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: {
              path: "",
              message: "Not a string",
              value: j
            }
          };
  }
}

function intToJson(i) {
  return i;
}

function intFromJson(j) {
  var f = Js_json.decodeNumber(j);
  if (f !== undefined) {
    if (Js_math.floor(f) === f) {
      return {
              TAG: /* Ok */0,
              _0: Js_math.floor(f)
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: {
                path: "",
                message: "Not an integer",
                value: j
              }
            };
    }
  } else {
    return {
            TAG: /* Error */1,
            _0: {
              path: "",
              message: "Not a number",
              value: j
            }
          };
  }
}

var int64ToJson = Caml_int64.float_of_bits;

function int64FromJson(j) {
  var n = Js_json.decodeNumber(j);
  if (n !== undefined) {
    return {
            TAG: /* Ok */0,
            _0: Caml_int64.bits_of_float(n)
          };
  } else {
    return error(undefined, "Not a number", j);
  }
}

var int64ToJsonUnsafe = Caml_int64.to_float;

function int64FromJsonUnsafe(j) {
  var n = Js_json.decodeNumber(j);
  if (n !== undefined) {
    return {
            TAG: /* Ok */0,
            _0: Caml_int64.of_float(n)
          };
  } else {
    return error(undefined, "Not a number", j);
  }
}

function floatToJson(v) {
  return v;
}

function floatFromJson(j) {
  var f = Js_json.decodeNumber(j);
  if (f !== undefined) {
    return {
            TAG: /* Ok */0,
            _0: f
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: {
              path: "",
              message: "Not a number",
              value: j
            }
          };
  }
}

function boolToJson(v) {
  return v;
}

function boolFromJson(j) {
  var b = Js_json.decodeBoolean(j);
  if (b !== undefined) {
    return {
            TAG: /* Ok */0,
            _0: b
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: {
              path: "",
              message: "Not a boolean",
              value: j
            }
          };
  }
}

function unitToJson(param) {
  return 0.0;
}

function unitFromJson(param) {
  return {
          TAG: /* Ok */0,
          _0: undefined
        };
}

function arrayToJson(encoder, arr) {
  return arr.map(Curry.__1(encoder));
}

function arrayFromJson(decoder, json) {
  var arr = Js_json.decodeArray(json);
  if (arr !== undefined) {
    return arr.reduce((function (acc, jsonI, i) {
                  var match = Curry._1(decoder, jsonI);
                  if (acc.TAG !== /* Ok */0) {
                    return acc;
                  }
                  if (match.TAG === /* Ok */0) {
                    return {
                            TAG: /* Ok */0,
                            _0: acc._0.concat([match._0])
                          };
                  }
                  var error = match._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: "[" + (String(i) + ("]" + error.path)),
                            message: error.message,
                            value: error.value
                          }
                        };
                }), {
                TAG: /* Ok */0,
                _0: []
              });
  } else {
    return {
            TAG: /* Error */1,
            _0: {
              path: "",
              message: "Not an array",
              value: json
            }
          };
  }
}

function listToJson(encoder, list) {
  var arr = $$Array.of_list(list);
  return arr.map(Curry.__1(encoder));
}

function listFromJson(decoder, json) {
  var __x = arrayFromJson(decoder, json);
  return Belt_Result.map(__x, $$Array.to_list);
}

function optionToJson(encoder, opt) {
  if (opt !== undefined) {
    return Curry._1(encoder, Caml_option.valFromOption(opt));
  } else {
    return null;
  }
}

function optionFromJson(decoder, json) {
  var match = Js_json.decodeNull(json);
  if (match !== undefined) {
    return {
            TAG: /* Ok */0,
            _0: undefined
          };
  }
  var __x = Curry._1(decoder, json);
  return Belt_Result.map(__x, (function (v) {
                return Caml_option.some(v);
              }));
}

function resultToJson(okEncoder, errorEncoder, result) {
  if (result.TAG === /* Ok */0) {
    return [
            "Ok",
            Curry._1(okEncoder, result._0)
          ];
  } else {
    return [
            "Error",
            Curry._1(errorEncoder, result._0)
          ];
  }
}

function resultFromJson(okDecoder, errorDecoder, json) {
  var match = Js_json.decodeArray(json);
  if (match === undefined) {
    return error(undefined, "Not an array", json);
  }
  if (match.length !== 2) {
    return error(undefined, "Expected exactly 2 values in array", json);
  }
  var variantConstructorId = match[0];
  var payload = match[1];
  var match$1 = Js_json.decodeString(variantConstructorId);
  if (match$1 === undefined) {
    return error(undefined, "Not a string", variantConstructorId);
  }
  switch (match$1) {
    case "Error" :
        var v = Curry._1(errorDecoder, payload);
        if (v.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    TAG: /* Error */1,
                    _0: v._0
                  }
                };
        } else {
          return {
                  TAG: /* Error */1,
                  _0: v._0
                };
        }
    case "Ok" :
        return Belt_Result.map(Curry._1(okDecoder, payload), (function (v) {
                      return {
                              TAG: /* Ok */0,
                              _0: v
                            };
                    }));
    default:
      return error(undefined, "Expected either \"Ok\" or \"Error\"", variantConstructorId);
  }
}

function dictToJson(encoder, dict) {
  return Js_dict.map(Curry.__1(encoder), dict);
}

function dictFromJson(decoder, json) {
  var dict = Js_json.decodeObject(json);
  if (dict !== undefined) {
    return Belt_Array.reduce(Js_dict.entries(Caml_option.valFromOption(dict)), {
                TAG: /* Ok */0,
                _0: {}
              }, (function (acc, param) {
                  var key = param[0];
                  var match = Curry._1(decoder, param[1]);
                  if (acc.TAG !== /* Ok */0) {
                    return acc;
                  }
                  var prev = acc._0;
                  if (match.TAG === /* Ok */0) {
                    prev[key] = match._0;
                    return {
                            TAG: /* Ok */0,
                            _0: prev
                          };
                  }
                  var error = match._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: "." + (key + error.path),
                            message: error.message,
                            value: error.value
                          }
                        };
                }));
  } else {
    return {
            TAG: /* Error */1,
            _0: {
              path: "",
              message: "Not a dict",
              value: json
            }
          };
  }
}

var string = [
  stringToJson,
  stringFromJson
];

var $$int = [
  intToJson,
  intFromJson
];

var int64Unsafe = [
  int64ToJsonUnsafe,
  int64FromJsonUnsafe
];

var $$float = [
  floatToJson,
  floatFromJson
];

var bool = [
  boolToJson,
  boolFromJson
];

var array = [
  arrayToJson,
  arrayFromJson
];

var list = [
  listToJson,
  listFromJson
];

var option = [
  optionToJson,
  optionFromJson
];

var unit = [
  unitToJson,
  unitFromJson
];

var Codecs = {
  falseableEncode: Decco_Codecs.falseableEncode,
  falseableDecode: Decco_Codecs.falseableDecode,
  falseable: Decco_Codecs.falseable,
  magicDecode: Decco_Codecs.magicDecode,
  magic: Decco_Codecs.magic,
  string: string,
  $$int: $$int,
  int64Unsafe: int64Unsafe,
  $$float: $$float,
  bool: bool,
  array: array,
  list: list,
  option: option,
  unit: unit
};

exports.error = error;
exports.stringToJson = stringToJson;
exports.stringFromJson = stringFromJson;
exports.intToJson = intToJson;
exports.intFromJson = intFromJson;
exports.int64ToJson = int64ToJson;
exports.int64FromJson = int64FromJson;
exports.int64ToJsonUnsafe = int64ToJsonUnsafe;
exports.int64FromJsonUnsafe = int64FromJsonUnsafe;
exports.floatToJson = floatToJson;
exports.floatFromJson = floatFromJson;
exports.boolToJson = boolToJson;
exports.boolFromJson = boolFromJson;
exports.unitToJson = unitToJson;
exports.unitFromJson = unitFromJson;
exports.arrayToJson = arrayToJson;
exports.arrayFromJson = arrayFromJson;
exports.listToJson = listToJson;
exports.listFromJson = listFromJson;
exports.optionToJson = optionToJson;
exports.optionFromJson = optionFromJson;
exports.resultToJson = resultToJson;
exports.resultFromJson = resultFromJson;
exports.dictToJson = dictToJson;
exports.dictFromJson = dictFromJson;
exports.Codecs = Codecs;
/* No side effect */


/***/ }),

/***/ 63781:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE


var Curry = __webpack_require__(41386);
var Js_json = __webpack_require__(85688);
var Belt_Result = __webpack_require__(86369);
var Caml_option = __webpack_require__(57175);

function falseableEncode(encoder, opt) {
  if (opt !== undefined) {
    return Curry._1(encoder, Caml_option.valFromOption(opt));
  } else {
    return false;
  }
}

function falseableDecode(decoder, json) {
  var match = Js_json.decodeBoolean(json);
  if (match !== undefined && !match) {
    return {
            TAG: /* Ok */0,
            _0: undefined
          };
  }
  var __x = Curry._1(decoder, json);
  return Belt_Result.map(__x, (function (v) {
                return Caml_option.some(v);
              }));
}

var falseable = [
  falseableEncode,
  falseableDecode
];

function magicDecode(j) {
  return {
          TAG: /* Ok */0,
          _0: j
        };
}

function magic_0(prim) {
  return prim;
}

var magic = [
  magic_0,
  magicDecode
];

exports.falseableEncode = falseableEncode;
exports.falseableDecode = falseableDecode;
exports.falseable = falseable;
exports.magicDecode = magicDecode;
exports.magic = magic;
/* No side effect */


/***/ }),

/***/ 2971:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var Caml = __webpack_require__(16253);
var Curry = __webpack_require__(41386);
var Js_math = __webpack_require__(84763);
var Caml_option = __webpack_require__(57175);

function get(arr, i) {
  if (i >= 0 && i < arr.length) {
    return Caml_option.some(arr[i]);
  }
  
}

function getExn(arr, i) {
  if (!(i >= 0 && i < arr.length)) {
    throw {
          RE_EXN_ID: "Assert_failure",
          _1: [
            "belt_Array.ml",
            27,
            4
          ],
          Error: new Error()
        };
  }
  return arr[i];
}

function set(arr, i, v) {
  if (i >= 0 && i < arr.length) {
    arr[i] = v;
    return true;
  } else {
    return false;
  }
}

function setExn(arr, i, v) {
  if (!(i >= 0 && i < arr.length)) {
    throw {
          RE_EXN_ID: "Assert_failure",
          _1: [
            "belt_Array.ml",
            33,
            2
          ],
          Error: new Error()
        };
  }
  arr[i] = v;
  
}

function swapUnsafe(xs, i, j) {
  var tmp = xs[i];
  xs[i] = xs[j];
  xs[j] = tmp;
  
}

function shuffleInPlace(xs) {
  var len = xs.length;
  for(var i = 0; i < len; ++i){
    swapUnsafe(xs, i, Js_math.random_int(i, len));
  }
  
}

function shuffle(xs) {
  var result = xs.slice(0);
  shuffleInPlace(result);
  return result;
}

function reverseInPlace(xs) {
  var len = xs.length;
  var ofs = 0;
  for(var i = 0 ,i_finish = len / 2 | 0; i < i_finish; ++i){
    swapUnsafe(xs, ofs + i | 0, ((ofs + len | 0) - i | 0) - 1 | 0);
  }
  
}

function reverse(xs) {
  var len = xs.length;
  var result = new Array(len);
  for(var i = 0; i < len; ++i){
    result[i] = xs[(len - 1 | 0) - i | 0];
  }
  return result;
}

function make(l, f) {
  if (l <= 0) {
    return [];
  }
  var res = new Array(l);
  for(var i = 0; i < l; ++i){
    res[i] = f;
  }
  return res;
}

function makeByU(l, f) {
  if (l <= 0) {
    return [];
  }
  var res = new Array(l);
  for(var i = 0; i < l; ++i){
    res[i] = f(i);
  }
  return res;
}

function makeBy(l, f) {
  return makeByU(l, Curry.__1(f));
}

function makeByAndShuffleU(l, f) {
  var u = makeByU(l, f);
  shuffleInPlace(u);
  return u;
}

function makeByAndShuffle(l, f) {
  return makeByAndShuffleU(l, Curry.__1(f));
}

function range(start, finish) {
  var cut = finish - start | 0;
  if (cut < 0) {
    return [];
  }
  var arr = new Array(cut + 1 | 0);
  for(var i = 0; i <= cut; ++i){
    arr[i] = start + i | 0;
  }
  return arr;
}

function rangeBy(start, finish, step) {
  var cut = finish - start | 0;
  if (cut < 0 || step <= 0) {
    return [];
  }
  var nb = (cut / step | 0) + 1 | 0;
  var arr = new Array(nb);
  var cur = start;
  for(var i = 0; i < nb; ++i){
    arr[i] = cur;
    cur = cur + step | 0;
  }
  return arr;
}

function zip(xs, ys) {
  var lenx = xs.length;
  var leny = ys.length;
  var len = lenx < leny ? lenx : leny;
  var s = new Array(len);
  for(var i = 0; i < len; ++i){
    s[i] = [
      xs[i],
      ys[i]
    ];
  }
  return s;
}

function zipByU(xs, ys, f) {
  var lenx = xs.length;
  var leny = ys.length;
  var len = lenx < leny ? lenx : leny;
  var s = new Array(len);
  for(var i = 0; i < len; ++i){
    s[i] = f(xs[i], ys[i]);
  }
  return s;
}

function zipBy(xs, ys, f) {
  return zipByU(xs, ys, Curry.__2(f));
}

function concat(a1, a2) {
  var l1 = a1.length;
  var l2 = a2.length;
  var a1a2 = new Array(l1 + l2 | 0);
  for(var i = 0; i < l1; ++i){
    a1a2[i] = a1[i];
  }
  for(var i$1 = 0; i$1 < l2; ++i$1){
    a1a2[l1 + i$1 | 0] = a2[i$1];
  }
  return a1a2;
}

function concatMany(arrs) {
  var lenArrs = arrs.length;
  var totalLen = 0;
  for(var i = 0; i < lenArrs; ++i){
    totalLen = totalLen + arrs[i].length | 0;
  }
  var result = new Array(totalLen);
  totalLen = 0;
  for(var j = 0; j < lenArrs; ++j){
    var cur = arrs[j];
    for(var k = 0 ,k_finish = cur.length; k < k_finish; ++k){
      result[totalLen] = cur[k];
      totalLen = totalLen + 1 | 0;
    }
  }
  return result;
}

function slice(a, offset, len) {
  if (len <= 0) {
    return [];
  }
  var lena = a.length;
  var ofs = offset < 0 ? Caml.caml_int_max(lena + offset | 0, 0) : offset;
  var hasLen = lena - ofs | 0;
  var copyLength = hasLen < len ? hasLen : len;
  if (copyLength <= 0) {
    return [];
  }
  var result = new Array(copyLength);
  for(var i = 0; i < copyLength; ++i){
    result[i] = a[ofs + i | 0];
  }
  return result;
}

function sliceToEnd(a, offset) {
  var lena = a.length;
  var ofs = offset < 0 ? Caml.caml_int_max(lena + offset | 0, 0) : offset;
  var len = lena - ofs | 0;
  var result = new Array(len);
  for(var i = 0; i < len; ++i){
    result[i] = a[ofs + i | 0];
  }
  return result;
}

function fill(a, offset, len, v) {
  if (len <= 0) {
    return ;
  }
  var lena = a.length;
  var ofs = offset < 0 ? Caml.caml_int_max(lena + offset | 0, 0) : offset;
  var hasLen = lena - ofs | 0;
  var fillLength = hasLen < len ? hasLen : len;
  if (fillLength <= 0) {
    return ;
  }
  for(var i = ofs ,i_finish = ofs + fillLength | 0; i < i_finish; ++i){
    a[i] = v;
  }
  
}

function blitUnsafe(a1, srcofs1, a2, srcofs2, blitLength) {
  if (srcofs2 <= srcofs1) {
    for(var j = 0; j < blitLength; ++j){
      a2[j + srcofs2 | 0] = a1[j + srcofs1 | 0];
    }
    return ;
  }
  for(var j$1 = blitLength - 1 | 0; j$1 >= 0; --j$1){
    a2[j$1 + srcofs2 | 0] = a1[j$1 + srcofs1 | 0];
  }
  
}

function blit(a1, ofs1, a2, ofs2, len) {
  var lena1 = a1.length;
  var lena2 = a2.length;
  var srcofs1 = ofs1 < 0 ? Caml.caml_int_max(lena1 + ofs1 | 0, 0) : ofs1;
  var srcofs2 = ofs2 < 0 ? Caml.caml_int_max(lena2 + ofs2 | 0, 0) : ofs2;
  var blitLength = Caml.caml_int_min(len, Caml.caml_int_min(lena1 - srcofs1 | 0, lena2 - srcofs2 | 0));
  if (srcofs2 <= srcofs1) {
    for(var j = 0; j < blitLength; ++j){
      a2[j + srcofs2 | 0] = a1[j + srcofs1 | 0];
    }
    return ;
  }
  for(var j$1 = blitLength - 1 | 0; j$1 >= 0; --j$1){
    a2[j$1 + srcofs2 | 0] = a1[j$1 + srcofs1 | 0];
  }
  
}

function forEachU(a, f) {
  for(var i = 0 ,i_finish = a.length; i < i_finish; ++i){
    f(a[i]);
  }
  
}

function forEach(a, f) {
  return forEachU(a, Curry.__1(f));
}

function mapU(a, f) {
  var l = a.length;
  var r = new Array(l);
  for(var i = 0; i < l; ++i){
    r[i] = f(a[i]);
  }
  return r;
}

function map(a, f) {
  return mapU(a, Curry.__1(f));
}

function getByU(a, p) {
  var l = a.length;
  var i = 0;
  var r;
  while(r === undefined && i < l) {
    var v = a[i];
    if (p(v)) {
      r = Caml_option.some(v);
    }
    i = i + 1 | 0;
  };
  return r;
}

function getBy(a, p) {
  return getByU(a, Curry.__1(p));
}

function getIndexByU(a, p) {
  var l = a.length;
  var i = 0;
  var r;
  while(r === undefined && i < l) {
    var v = a[i];
    if (p(v)) {
      r = i;
    }
    i = i + 1 | 0;
  };
  return r;
}

function getIndexBy(a, p) {
  return getIndexByU(a, Curry.__1(p));
}

function keepU(a, f) {
  var l = a.length;
  var r = new Array(l);
  var j = 0;
  for(var i = 0; i < l; ++i){
    var v = a[i];
    if (f(v)) {
      r[j] = v;
      j = j + 1 | 0;
    }
    
  }
  r.length = j;
  return r;
}

function keep(a, f) {
  return keepU(a, Curry.__1(f));
}

function keepWithIndexU(a, f) {
  var l = a.length;
  var r = new Array(l);
  var j = 0;
  for(var i = 0; i < l; ++i){
    var v = a[i];
    if (f(v, i)) {
      r[j] = v;
      j = j + 1 | 0;
    }
    
  }
  r.length = j;
  return r;
}

function keepWithIndex(a, f) {
  return keepWithIndexU(a, Curry.__2(f));
}

function keepMapU(a, f) {
  var l = a.length;
  var r = new Array(l);
  var j = 0;
  for(var i = 0; i < l; ++i){
    var v = a[i];
    var v$1 = f(v);
    if (v$1 !== undefined) {
      r[j] = Caml_option.valFromOption(v$1);
      j = j + 1 | 0;
    }
    
  }
  r.length = j;
  return r;
}

function keepMap(a, f) {
  return keepMapU(a, Curry.__1(f));
}

function forEachWithIndexU(a, f) {
  for(var i = 0 ,i_finish = a.length; i < i_finish; ++i){
    f(i, a[i]);
  }
  
}

function forEachWithIndex(a, f) {
  return forEachWithIndexU(a, Curry.__2(f));
}

function mapWithIndexU(a, f) {
  var l = a.length;
  var r = new Array(l);
  for(var i = 0; i < l; ++i){
    r[i] = f(i, a[i]);
  }
  return r;
}

function mapWithIndex(a, f) {
  return mapWithIndexU(a, Curry.__2(f));
}

function reduceU(a, x, f) {
  var r = x;
  for(var i = 0 ,i_finish = a.length; i < i_finish; ++i){
    r = f(r, a[i]);
  }
  return r;
}

function reduce(a, x, f) {
  return reduceU(a, x, Curry.__2(f));
}

function reduceReverseU(a, x, f) {
  var r = x;
  for(var i = a.length - 1 | 0; i >= 0; --i){
    r = f(r, a[i]);
  }
  return r;
}

function reduceReverse(a, x, f) {
  return reduceReverseU(a, x, Curry.__2(f));
}

function reduceReverse2U(a, b, x, f) {
  var r = x;
  var len = Caml.caml_int_min(a.length, b.length);
  for(var i = len - 1 | 0; i >= 0; --i){
    r = f(r, a[i], b[i]);
  }
  return r;
}

function reduceReverse2(a, b, x, f) {
  return reduceReverse2U(a, b, x, Curry.__3(f));
}

function reduceWithIndexU(a, x, f) {
  var r = x;
  for(var i = 0 ,i_finish = a.length; i < i_finish; ++i){
    r = f(r, a[i], i);
  }
  return r;
}

function reduceWithIndex(a, x, f) {
  return reduceWithIndexU(a, x, Curry.__3(f));
}

function everyU(arr, b) {
  var len = arr.length;
  var _i = 0;
  while(true) {
    var i = _i;
    if (i === len) {
      return true;
    }
    if (!b(arr[i])) {
      return false;
    }
    _i = i + 1 | 0;
    continue ;
  };
}

function every(arr, f) {
  return everyU(arr, Curry.__1(f));
}

function someU(arr, b) {
  var len = arr.length;
  var _i = 0;
  while(true) {
    var i = _i;
    if (i === len) {
      return false;
    }
    if (b(arr[i])) {
      return true;
    }
    _i = i + 1 | 0;
    continue ;
  };
}

function some(arr, f) {
  return someU(arr, Curry.__1(f));
}

function everyAux2(arr1, arr2, _i, b, len) {
  while(true) {
    var i = _i;
    if (i === len) {
      return true;
    }
    if (!b(arr1[i], arr2[i])) {
      return false;
    }
    _i = i + 1 | 0;
    continue ;
  };
}

function every2U(a, b, p) {
  return everyAux2(a, b, 0, p, Caml.caml_int_min(a.length, b.length));
}

function every2(a, b, p) {
  return every2U(a, b, Curry.__2(p));
}

function some2U(a, b, p) {
  var _i = 0;
  var len = Caml.caml_int_min(a.length, b.length);
  while(true) {
    var i = _i;
    if (i === len) {
      return false;
    }
    if (p(a[i], b[i])) {
      return true;
    }
    _i = i + 1 | 0;
    continue ;
  };
}

function some2(a, b, p) {
  return some2U(a, b, Curry.__2(p));
}

function eqU(a, b, p) {
  var lena = a.length;
  var lenb = b.length;
  if (lena === lenb) {
    return everyAux2(a, b, 0, p, lena);
  } else {
    return false;
  }
}

function eq(a, b, p) {
  return eqU(a, b, Curry.__2(p));
}

function cmpU(a, b, p) {
  var lena = a.length;
  var lenb = b.length;
  if (lena > lenb) {
    return 1;
  } else if (lena < lenb) {
    return -1;
  } else {
    var _i = 0;
    while(true) {
      var i = _i;
      if (i === lena) {
        return 0;
      }
      var c = p(a[i], b[i]);
      if (c !== 0) {
        return c;
      }
      _i = i + 1 | 0;
      continue ;
    };
  }
}

function cmp(a, b, p) {
  return cmpU(a, b, Curry.__2(p));
}

function partitionU(a, f) {
  var l = a.length;
  var i = 0;
  var j = 0;
  var a1 = new Array(l);
  var a2 = new Array(l);
  for(var ii = 0; ii < l; ++ii){
    var v = a[ii];
    if (f(v)) {
      a1[i] = v;
      i = i + 1 | 0;
    } else {
      a2[j] = v;
      j = j + 1 | 0;
    }
  }
  a1.length = i;
  a2.length = j;
  return [
          a1,
          a2
        ];
}

function partition(a, f) {
  return partitionU(a, Curry.__1(f));
}

function unzip(a) {
  var l = a.length;
  var a1 = new Array(l);
  var a2 = new Array(l);
  for(var i = 0; i < l; ++i){
    var match = a[i];
    a1[i] = match[0];
    a2[i] = match[1];
  }
  return [
          a1,
          a2
        ];
}

function joinWithU(a, sep, toString) {
  var l = a.length;
  if (l === 0) {
    return "";
  }
  var lastIndex = l - 1 | 0;
  var _i = 0;
  var _res = "";
  while(true) {
    var res = _res;
    var i = _i;
    if (i === lastIndex) {
      return res + toString(a[i]);
    }
    _res = res + (toString(a[i]) + sep);
    _i = i + 1 | 0;
    continue ;
  };
}

function joinWith(a, sep, toString) {
  return joinWithU(a, sep, Curry.__1(toString));
}

exports.get = get;
exports.getExn = getExn;
exports.set = set;
exports.setExn = setExn;
exports.shuffleInPlace = shuffleInPlace;
exports.shuffle = shuffle;
exports.reverseInPlace = reverseInPlace;
exports.reverse = reverse;
exports.make = make;
exports.range = range;
exports.rangeBy = rangeBy;
exports.makeByU = makeByU;
exports.makeBy = makeBy;
exports.makeByAndShuffleU = makeByAndShuffleU;
exports.makeByAndShuffle = makeByAndShuffle;
exports.zip = zip;
exports.zipByU = zipByU;
exports.zipBy = zipBy;
exports.unzip = unzip;
exports.concat = concat;
exports.concatMany = concatMany;
exports.slice = slice;
exports.sliceToEnd = sliceToEnd;
exports.fill = fill;
exports.blit = blit;
exports.blitUnsafe = blitUnsafe;
exports.forEachU = forEachU;
exports.forEach = forEach;
exports.mapU = mapU;
exports.map = map;
exports.getByU = getByU;
exports.getBy = getBy;
exports.getIndexByU = getIndexByU;
exports.getIndexBy = getIndexBy;
exports.keepU = keepU;
exports.keep = keep;
exports.keepWithIndexU = keepWithIndexU;
exports.keepWithIndex = keepWithIndex;
exports.keepMapU = keepMapU;
exports.keepMap = keepMap;
exports.forEachWithIndexU = forEachWithIndexU;
exports.forEachWithIndex = forEachWithIndex;
exports.mapWithIndexU = mapWithIndexU;
exports.mapWithIndex = mapWithIndex;
exports.partitionU = partitionU;
exports.partition = partition;
exports.reduceU = reduceU;
exports.reduce = reduce;
exports.reduceReverseU = reduceReverseU;
exports.reduceReverse = reduceReverse;
exports.reduceReverse2U = reduceReverse2U;
exports.reduceReverse2 = reduceReverse2;
exports.reduceWithIndexU = reduceWithIndexU;
exports.reduceWithIndex = reduceWithIndex;
exports.joinWithU = joinWithU;
exports.joinWith = joinWith;
exports.someU = someU;
exports.some = some;
exports.everyU = everyU;
exports.every = every;
exports.every2U = every2U;
exports.every2 = every2;
exports.some2U = some2U;
exports.some2 = some2;
exports.cmpU = cmpU;
exports.cmp = cmp;
exports.eqU = eqU;
exports.eq = eq;
/* No side effect */


/***/ }),

/***/ 11332:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var Curry = __webpack_require__(41386);
var Belt_Array = __webpack_require__(2971);
var Caml_option = __webpack_require__(57175);
var Belt_SortArray = __webpack_require__(62531);

function head(x) {
  if (x) {
    return Caml_option.some(x.hd);
  }
  
}

function headExn(x) {
  if (x) {
    return x.hd;
  }
  throw {
        RE_EXN_ID: "Not_found",
        Error: new Error()
      };
}

function tail(x) {
  if (x) {
    return x.tl;
  }
  
}

function tailExn(x) {
  if (x) {
    return x.tl;
  }
  throw {
        RE_EXN_ID: "Not_found",
        Error: new Error()
      };
}

function add(xs, x) {
  return {
          hd: x,
          tl: xs
        };
}

function get(x, n) {
  if (n < 0) {
    return ;
  } else {
    var _x = x;
    var _n = n;
    while(true) {
      var n$1 = _n;
      var x$1 = _x;
      if (!x$1) {
        return ;
      }
      if (n$1 === 0) {
        return Caml_option.some(x$1.hd);
      }
      _n = n$1 - 1 | 0;
      _x = x$1.tl;
      continue ;
    };
  }
}

function getExn(x, n) {
  if (n < 0) {
    throw {
          RE_EXN_ID: "Not_found",
          Error: new Error()
        };
  }
  var _x = x;
  var _n = n;
  while(true) {
    var n$1 = _n;
    var x$1 = _x;
    if (x$1) {
      if (n$1 === 0) {
        return x$1.hd;
      }
      _n = n$1 - 1 | 0;
      _x = x$1.tl;
      continue ;
    }
    throw {
          RE_EXN_ID: "Not_found",
          Error: new Error()
        };
  };
}

function partitionAux(p, _cell, _precX, _precY) {
  while(true) {
    var precY = _precY;
    var precX = _precX;
    var cell = _cell;
    if (!cell) {
      return ;
    }
    var t = cell.tl;
    var h = cell.hd;
    var next = {
      hd: h,
      tl: /* [] */0
    };
    if (p(h)) {
      precX.tl = next;
      _precX = next;
      _cell = t;
      continue ;
    }
    precY.tl = next;
    _precY = next;
    _cell = t;
    continue ;
  };
}

function splitAux(_cell, _precX, _precY) {
  while(true) {
    var precY = _precY;
    var precX = _precX;
    var cell = _cell;
    if (!cell) {
      return ;
    }
    var match = cell.hd;
    var nextA = {
      hd: match[0],
      tl: /* [] */0
    };
    var nextB = {
      hd: match[1],
      tl: /* [] */0
    };
    precX.tl = nextA;
    precY.tl = nextB;
    _precY = nextB;
    _precX = nextA;
    _cell = cell.tl;
    continue ;
  };
}

function copyAuxCont(_cellX, _prec) {
  while(true) {
    var prec = _prec;
    var cellX = _cellX;
    if (!cellX) {
      return prec;
    }
    var next = {
      hd: cellX.hd,
      tl: /* [] */0
    };
    prec.tl = next;
    _prec = next;
    _cellX = cellX.tl;
    continue ;
  };
}

function copyAuxWitFilter(f, _cellX, _prec) {
  while(true) {
    var prec = _prec;
    var cellX = _cellX;
    if (!cellX) {
      return ;
    }
    var t = cellX.tl;
    var h = cellX.hd;
    if (f(h)) {
      var next = {
        hd: h,
        tl: /* [] */0
      };
      prec.tl = next;
      _prec = next;
      _cellX = t;
      continue ;
    }
    _cellX = t;
    continue ;
  };
}

function copyAuxWithFilterIndex(f, _cellX, _prec, _i) {
  while(true) {
    var i = _i;
    var prec = _prec;
    var cellX = _cellX;
    if (!cellX) {
      return ;
    }
    var t = cellX.tl;
    var h = cellX.hd;
    if (f(h, i)) {
      var next = {
        hd: h,
        tl: /* [] */0
      };
      prec.tl = next;
      _i = i + 1 | 0;
      _prec = next;
      _cellX = t;
      continue ;
    }
    _i = i + 1 | 0;
    _cellX = t;
    continue ;
  };
}

function copyAuxWitFilterMap(f, _cellX, _prec) {
  while(true) {
    var prec = _prec;
    var cellX = _cellX;
    if (!cellX) {
      return ;
    }
    var t = cellX.tl;
    var h = f(cellX.hd);
    if (h !== undefined) {
      var next = {
        hd: Caml_option.valFromOption(h),
        tl: /* [] */0
      };
      prec.tl = next;
      _prec = next;
      _cellX = t;
      continue ;
    }
    _cellX = t;
    continue ;
  };
}

function removeAssocAuxWithMap(_cellX, x, _prec, f) {
  while(true) {
    var prec = _prec;
    var cellX = _cellX;
    if (!cellX) {
      return false;
    }
    var t = cellX.tl;
    var h = cellX.hd;
    if (f(h[0], x)) {
      prec.tl = t;
      return true;
    }
    var next = {
      hd: h,
      tl: /* [] */0
    };
    prec.tl = next;
    _prec = next;
    _cellX = t;
    continue ;
  };
}

function setAssocAuxWithMap(_cellX, x, k, _prec, eq) {
  while(true) {
    var prec = _prec;
    var cellX = _cellX;
    if (!cellX) {
      return false;
    }
    var t = cellX.tl;
    var h = cellX.hd;
    if (eq(h[0], x)) {
      prec.tl = {
        hd: [
          x,
          k
        ],
        tl: t
      };
      return true;
    }
    var next = {
      hd: h,
      tl: /* [] */0
    };
    prec.tl = next;
    _prec = next;
    _cellX = t;
    continue ;
  };
}

function copyAuxWithMap(_cellX, _prec, f) {
  while(true) {
    var prec = _prec;
    var cellX = _cellX;
    if (!cellX) {
      return ;
    }
    var next = {
      hd: f(cellX.hd),
      tl: /* [] */0
    };
    prec.tl = next;
    _prec = next;
    _cellX = cellX.tl;
    continue ;
  };
}

function zipAux(_cellX, _cellY, _prec) {
  while(true) {
    var prec = _prec;
    var cellY = _cellY;
    var cellX = _cellX;
    if (!cellX) {
      return ;
    }
    if (!cellY) {
      return ;
    }
    var next = {
      hd: [
        cellX.hd,
        cellY.hd
      ],
      tl: /* [] */0
    };
    prec.tl = next;
    _prec = next;
    _cellY = cellY.tl;
    _cellX = cellX.tl;
    continue ;
  };
}

function copyAuxWithMap2(f, _cellX, _cellY, _prec) {
  while(true) {
    var prec = _prec;
    var cellY = _cellY;
    var cellX = _cellX;
    if (!cellX) {
      return ;
    }
    if (!cellY) {
      return ;
    }
    var next = {
      hd: f(cellX.hd, cellY.hd),
      tl: /* [] */0
    };
    prec.tl = next;
    _prec = next;
    _cellY = cellY.tl;
    _cellX = cellX.tl;
    continue ;
  };
}

function copyAuxWithMapI(f, _i, _cellX, _prec) {
  while(true) {
    var prec = _prec;
    var cellX = _cellX;
    var i = _i;
    if (!cellX) {
      return ;
    }
    var next = {
      hd: f(i, cellX.hd),
      tl: /* [] */0
    };
    prec.tl = next;
    _prec = next;
    _cellX = cellX.tl;
    _i = i + 1 | 0;
    continue ;
  };
}

function takeAux(_n, _cell, _prec) {
  while(true) {
    var prec = _prec;
    var cell = _cell;
    var n = _n;
    if (n === 0) {
      return true;
    }
    if (!cell) {
      return false;
    }
    var cell$1 = {
      hd: cell.hd,
      tl: /* [] */0
    };
    prec.tl = cell$1;
    _prec = cell$1;
    _cell = cell.tl;
    _n = n - 1 | 0;
    continue ;
  };
}

function splitAtAux(_n, _cell, _prec) {
  while(true) {
    var prec = _prec;
    var cell = _cell;
    var n = _n;
    if (n === 0) {
      return cell;
    }
    if (!cell) {
      return ;
    }
    var cell$1 = {
      hd: cell.hd,
      tl: /* [] */0
    };
    prec.tl = cell$1;
    _prec = cell$1;
    _cell = cell.tl;
    _n = n - 1 | 0;
    continue ;
  };
}

function take(lst, n) {
  if (n < 0) {
    return ;
  }
  if (n === 0) {
    return /* [] */0;
  }
  if (!lst) {
    return ;
  }
  var cell = {
    hd: lst.hd,
    tl: /* [] */0
  };
  var has = takeAux(n - 1 | 0, lst.tl, cell);
  if (has) {
    return cell;
  }
  
}

function drop(lst, n) {
  if (n < 0) {
    return ;
  } else {
    var _l = lst;
    var _n = n;
    while(true) {
      var n$1 = _n;
      var l = _l;
      if (n$1 === 0) {
        return l;
      }
      if (!l) {
        return ;
      }
      _n = n$1 - 1 | 0;
      _l = l.tl;
      continue ;
    };
  }
}

function splitAt(lst, n) {
  if (n < 0) {
    return ;
  }
  if (n === 0) {
    return [
            /* [] */0,
            lst
          ];
  }
  if (!lst) {
    return ;
  }
  var cell = {
    hd: lst.hd,
    tl: /* [] */0
  };
  var rest = splitAtAux(n - 1 | 0, lst.tl, cell);
  if (rest !== undefined) {
    return [
            cell,
            rest
          ];
  }
  
}

function concat(xs, ys) {
  if (!xs) {
    return ys;
  }
  var cell = {
    hd: xs.hd,
    tl: /* [] */0
  };
  copyAuxCont(xs.tl, cell).tl = ys;
  return cell;
}

function mapU(xs, f) {
  if (!xs) {
    return /* [] */0;
  }
  var cell = {
    hd: f(xs.hd),
    tl: /* [] */0
  };
  copyAuxWithMap(xs.tl, cell, f);
  return cell;
}

function map(xs, f) {
  return mapU(xs, Curry.__1(f));
}

function zipByU(l1, l2, f) {
  if (!l1) {
    return /* [] */0;
  }
  if (!l2) {
    return /* [] */0;
  }
  var cell = {
    hd: f(l1.hd, l2.hd),
    tl: /* [] */0
  };
  copyAuxWithMap2(f, l1.tl, l2.tl, cell);
  return cell;
}

function zipBy(l1, l2, f) {
  return zipByU(l1, l2, Curry.__2(f));
}

function mapWithIndexU(xs, f) {
  if (!xs) {
    return /* [] */0;
  }
  var cell = {
    hd: f(0, xs.hd),
    tl: /* [] */0
  };
  copyAuxWithMapI(f, 1, xs.tl, cell);
  return cell;
}

function mapWithIndex(xs, f) {
  return mapWithIndexU(xs, Curry.__2(f));
}

function makeByU(n, f) {
  if (n <= 0) {
    return /* [] */0;
  }
  var headX = {
    hd: f(0),
    tl: /* [] */0
  };
  var cur = headX;
  var i = 1;
  while(i < n) {
    var v = {
      hd: f(i),
      tl: /* [] */0
    };
    cur.tl = v;
    cur = v;
    i = i + 1 | 0;
  };
  return headX;
}

function makeBy(n, f) {
  return makeByU(n, Curry.__1(f));
}

function make(n, v) {
  if (n <= 0) {
    return /* [] */0;
  }
  var headX = {
    hd: v,
    tl: /* [] */0
  };
  var cur = headX;
  var i = 1;
  while(i < n) {
    var v$1 = {
      hd: v,
      tl: /* [] */0
    };
    cur.tl = v$1;
    cur = v$1;
    i = i + 1 | 0;
  };
  return headX;
}

function length(xs) {
  var _x = xs;
  var _acc = 0;
  while(true) {
    var acc = _acc;
    var x = _x;
    if (!x) {
      return acc;
    }
    _acc = acc + 1 | 0;
    _x = x.tl;
    continue ;
  };
}

function fillAux(arr, _i, _x) {
  while(true) {
    var x = _x;
    var i = _i;
    if (!x) {
      return ;
    }
    arr[i] = x.hd;
    _x = x.tl;
    _i = i + 1 | 0;
    continue ;
  };
}

function fromArray(a) {
  var _i = a.length - 1 | 0;
  var _res = /* [] */0;
  while(true) {
    var res = _res;
    var i = _i;
    if (i < 0) {
      return res;
    }
    _res = {
      hd: a[i],
      tl: res
    };
    _i = i - 1 | 0;
    continue ;
  };
}

function toArray(x) {
  var len = length(x);
  var arr = new Array(len);
  fillAux(arr, 0, x);
  return arr;
}

function shuffle(xs) {
  var v = toArray(xs);
  Belt_Array.shuffleInPlace(v);
  return fromArray(v);
}

function reverseConcat(_l1, _l2) {
  while(true) {
    var l2 = _l2;
    var l1 = _l1;
    if (!l1) {
      return l2;
    }
    _l2 = {
      hd: l1.hd,
      tl: l2
    };
    _l1 = l1.tl;
    continue ;
  };
}

function reverse(l) {
  return reverseConcat(l, /* [] */0);
}

function flattenAux(_prec, _xs) {
  while(true) {
    var xs = _xs;
    var prec = _prec;
    if (xs) {
      _xs = xs.tl;
      _prec = copyAuxCont(xs.hd, prec);
      continue ;
    }
    prec.tl = /* [] */0;
    return ;
  };
}

function flatten(_xs) {
  while(true) {
    var xs = _xs;
    if (!xs) {
      return /* [] */0;
    }
    var match = xs.hd;
    if (match) {
      var cell = {
        hd: match.hd,
        tl: /* [] */0
      };
      flattenAux(copyAuxCont(match.tl, cell), xs.tl);
      return cell;
    }
    _xs = xs.tl;
    continue ;
  };
}

function concatMany(xs) {
  var len = xs.length;
  if (len === 1) {
    return xs[0];
  }
  if (len === 0) {
    return /* [] */0;
  }
  var len$1 = xs.length;
  var v = xs[len$1 - 1 | 0];
  for(var i = len$1 - 2 | 0; i >= 0; --i){
    v = concat(xs[i], v);
  }
  return v;
}

function mapReverseU(l, f) {
  var _accu = /* [] */0;
  var _xs = l;
  while(true) {
    var xs = _xs;
    var accu = _accu;
    if (!xs) {
      return accu;
    }
    _xs = xs.tl;
    _accu = {
      hd: f(xs.hd),
      tl: accu
    };
    continue ;
  };
}

function mapReverse(l, f) {
  return mapReverseU(l, Curry.__1(f));
}

function forEachU(_xs, f) {
  while(true) {
    var xs = _xs;
    if (!xs) {
      return ;
    }
    f(xs.hd);
    _xs = xs.tl;
    continue ;
  };
}

function forEach(xs, f) {
  return forEachU(xs, Curry.__1(f));
}

function forEachWithIndexU(l, f) {
  var _xs = l;
  var _i = 0;
  while(true) {
    var i = _i;
    var xs = _xs;
    if (!xs) {
      return ;
    }
    f(i, xs.hd);
    _i = i + 1 | 0;
    _xs = xs.tl;
    continue ;
  };
}

function forEachWithIndex(l, f) {
  return forEachWithIndexU(l, Curry.__2(f));
}

function reduceU(_l, _accu, f) {
  while(true) {
    var accu = _accu;
    var l = _l;
    if (!l) {
      return accu;
    }
    _accu = f(accu, l.hd);
    _l = l.tl;
    continue ;
  };
}

function reduce(l, accu, f) {
  return reduceU(l, accu, Curry.__2(f));
}

function reduceReverseUnsafeU(l, accu, f) {
  if (l) {
    return f(reduceReverseUnsafeU(l.tl, accu, f), l.hd);
  } else {
    return accu;
  }
}

function reduceReverseU(l, acc, f) {
  var len = length(l);
  if (len < 1000) {
    return reduceReverseUnsafeU(l, acc, f);
  } else {
    return Belt_Array.reduceReverseU(toArray(l), acc, f);
  }
}

function reduceReverse(l, accu, f) {
  return reduceReverseU(l, accu, Curry.__2(f));
}

function reduceWithIndexU(l, acc, f) {
  var _l = l;
  var _acc = acc;
  var _i = 0;
  while(true) {
    var i = _i;
    var acc$1 = _acc;
    var l$1 = _l;
    if (!l$1) {
      return acc$1;
    }
    _i = i + 1 | 0;
    _acc = f(acc$1, l$1.hd, i);
    _l = l$1.tl;
    continue ;
  };
}

function reduceWithIndex(l, acc, f) {
  return reduceWithIndexU(l, acc, Curry.__3(f));
}

function mapReverse2U(l1, l2, f) {
  var _l1 = l1;
  var _l2 = l2;
  var _accu = /* [] */0;
  while(true) {
    var accu = _accu;
    var l2$1 = _l2;
    var l1$1 = _l1;
    if (!l1$1) {
      return accu;
    }
    if (!l2$1) {
      return accu;
    }
    _accu = {
      hd: f(l1$1.hd, l2$1.hd),
      tl: accu
    };
    _l2 = l2$1.tl;
    _l1 = l1$1.tl;
    continue ;
  };
}

function mapReverse2(l1, l2, f) {
  return mapReverse2U(l1, l2, Curry.__2(f));
}

function forEach2U(_l1, _l2, f) {
  while(true) {
    var l2 = _l2;
    var l1 = _l1;
    if (!l1) {
      return ;
    }
    if (!l2) {
      return ;
    }
    f(l1.hd, l2.hd);
    _l2 = l2.tl;
    _l1 = l1.tl;
    continue ;
  };
}

function forEach2(l1, l2, f) {
  return forEach2U(l1, l2, Curry.__2(f));
}

function reduce2U(_l1, _l2, _accu, f) {
  while(true) {
    var accu = _accu;
    var l2 = _l2;
    var l1 = _l1;
    if (!l1) {
      return accu;
    }
    if (!l2) {
      return accu;
    }
    _accu = f(accu, l1.hd, l2.hd);
    _l2 = l2.tl;
    _l1 = l1.tl;
    continue ;
  };
}

function reduce2(l1, l2, acc, f) {
  return reduce2U(l1, l2, acc, Curry.__3(f));
}

function reduceReverse2UnsafeU(l1, l2, accu, f) {
  if (l1 && l2) {
    return f(reduceReverse2UnsafeU(l1.tl, l2.tl, accu, f), l1.hd, l2.hd);
  } else {
    return accu;
  }
}

function reduceReverse2U(l1, l2, acc, f) {
  var len = length(l1);
  if (len < 1000) {
    return reduceReverse2UnsafeU(l1, l2, acc, f);
  } else {
    return Belt_Array.reduceReverse2U(toArray(l1), toArray(l2), acc, f);
  }
}

function reduceReverse2(l1, l2, acc, f) {
  return reduceReverse2U(l1, l2, acc, Curry.__3(f));
}

function everyU(_xs, p) {
  while(true) {
    var xs = _xs;
    if (!xs) {
      return true;
    }
    if (!p(xs.hd)) {
      return false;
    }
    _xs = xs.tl;
    continue ;
  };
}

function every(xs, p) {
  return everyU(xs, Curry.__1(p));
}

function someU(_xs, p) {
  while(true) {
    var xs = _xs;
    if (!xs) {
      return false;
    }
    if (p(xs.hd)) {
      return true;
    }
    _xs = xs.tl;
    continue ;
  };
}

function some(xs, p) {
  return someU(xs, Curry.__1(p));
}

function every2U(_l1, _l2, p) {
  while(true) {
    var l2 = _l2;
    var l1 = _l1;
    if (!l1) {
      return true;
    }
    if (!l2) {
      return true;
    }
    if (!p(l1.hd, l2.hd)) {
      return false;
    }
    _l2 = l2.tl;
    _l1 = l1.tl;
    continue ;
  };
}

function every2(l1, l2, p) {
  return every2U(l1, l2, Curry.__2(p));
}

function cmpByLength(_l1, _l2) {
  while(true) {
    var l2 = _l2;
    var l1 = _l1;
    if (!l1) {
      if (l2) {
        return -1;
      } else {
        return 0;
      }
    }
    if (!l2) {
      return 1;
    }
    _l2 = l2.tl;
    _l1 = l1.tl;
    continue ;
  };
}

function cmpU(_l1, _l2, p) {
  while(true) {
    var l2 = _l2;
    var l1 = _l1;
    if (!l1) {
      if (l2) {
        return -1;
      } else {
        return 0;
      }
    }
    if (!l2) {
      return 1;
    }
    var c = p(l1.hd, l2.hd);
    if (c !== 0) {
      return c;
    }
    _l2 = l2.tl;
    _l1 = l1.tl;
    continue ;
  };
}

function cmp(l1, l2, f) {
  return cmpU(l1, l2, Curry.__2(f));
}

function eqU(_l1, _l2, p) {
  while(true) {
    var l2 = _l2;
    var l1 = _l1;
    if (!l1) {
      if (l2) {
        return false;
      } else {
        return true;
      }
    }
    if (!l2) {
      return false;
    }
    if (!p(l1.hd, l2.hd)) {
      return false;
    }
    _l2 = l2.tl;
    _l1 = l1.tl;
    continue ;
  };
}

function eq(l1, l2, f) {
  return eqU(l1, l2, Curry.__2(f));
}

function some2U(_l1, _l2, p) {
  while(true) {
    var l2 = _l2;
    var l1 = _l1;
    if (!l1) {
      return false;
    }
    if (!l2) {
      return false;
    }
    if (p(l1.hd, l2.hd)) {
      return true;
    }
    _l2 = l2.tl;
    _l1 = l1.tl;
    continue ;
  };
}

function some2(l1, l2, p) {
  return some2U(l1, l2, Curry.__2(p));
}

function hasU(_xs, x, eq) {
  while(true) {
    var xs = _xs;
    if (!xs) {
      return false;
    }
    if (eq(xs.hd, x)) {
      return true;
    }
    _xs = xs.tl;
    continue ;
  };
}

function has(xs, x, eq) {
  return hasU(xs, x, Curry.__2(eq));
}

function getAssocU(_xs, x, eq) {
  while(true) {
    var xs = _xs;
    if (!xs) {
      return ;
    }
    var match = xs.hd;
    if (eq(match[0], x)) {
      return Caml_option.some(match[1]);
    }
    _xs = xs.tl;
    continue ;
  };
}

function getAssoc(xs, x, eq) {
  return getAssocU(xs, x, Curry.__2(eq));
}

function hasAssocU(_xs, x, eq) {
  while(true) {
    var xs = _xs;
    if (!xs) {
      return false;
    }
    if (eq(xs.hd[0], x)) {
      return true;
    }
    _xs = xs.tl;
    continue ;
  };
}

function hasAssoc(xs, x, eq) {
  return hasAssocU(xs, x, Curry.__2(eq));
}

function removeAssocU(xs, x, eq) {
  if (!xs) {
    return /* [] */0;
  }
  var l = xs.tl;
  var pair = xs.hd;
  if (eq(pair[0], x)) {
    return l;
  }
  var cell = {
    hd: pair,
    tl: /* [] */0
  };
  var removed = removeAssocAuxWithMap(l, x, cell, eq);
  if (removed) {
    return cell;
  } else {
    return xs;
  }
}

function removeAssoc(xs, x, eq) {
  return removeAssocU(xs, x, Curry.__2(eq));
}

function setAssocU(xs, x, k, eq) {
  if (!xs) {
    return {
            hd: [
              x,
              k
            ],
            tl: /* [] */0
          };
  }
  var l = xs.tl;
  var pair = xs.hd;
  if (eq(pair[0], x)) {
    return {
            hd: [
              x,
              k
            ],
            tl: l
          };
  }
  var cell = {
    hd: pair,
    tl: /* [] */0
  };
  var replaced = setAssocAuxWithMap(l, x, k, cell, eq);
  if (replaced) {
    return cell;
  } else {
    return {
            hd: [
              x,
              k
            ],
            tl: xs
          };
  }
}

function setAssoc(xs, x, k, eq) {
  return setAssocU(xs, x, k, Curry.__2(eq));
}

function sortU(xs, cmp) {
  var arr = toArray(xs);
  Belt_SortArray.stableSortInPlaceByU(arr, cmp);
  return fromArray(arr);
}

function sort(xs, cmp) {
  return sortU(xs, Curry.__2(cmp));
}

function getByU(_xs, p) {
  while(true) {
    var xs = _xs;
    if (!xs) {
      return ;
    }
    var x = xs.hd;
    if (p(x)) {
      return Caml_option.some(x);
    }
    _xs = xs.tl;
    continue ;
  };
}

function getBy(xs, p) {
  return getByU(xs, Curry.__1(p));
}

function keepU(_xs, p) {
  while(true) {
    var xs = _xs;
    if (!xs) {
      return /* [] */0;
    }
    var t = xs.tl;
    var h = xs.hd;
    if (p(h)) {
      var cell = {
        hd: h,
        tl: /* [] */0
      };
      copyAuxWitFilter(p, t, cell);
      return cell;
    }
    _xs = t;
    continue ;
  };
}

function keep(xs, p) {
  return keepU(xs, Curry.__1(p));
}

function keepWithIndexU(xs, p) {
  var _xs = xs;
  var _i = 0;
  while(true) {
    var i = _i;
    var xs$1 = _xs;
    if (!xs$1) {
      return /* [] */0;
    }
    var t = xs$1.tl;
    var h = xs$1.hd;
    if (p(h, i)) {
      var cell = {
        hd: h,
        tl: /* [] */0
      };
      copyAuxWithFilterIndex(p, t, cell, i + 1 | 0);
      return cell;
    }
    _i = i + 1 | 0;
    _xs = t;
    continue ;
  };
}

function keepWithIndex(xs, p) {
  return keepWithIndexU(xs, Curry.__2(p));
}

function keepMapU(_xs, p) {
  while(true) {
    var xs = _xs;
    if (!xs) {
      return /* [] */0;
    }
    var t = xs.tl;
    var h = p(xs.hd);
    if (h !== undefined) {
      var cell = {
        hd: Caml_option.valFromOption(h),
        tl: /* [] */0
      };
      copyAuxWitFilterMap(p, t, cell);
      return cell;
    }
    _xs = t;
    continue ;
  };
}

function keepMap(xs, p) {
  return keepMapU(xs, Curry.__1(p));
}

function partitionU(l, p) {
  if (!l) {
    return [
            /* [] */0,
            /* [] */0
          ];
  }
  var h = l.hd;
  var nextX = {
    hd: h,
    tl: /* [] */0
  };
  var nextY = {
    hd: h,
    tl: /* [] */0
  };
  var b = p(h);
  partitionAux(p, l.tl, nextX, nextY);
  if (b) {
    return [
            nextX,
            nextY.tl
          ];
  } else {
    return [
            nextX.tl,
            nextY
          ];
  }
}

function partition(l, p) {
  return partitionU(l, Curry.__1(p));
}

function unzip(xs) {
  if (!xs) {
    return [
            /* [] */0,
            /* [] */0
          ];
  }
  var match = xs.hd;
  var cellX = {
    hd: match[0],
    tl: /* [] */0
  };
  var cellY = {
    hd: match[1],
    tl: /* [] */0
  };
  splitAux(xs.tl, cellX, cellY);
  return [
          cellX,
          cellY
        ];
}

function zip(l1, l2) {
  if (!l1) {
    return /* [] */0;
  }
  if (!l2) {
    return /* [] */0;
  }
  var cell = {
    hd: [
      l1.hd,
      l2.hd
    ],
    tl: /* [] */0
  };
  zipAux(l1.tl, l2.tl, cell);
  return cell;
}

var size = length;

var filter = keep;

var filterWithIndex = keepWithIndex;

exports.length = length;
exports.size = size;
exports.head = head;
exports.headExn = headExn;
exports.tail = tail;
exports.tailExn = tailExn;
exports.add = add;
exports.get = get;
exports.getExn = getExn;
exports.make = make;
exports.makeByU = makeByU;
exports.makeBy = makeBy;
exports.shuffle = shuffle;
exports.drop = drop;
exports.take = take;
exports.splitAt = splitAt;
exports.concat = concat;
exports.concatMany = concatMany;
exports.reverseConcat = reverseConcat;
exports.flatten = flatten;
exports.mapU = mapU;
exports.map = map;
exports.zip = zip;
exports.zipByU = zipByU;
exports.zipBy = zipBy;
exports.mapWithIndexU = mapWithIndexU;
exports.mapWithIndex = mapWithIndex;
exports.fromArray = fromArray;
exports.toArray = toArray;
exports.reverse = reverse;
exports.mapReverseU = mapReverseU;
exports.mapReverse = mapReverse;
exports.forEachU = forEachU;
exports.forEach = forEach;
exports.forEachWithIndexU = forEachWithIndexU;
exports.forEachWithIndex = forEachWithIndex;
exports.reduceU = reduceU;
exports.reduce = reduce;
exports.reduceWithIndexU = reduceWithIndexU;
exports.reduceWithIndex = reduceWithIndex;
exports.reduceReverseU = reduceReverseU;
exports.reduceReverse = reduceReverse;
exports.mapReverse2U = mapReverse2U;
exports.mapReverse2 = mapReverse2;
exports.forEach2U = forEach2U;
exports.forEach2 = forEach2;
exports.reduce2U = reduce2U;
exports.reduce2 = reduce2;
exports.reduceReverse2U = reduceReverse2U;
exports.reduceReverse2 = reduceReverse2;
exports.everyU = everyU;
exports.every = every;
exports.someU = someU;
exports.some = some;
exports.every2U = every2U;
exports.every2 = every2;
exports.some2U = some2U;
exports.some2 = some2;
exports.cmpByLength = cmpByLength;
exports.cmpU = cmpU;
exports.cmp = cmp;
exports.eqU = eqU;
exports.eq = eq;
exports.hasU = hasU;
exports.has = has;
exports.getByU = getByU;
exports.getBy = getBy;
exports.keepU = keepU;
exports.keep = keep;
exports.filter = filter;
exports.keepWithIndexU = keepWithIndexU;
exports.keepWithIndex = keepWithIndex;
exports.filterWithIndex = filterWithIndex;
exports.keepMapU = keepMapU;
exports.keepMap = keepMap;
exports.partitionU = partitionU;
exports.partition = partition;
exports.unzip = unzip;
exports.getAssocU = getAssocU;
exports.getAssoc = getAssoc;
exports.hasAssocU = hasAssocU;
exports.hasAssoc = hasAssoc;
exports.removeAssocU = removeAssocU;
exports.removeAssoc = removeAssoc;
exports.setAssocU = setAssocU;
exports.setAssoc = setAssoc;
exports.sortU = sortU;
exports.sort = sort;
/* No side effect */


/***/ }),

/***/ 35082:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var Curry = __webpack_require__(41386);
var Caml_option = __webpack_require__(57175);
var Belt_internalAVLtree = __webpack_require__(46144);
var Belt_internalMapString = __webpack_require__(62459);

function set(t, newK, newD) {
  if (t === undefined) {
    return Belt_internalAVLtree.singleton(newK, newD);
  }
  var k = t.k;
  if (newK === k) {
    return Belt_internalAVLtree.updateValue(t, newD);
  }
  var v = t.v;
  if (newK < k) {
    return Belt_internalAVLtree.bal(set(t.l, newK, newD), k, v, t.r);
  } else {
    return Belt_internalAVLtree.bal(t.l, k, v, set(t.r, newK, newD));
  }
}

function updateU(t, x, f) {
  if (t !== undefined) {
    var k = t.k;
    if (x === k) {
      var data = f(Caml_option.some(t.v));
      if (data !== undefined) {
        return Belt_internalAVLtree.updateValue(t, Caml_option.valFromOption(data));
      }
      var l = t.l;
      var r = t.r;
      if (l === undefined) {
        return r;
      }
      if (r === undefined) {
        return l;
      }
      var kr = {
        contents: r.k
      };
      var vr = {
        contents: r.v
      };
      var r$1 = Belt_internalAVLtree.removeMinAuxWithRef(r, kr, vr);
      return Belt_internalAVLtree.bal(l, kr.contents, vr.contents, r$1);
    }
    var v = t.v;
    var l$1 = t.l;
    var r$2 = t.r;
    if (x < k) {
      var ll = updateU(l$1, x, f);
      if (l$1 === ll) {
        return t;
      } else {
        return Belt_internalAVLtree.bal(ll, k, v, r$2);
      }
    }
    var rr = updateU(r$2, x, f);
    if (r$2 === rr) {
      return t;
    } else {
      return Belt_internalAVLtree.bal(l$1, k, v, rr);
    }
  }
  var data$1 = f(undefined);
  if (data$1 !== undefined) {
    return Belt_internalAVLtree.singleton(x, Caml_option.valFromOption(data$1));
  } else {
    return t;
  }
}

function update(t, x, f) {
  return updateU(t, x, Curry.__1(f));
}

function removeAux(n, x) {
  var v = n.k;
  var l = n.l;
  var r = n.r;
  if (x === v) {
    if (l === undefined) {
      return r;
    }
    if (r === undefined) {
      return l;
    }
    var kr = {
      contents: r.k
    };
    var vr = {
      contents: r.v
    };
    var r$1 = Belt_internalAVLtree.removeMinAuxWithRef(r, kr, vr);
    return Belt_internalAVLtree.bal(l, kr.contents, vr.contents, r$1);
  }
  if (x < v) {
    if (l === undefined) {
      return n;
    }
    var ll = removeAux(l, x);
    if (ll === l) {
      return n;
    } else {
      return Belt_internalAVLtree.bal(ll, v, n.v, r);
    }
  }
  if (r === undefined) {
    return n;
  }
  var rr = removeAux(r, x);
  return Belt_internalAVLtree.bal(l, v, n.v, rr);
}

function remove(n, x) {
  if (n !== undefined) {
    return removeAux(n, x);
  }
  
}

function removeMany(t, keys) {
  var len = keys.length;
  if (t !== undefined) {
    var _t = t;
    var _i = 0;
    while(true) {
      var i = _i;
      var t$1 = _t;
      if (i >= len) {
        return t$1;
      }
      var ele = keys[i];
      var u = removeAux(t$1, ele);
      if (u === undefined) {
        return u;
      }
      _i = i + 1 | 0;
      _t = u;
      continue ;
    };
  }
  
}

function mergeMany(h, arr) {
  var len = arr.length;
  var v = h;
  for(var i = 0; i < len; ++i){
    var match = arr[i];
    v = set(v, match[0], match[1]);
  }
  return v;
}

var empty;

var isEmpty = Belt_internalAVLtree.isEmpty;

var has = Belt_internalMapString.has;

var cmpU = Belt_internalMapString.cmpU;

var cmp = Belt_internalMapString.cmp;

var eqU = Belt_internalMapString.eqU;

var eq = Belt_internalMapString.eq;

var findFirstByU = Belt_internalAVLtree.findFirstByU;

var findFirstBy = Belt_internalAVLtree.findFirstBy;

var forEachU = Belt_internalAVLtree.forEachU;

var forEach = Belt_internalAVLtree.forEach;

var reduceU = Belt_internalAVLtree.reduceU;

var reduce = Belt_internalAVLtree.reduce;

var everyU = Belt_internalAVLtree.everyU;

var every = Belt_internalAVLtree.every;

var someU = Belt_internalAVLtree.someU;

var some = Belt_internalAVLtree.some;

var size = Belt_internalAVLtree.size;

var toList = Belt_internalAVLtree.toList;

var toArray = Belt_internalAVLtree.toArray;

var fromArray = Belt_internalMapString.fromArray;

var keysToArray = Belt_internalAVLtree.keysToArray;

var valuesToArray = Belt_internalAVLtree.valuesToArray;

var minKey = Belt_internalAVLtree.minKey;

var minKeyUndefined = Belt_internalAVLtree.minKeyUndefined;

var maxKey = Belt_internalAVLtree.maxKey;

var maxKeyUndefined = Belt_internalAVLtree.maxKeyUndefined;

var minimum = Belt_internalAVLtree.minimum;

var minUndefined = Belt_internalAVLtree.minUndefined;

var maximum = Belt_internalAVLtree.maximum;

var maxUndefined = Belt_internalAVLtree.maxUndefined;

var get = Belt_internalMapString.get;

var getUndefined = Belt_internalMapString.getUndefined;

var getWithDefault = Belt_internalMapString.getWithDefault;

var getExn = Belt_internalMapString.getExn;

var checkInvariantInternal = Belt_internalAVLtree.checkInvariantInternal;

var mergeU = Belt_internalMapString.mergeU;

var merge = Belt_internalMapString.merge;

var keepU = Belt_internalAVLtree.keepSharedU;

var keep = Belt_internalAVLtree.keepShared;

var partitionU = Belt_internalAVLtree.partitionSharedU;

var partition = Belt_internalAVLtree.partitionShared;

var split = Belt_internalMapString.split;

var mapU = Belt_internalAVLtree.mapU;

var map = Belt_internalAVLtree.map;

var mapWithKeyU = Belt_internalAVLtree.mapWithKeyU;

var mapWithKey = Belt_internalAVLtree.mapWithKey;

exports.empty = empty;
exports.isEmpty = isEmpty;
exports.has = has;
exports.cmpU = cmpU;
exports.cmp = cmp;
exports.eqU = eqU;
exports.eq = eq;
exports.findFirstByU = findFirstByU;
exports.findFirstBy = findFirstBy;
exports.forEachU = forEachU;
exports.forEach = forEach;
exports.reduceU = reduceU;
exports.reduce = reduce;
exports.everyU = everyU;
exports.every = every;
exports.someU = someU;
exports.some = some;
exports.size = size;
exports.toList = toList;
exports.toArray = toArray;
exports.fromArray = fromArray;
exports.keysToArray = keysToArray;
exports.valuesToArray = valuesToArray;
exports.minKey = minKey;
exports.minKeyUndefined = minKeyUndefined;
exports.maxKey = maxKey;
exports.maxKeyUndefined = maxKeyUndefined;
exports.minimum = minimum;
exports.minUndefined = minUndefined;
exports.maximum = maximum;
exports.maxUndefined = maxUndefined;
exports.get = get;
exports.getUndefined = getUndefined;
exports.getWithDefault = getWithDefault;
exports.getExn = getExn;
exports.checkInvariantInternal = checkInvariantInternal;
exports.remove = remove;
exports.removeMany = removeMany;
exports.set = set;
exports.updateU = updateU;
exports.update = update;
exports.mergeU = mergeU;
exports.merge = merge;
exports.mergeMany = mergeMany;
exports.keepU = keepU;
exports.keep = keep;
exports.partitionU = partitionU;
exports.partition = partition;
exports.split = split;
exports.mapU = mapU;
exports.map = map;
exports.mapWithKeyU = mapWithKeyU;
exports.mapWithKey = mapWithKey;
/* No side effect */


/***/ }),

/***/ 46517:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var Curry = __webpack_require__(41386);
var Caml_option = __webpack_require__(57175);

function keepU(opt, p) {
  if (opt !== undefined && p(Caml_option.valFromOption(opt))) {
    return opt;
  }
  
}

function keep(opt, p) {
  return keepU(opt, Curry.__1(p));
}

function forEachU(opt, f) {
  if (opt !== undefined) {
    return f(Caml_option.valFromOption(opt));
  }
  
}

function forEach(opt, f) {
  return forEachU(opt, Curry.__1(f));
}

function getExn(x) {
  if (x !== undefined) {
    return Caml_option.valFromOption(x);
  }
  throw {
        RE_EXN_ID: "Not_found",
        Error: new Error()
      };
}

function mapWithDefaultU(opt, $$default, f) {
  if (opt !== undefined) {
    return f(Caml_option.valFromOption(opt));
  } else {
    return $$default;
  }
}

function mapWithDefault(opt, $$default, f) {
  return mapWithDefaultU(opt, $$default, Curry.__1(f));
}

function mapU(opt, f) {
  if (opt !== undefined) {
    return Caml_option.some(f(Caml_option.valFromOption(opt)));
  }
  
}

function map(opt, f) {
  return mapU(opt, Curry.__1(f));
}

function flatMapU(opt, f) {
  if (opt !== undefined) {
    return f(Caml_option.valFromOption(opt));
  }
  
}

function flatMap(opt, f) {
  return flatMapU(opt, Curry.__1(f));
}

function getWithDefault(opt, $$default) {
  if (opt !== undefined) {
    return Caml_option.valFromOption(opt);
  } else {
    return $$default;
  }
}

function isSome(param) {
  return param !== undefined;
}

function isNone(x) {
  return x === undefined;
}

function eqU(a, b, f) {
  if (a !== undefined) {
    if (b !== undefined) {
      return f(Caml_option.valFromOption(a), Caml_option.valFromOption(b));
    } else {
      return false;
    }
  } else {
    return b === undefined;
  }
}

function eq(a, b, f) {
  return eqU(a, b, Curry.__2(f));
}

function cmpU(a, b, f) {
  if (a !== undefined) {
    if (b !== undefined) {
      return f(Caml_option.valFromOption(a), Caml_option.valFromOption(b));
    } else {
      return 1;
    }
  } else if (b !== undefined) {
    return -1;
  } else {
    return 0;
  }
}

function cmp(a, b, f) {
  return cmpU(a, b, Curry.__2(f));
}

exports.keepU = keepU;
exports.keep = keep;
exports.forEachU = forEachU;
exports.forEach = forEach;
exports.getExn = getExn;
exports.mapWithDefaultU = mapWithDefaultU;
exports.mapWithDefault = mapWithDefault;
exports.mapU = mapU;
exports.map = map;
exports.flatMapU = flatMapU;
exports.flatMap = flatMap;
exports.getWithDefault = getWithDefault;
exports.isSome = isSome;
exports.isNone = isNone;
exports.eqU = eqU;
exports.eq = eq;
exports.cmpU = cmpU;
exports.cmp = cmp;
/* No side effect */


/***/ }),

/***/ 86369:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var Curry = __webpack_require__(41386);

function getExn(x) {
  if (x.TAG === /* Ok */0) {
    return x._0;
  }
  throw {
        RE_EXN_ID: "Not_found",
        Error: new Error()
      };
}

function mapWithDefaultU(opt, $$default, f) {
  if (opt.TAG === /* Ok */0) {
    return f(opt._0);
  } else {
    return $$default;
  }
}

function mapWithDefault(opt, $$default, f) {
  return mapWithDefaultU(opt, $$default, Curry.__1(f));
}

function mapU(opt, f) {
  if (opt.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: f(opt._0)
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: opt._0
          };
  }
}

function map(opt, f) {
  return mapU(opt, Curry.__1(f));
}

function flatMapU(opt, f) {
  if (opt.TAG === /* Ok */0) {
    return f(opt._0);
  } else {
    return {
            TAG: /* Error */1,
            _0: opt._0
          };
  }
}

function flatMap(opt, f) {
  return flatMapU(opt, Curry.__1(f));
}

function getWithDefault(opt, $$default) {
  if (opt.TAG === /* Ok */0) {
    return opt._0;
  } else {
    return $$default;
  }
}

function isOk(param) {
  if (param.TAG === /* Ok */0) {
    return true;
  } else {
    return false;
  }
}

function isError(param) {
  if (param.TAG === /* Ok */0) {
    return false;
  } else {
    return true;
  }
}

function eqU(a, b, f) {
  if (a.TAG === /* Ok */0) {
    if (b.TAG === /* Ok */0) {
      return f(a._0, b._0);
    } else {
      return false;
    }
  } else if (b.TAG === /* Ok */0) {
    return false;
  } else {
    return true;
  }
}

function eq(a, b, f) {
  return eqU(a, b, Curry.__2(f));
}

function cmpU(a, b, f) {
  if (a.TAG === /* Ok */0) {
    if (b.TAG === /* Ok */0) {
      return f(a._0, b._0);
    } else {
      return 1;
    }
  } else if (b.TAG === /* Ok */0) {
    return -1;
  } else {
    return 0;
  }
}

function cmp(a, b, f) {
  return cmpU(a, b, Curry.__2(f));
}

exports.getExn = getExn;
exports.mapWithDefaultU = mapWithDefaultU;
exports.mapWithDefault = mapWithDefault;
exports.mapU = mapU;
exports.map = map;
exports.flatMapU = flatMapU;
exports.flatMap = flatMap;
exports.getWithDefault = getWithDefault;
exports.isOk = isOk;
exports.isError = isError;
exports.eqU = eqU;
exports.eq = eq;
exports.cmpU = cmpU;
exports.cmp = cmp;
/* No side effect */


/***/ }),

/***/ 62531:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var Curry = __webpack_require__(41386);
var Belt_Array = __webpack_require__(2971);

function sortedLengthAuxMore(xs, _prec, _acc, len, lt) {
  while(true) {
    var acc = _acc;
    var prec = _prec;
    if (acc >= len) {
      return acc;
    }
    var v = xs[acc];
    if (!lt(v, prec)) {
      return acc;
    }
    _acc = acc + 1 | 0;
    _prec = v;
    continue ;
  };
}

function strictlySortedLengthU(xs, lt) {
  var len = xs.length;
  if (len === 0 || len === 1) {
    return len;
  }
  var x0 = xs[0];
  var x1 = xs[1];
  if (lt(x0, x1)) {
    var _prec = x1;
    var _acc = 2;
    while(true) {
      var acc = _acc;
      var prec = _prec;
      if (acc >= len) {
        return acc;
      }
      var v = xs[acc];
      if (!lt(prec, v)) {
        return acc;
      }
      _acc = acc + 1 | 0;
      _prec = v;
      continue ;
    };
  } else if (lt(x1, x0)) {
    return -sortedLengthAuxMore(xs, x1, 2, len, lt) | 0;
  } else {
    return 1;
  }
}

function strictlySortedLength(xs, lt) {
  return strictlySortedLengthU(xs, Curry.__2(lt));
}

function isSortedU(a, cmp) {
  var len = a.length;
  if (len === 0) {
    return true;
  } else {
    var _i = 0;
    var last_bound = len - 1 | 0;
    while(true) {
      var i = _i;
      if (i === last_bound) {
        return true;
      }
      if (cmp(a[i], a[i + 1 | 0]) > 0) {
        return false;
      }
      _i = i + 1 | 0;
      continue ;
    };
  }
}

function isSorted(a, cmp) {
  return isSortedU(a, Curry.__2(cmp));
}

function merge(src, src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs, cmp) {
  var src1r = src1ofs + src1len | 0;
  var src2r = src2ofs + src2len | 0;
  var _i1 = src1ofs;
  var _s1 = src[src1ofs];
  var _i2 = src2ofs;
  var _s2 = src2[src2ofs];
  var _d = dstofs;
  while(true) {
    var d = _d;
    var s2 = _s2;
    var i2 = _i2;
    var s1 = _s1;
    var i1 = _i1;
    if (cmp(s1, s2) <= 0) {
      dst[d] = s1;
      var i1$1 = i1 + 1 | 0;
      if (i1$1 >= src1r) {
        return Belt_Array.blitUnsafe(src2, i2, dst, d + 1 | 0, src2r - i2 | 0);
      }
      _d = d + 1 | 0;
      _s1 = src[i1$1];
      _i1 = i1$1;
      continue ;
    }
    dst[d] = s2;
    var i2$1 = i2 + 1 | 0;
    if (i2$1 >= src2r) {
      return Belt_Array.blitUnsafe(src, i1, dst, d + 1 | 0, src1r - i1 | 0);
    }
    _d = d + 1 | 0;
    _s2 = src2[i2$1];
    _i2 = i2$1;
    continue ;
  };
}

function unionU(src, src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs, cmp) {
  var src1r = src1ofs + src1len | 0;
  var src2r = src2ofs + src2len | 0;
  var _i1 = src1ofs;
  var _s1 = src[src1ofs];
  var _i2 = src2ofs;
  var _s2 = src2[src2ofs];
  var _d = dstofs;
  while(true) {
    var d = _d;
    var s2 = _s2;
    var i2 = _i2;
    var s1 = _s1;
    var i1 = _i1;
    var c = cmp(s1, s2);
    if (c < 0) {
      dst[d] = s1;
      var i1$1 = i1 + 1 | 0;
      var d$1 = d + 1 | 0;
      if (i1$1 < src1r) {
        _d = d$1;
        _s1 = src[i1$1];
        _i1 = i1$1;
        continue ;
      }
      Belt_Array.blitUnsafe(src2, i2, dst, d$1, src2r - i2 | 0);
      return (d$1 + src2r | 0) - i2 | 0;
    }
    if (c === 0) {
      dst[d] = s1;
      var i1$2 = i1 + 1 | 0;
      var i2$1 = i2 + 1 | 0;
      var d$2 = d + 1 | 0;
      if (!(i1$2 < src1r && i2$1 < src2r)) {
        if (i1$2 === src1r) {
          Belt_Array.blitUnsafe(src2, i2$1, dst, d$2, src2r - i2$1 | 0);
          return (d$2 + src2r | 0) - i2$1 | 0;
        } else {
          Belt_Array.blitUnsafe(src, i1$2, dst, d$2, src1r - i1$2 | 0);
          return (d$2 + src1r | 0) - i1$2 | 0;
        }
      }
      _d = d$2;
      _s2 = src2[i2$1];
      _i2 = i2$1;
      _s1 = src[i1$2];
      _i1 = i1$2;
      continue ;
    }
    dst[d] = s2;
    var i2$2 = i2 + 1 | 0;
    var d$3 = d + 1 | 0;
    if (i2$2 < src2r) {
      _d = d$3;
      _s2 = src2[i2$2];
      _i2 = i2$2;
      continue ;
    }
    Belt_Array.blitUnsafe(src, i1, dst, d$3, src1r - i1 | 0);
    return (d$3 + src1r | 0) - i1 | 0;
  };
}

function union(src, src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs, cmp) {
  return unionU(src, src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs, Curry.__2(cmp));
}

function intersectU(src, src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs, cmp) {
  var src1r = src1ofs + src1len | 0;
  var src2r = src2ofs + src2len | 0;
  var _i1 = src1ofs;
  var _s1 = src[src1ofs];
  var _i2 = src2ofs;
  var _s2 = src2[src2ofs];
  var _d = dstofs;
  while(true) {
    var d = _d;
    var s2 = _s2;
    var i2 = _i2;
    var s1 = _s1;
    var i1 = _i1;
    var c = cmp(s1, s2);
    if (c < 0) {
      var i1$1 = i1 + 1 | 0;
      if (i1$1 >= src1r) {
        return d;
      }
      _s1 = src[i1$1];
      _i1 = i1$1;
      continue ;
    }
    if (c === 0) {
      dst[d] = s1;
      var i1$2 = i1 + 1 | 0;
      var i2$1 = i2 + 1 | 0;
      var d$1 = d + 1 | 0;
      if (!(i1$2 < src1r && i2$1 < src2r)) {
        return d$1;
      }
      _d = d$1;
      _s2 = src2[i2$1];
      _i2 = i2$1;
      _s1 = src[i1$2];
      _i1 = i1$2;
      continue ;
    }
    var i2$2 = i2 + 1 | 0;
    if (i2$2 >= src2r) {
      return d;
    }
    _s2 = src2[i2$2];
    _i2 = i2$2;
    continue ;
  };
}

function intersect(src, src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs, cmp) {
  return intersectU(src, src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs, Curry.__2(cmp));
}

function diffU(src, src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs, cmp) {
  var src1r = src1ofs + src1len | 0;
  var src2r = src2ofs + src2len | 0;
  var _i1 = src1ofs;
  var _s1 = src[src1ofs];
  var _i2 = src2ofs;
  var _s2 = src2[src2ofs];
  var _d = dstofs;
  while(true) {
    var d = _d;
    var s2 = _s2;
    var i2 = _i2;
    var s1 = _s1;
    var i1 = _i1;
    var c = cmp(s1, s2);
    if (c < 0) {
      dst[d] = s1;
      var d$1 = d + 1 | 0;
      var i1$1 = i1 + 1 | 0;
      if (i1$1 >= src1r) {
        return d$1;
      }
      _d = d$1;
      _s1 = src[i1$1];
      _i1 = i1$1;
      continue ;
    }
    if (c === 0) {
      var i1$2 = i1 + 1 | 0;
      var i2$1 = i2 + 1 | 0;
      if (!(i1$2 < src1r && i2$1 < src2r)) {
        if (i1$2 === src1r) {
          return d;
        } else {
          Belt_Array.blitUnsafe(src, i1$2, dst, d, src1r - i1$2 | 0);
          return (d + src1r | 0) - i1$2 | 0;
        }
      }
      _s2 = src2[i2$1];
      _i2 = i2$1;
      _s1 = src[i1$2];
      _i1 = i1$2;
      continue ;
    }
    var i2$2 = i2 + 1 | 0;
    if (i2$2 < src2r) {
      _s2 = src2[i2$2];
      _i2 = i2$2;
      continue ;
    }
    Belt_Array.blitUnsafe(src, i1, dst, d, src1r - i1 | 0);
    return (d + src1r | 0) - i1 | 0;
  };
}

function diff(src, src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs, cmp) {
  return diffU(src, src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs, Curry.__2(cmp));
}

function insertionSort(src, srcofs, dst, dstofs, len, cmp) {
  for(var i = 0; i < len; ++i){
    var e = src[srcofs + i | 0];
    var j = (dstofs + i | 0) - 1 | 0;
    while(j >= dstofs && cmp(dst[j], e) > 0) {
      dst[j + 1 | 0] = dst[j];
      j = j - 1 | 0;
    };
    dst[j + 1 | 0] = e;
  }
  
}

function sortTo(src, srcofs, dst, dstofs, len, cmp) {
  if (len <= 5) {
    return insertionSort(src, srcofs, dst, dstofs, len, cmp);
  }
  var l1 = len / 2 | 0;
  var l2 = len - l1 | 0;
  sortTo(src, srcofs + l1 | 0, dst, dstofs + l1 | 0, l2, cmp);
  sortTo(src, srcofs, src, srcofs + l2 | 0, l1, cmp);
  return merge(src, srcofs + l2 | 0, l1, dst, dstofs + l1 | 0, l2, dst, dstofs, cmp);
}

function stableSortInPlaceByU(a, cmp) {
  var l = a.length;
  if (l <= 5) {
    return insertionSort(a, 0, a, 0, l, cmp);
  }
  var l1 = l / 2 | 0;
  var l2 = l - l1 | 0;
  var t = new Array(l2);
  sortTo(a, l1, t, 0, l2, cmp);
  sortTo(a, 0, a, l2, l1, cmp);
  return merge(a, l2, l1, t, 0, l2, a, 0, cmp);
}

function stableSortInPlaceBy(a, cmp) {
  return stableSortInPlaceByU(a, Curry.__2(cmp));
}

function stableSortByU(a, cmp) {
  var b = a.slice(0);
  stableSortInPlaceByU(b, cmp);
  return b;
}

function stableSortBy(a, cmp) {
  return stableSortByU(a, Curry.__2(cmp));
}

function binarySearchByU(sorted, key, cmp) {
  var len = sorted.length;
  if (len === 0) {
    return -1;
  }
  var lo = sorted[0];
  var c = cmp(key, lo);
  if (c < 0) {
    return -1;
  }
  var hi = sorted[len - 1 | 0];
  var c2 = cmp(key, hi);
  if (c2 > 0) {
    return -(len + 1 | 0) | 0;
  } else {
    var _lo = 0;
    var _hi = len - 1 | 0;
    while(true) {
      var hi$1 = _hi;
      var lo$1 = _lo;
      var mid = (lo$1 + hi$1 | 0) / 2 | 0;
      var midVal = sorted[mid];
      var c$1 = cmp(key, midVal);
      if (c$1 === 0) {
        return mid;
      }
      if (c$1 < 0) {
        if (hi$1 === mid) {
          if (cmp(sorted[lo$1], key) === 0) {
            return lo$1;
          } else {
            return -(hi$1 + 1 | 0) | 0;
          }
        }
        _hi = mid;
        continue ;
      }
      if (lo$1 === mid) {
        if (cmp(sorted[hi$1], key) === 0) {
          return hi$1;
        } else {
          return -(hi$1 + 1 | 0) | 0;
        }
      }
      _lo = mid;
      continue ;
    };
  }
}

function binarySearchBy(sorted, key, cmp) {
  return binarySearchByU(sorted, key, Curry.__2(cmp));
}

var Int;

var $$String;

exports.Int = Int;
exports.$$String = $$String;
exports.strictlySortedLengthU = strictlySortedLengthU;
exports.strictlySortedLength = strictlySortedLength;
exports.isSortedU = isSortedU;
exports.isSorted = isSorted;
exports.stableSortInPlaceByU = stableSortInPlaceByU;
exports.stableSortInPlaceBy = stableSortInPlaceBy;
exports.stableSortByU = stableSortByU;
exports.stableSortBy = stableSortBy;
exports.binarySearchByU = binarySearchByU;
exports.binarySearchBy = binarySearchBy;
exports.unionU = unionU;
exports.union = union;
exports.intersectU = intersectU;
exports.intersect = intersect;
exports.diffU = diffU;
exports.diff = diff;
/* No side effect */


/***/ }),

/***/ 46144:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var Curry = __webpack_require__(41386);
var Caml_option = __webpack_require__(57175);
var Belt_SortArray = __webpack_require__(62531);

function treeHeight(n) {
  if (n !== undefined) {
    return n.h;
  } else {
    return 0;
  }
}

function copy(n) {
  if (n !== undefined) {
    return {
            k: n.k,
            v: n.v,
            h: n.h,
            l: copy(n.l),
            r: copy(n.r)
          };
  } else {
    return n;
  }
}

function create(l, x, d, r) {
  var hl = treeHeight(l);
  var hr = treeHeight(r);
  return {
          k: x,
          v: d,
          h: hl >= hr ? hl + 1 | 0 : hr + 1 | 0,
          l: l,
          r: r
        };
}

function singleton(x, d) {
  return {
          k: x,
          v: d,
          h: 1,
          l: undefined,
          r: undefined
        };
}

function heightGe(l, r) {
  if (r !== undefined) {
    if (l !== undefined) {
      return l.h >= r.h;
    } else {
      return false;
    }
  } else {
    return true;
  }
}

function updateValue(n, newValue) {
  if (n.v === newValue) {
    return n;
  } else {
    return {
            k: n.k,
            v: newValue,
            h: n.h,
            l: n.l,
            r: n.r
          };
  }
}

function bal(l, x, d, r) {
  var hl = l !== undefined ? l.h : 0;
  var hr = r !== undefined ? r.h : 0;
  if (hl > (hr + 2 | 0)) {
    var ll = l.l;
    var lr = l.r;
    if (treeHeight(ll) >= treeHeight(lr)) {
      return create(ll, l.k, l.v, create(lr, x, d, r));
    } else {
      return create(create(ll, l.k, l.v, lr.l), lr.k, lr.v, create(lr.r, x, d, r));
    }
  }
  if (hr <= (hl + 2 | 0)) {
    return {
            k: x,
            v: d,
            h: hl >= hr ? hl + 1 | 0 : hr + 1 | 0,
            l: l,
            r: r
          };
  }
  var rl = r.l;
  var rr = r.r;
  if (treeHeight(rr) >= treeHeight(rl)) {
    return create(create(l, x, d, rl), r.k, r.v, rr);
  } else {
    return create(create(l, x, d, rl.l), rl.k, rl.v, create(rl.r, r.k, r.v, rr));
  }
}

function minKey0Aux(_n) {
  while(true) {
    var n = _n;
    var n$1 = n.l;
    if (n$1 === undefined) {
      return n.k;
    }
    _n = n$1;
    continue ;
  };
}

function minKey(n) {
  if (n !== undefined) {
    return Caml_option.some(minKey0Aux(n));
  }
  
}

function minKeyUndefined(n) {
  if (n !== undefined) {
    return minKey0Aux(n);
  }
  
}

function maxKey0Aux(_n) {
  while(true) {
    var n = _n;
    var n$1 = n.r;
    if (n$1 === undefined) {
      return n.k;
    }
    _n = n$1;
    continue ;
  };
}

function maxKey(n) {
  if (n !== undefined) {
    return Caml_option.some(maxKey0Aux(n));
  }
  
}

function maxKeyUndefined(n) {
  if (n !== undefined) {
    return maxKey0Aux(n);
  }
  
}

function minKV0Aux(_n) {
  while(true) {
    var n = _n;
    var n$1 = n.l;
    if (n$1 === undefined) {
      return [
              n.k,
              n.v
            ];
    }
    _n = n$1;
    continue ;
  };
}

function minimum(n) {
  if (n !== undefined) {
    return minKV0Aux(n);
  }
  
}

function minUndefined(n) {
  if (n !== undefined) {
    return minKV0Aux(n);
  }
  
}

function maxKV0Aux(_n) {
  while(true) {
    var n = _n;
    var n$1 = n.r;
    if (n$1 === undefined) {
      return [
              n.k,
              n.v
            ];
    }
    _n = n$1;
    continue ;
  };
}

function maximum(n) {
  if (n !== undefined) {
    return maxKV0Aux(n);
  }
  
}

function maxUndefined(n) {
  if (n !== undefined) {
    return maxKV0Aux(n);
  }
  
}

function removeMinAuxWithRef(n, kr, vr) {
  var ln = n.l;
  if (ln !== undefined) {
    return bal(removeMinAuxWithRef(ln, kr, vr), n.k, n.v, n.r);
  } else {
    kr.contents = n.k;
    vr.contents = n.v;
    return n.r;
  }
}

function isEmpty(x) {
  return x === undefined;
}

function stackAllLeft(_v, _s) {
  while(true) {
    var s = _s;
    var v = _v;
    if (v === undefined) {
      return s;
    }
    _s = {
      hd: v,
      tl: s
    };
    _v = v.l;
    continue ;
  };
}

function findFirstByU(n, p) {
  if (n === undefined) {
    return ;
  }
  var left = findFirstByU(n.l, p);
  if (left !== undefined) {
    return left;
  }
  var v = n.k;
  var d = n.v;
  var pvd = p(v, d);
  if (pvd) {
    return [
            v,
            d
          ];
  }
  var right = findFirstByU(n.r, p);
  if (right !== undefined) {
    return right;
  }
  
}

function findFirstBy(n, p) {
  return findFirstByU(n, Curry.__2(p));
}

function forEachU(_n, f) {
  while(true) {
    var n = _n;
    if (n === undefined) {
      return ;
    }
    forEachU(n.l, f);
    f(n.k, n.v);
    _n = n.r;
    continue ;
  };
}

function forEach(n, f) {
  return forEachU(n, Curry.__2(f));
}

function mapU(n, f) {
  if (n === undefined) {
    return ;
  }
  var newLeft = mapU(n.l, f);
  var newD = f(n.v);
  var newRight = mapU(n.r, f);
  return {
          k: n.k,
          v: newD,
          h: n.h,
          l: newLeft,
          r: newRight
        };
}

function map(n, f) {
  return mapU(n, Curry.__1(f));
}

function mapWithKeyU(n, f) {
  if (n === undefined) {
    return ;
  }
  var key = n.k;
  var newLeft = mapWithKeyU(n.l, f);
  var newD = f(key, n.v);
  var newRight = mapWithKeyU(n.r, f);
  return {
          k: key,
          v: newD,
          h: n.h,
          l: newLeft,
          r: newRight
        };
}

function mapWithKey(n, f) {
  return mapWithKeyU(n, Curry.__2(f));
}

function reduceU(_m, _accu, f) {
  while(true) {
    var accu = _accu;
    var m = _m;
    if (m === undefined) {
      return accu;
    }
    var v = m.k;
    var d = m.v;
    var l = m.l;
    var r = m.r;
    _accu = f(reduceU(l, accu, f), v, d);
    _m = r;
    continue ;
  };
}

function reduce(m, accu, f) {
  return reduceU(m, accu, Curry.__3(f));
}

function everyU(_n, p) {
  while(true) {
    var n = _n;
    if (n === undefined) {
      return true;
    }
    if (!p(n.k, n.v)) {
      return false;
    }
    if (!everyU(n.l, p)) {
      return false;
    }
    _n = n.r;
    continue ;
  };
}

function every(n, p) {
  return everyU(n, Curry.__2(p));
}

function someU(_n, p) {
  while(true) {
    var n = _n;
    if (n === undefined) {
      return false;
    }
    if (p(n.k, n.v)) {
      return true;
    }
    if (someU(n.l, p)) {
      return true;
    }
    _n = n.r;
    continue ;
  };
}

function some(n, p) {
  return someU(n, Curry.__2(p));
}

function addMinElement(n, k, v) {
  if (n !== undefined) {
    return bal(addMinElement(n.l, k, v), n.k, n.v, n.r);
  } else {
    return singleton(k, v);
  }
}

function addMaxElement(n, k, v) {
  if (n !== undefined) {
    return bal(n.l, n.k, n.v, addMaxElement(n.r, k, v));
  } else {
    return singleton(k, v);
  }
}

function join(ln, v, d, rn) {
  if (ln === undefined) {
    return addMinElement(rn, v, d);
  }
  if (rn === undefined) {
    return addMaxElement(ln, v, d);
  }
  var lv = ln.k;
  var ld = ln.v;
  var lh = ln.h;
  var ll = ln.l;
  var lr = ln.r;
  var rv = rn.k;
  var rd = rn.v;
  var rh = rn.h;
  var rl = rn.l;
  var rr = rn.r;
  if (lh > (rh + 2 | 0)) {
    return bal(ll, lv, ld, join(lr, v, d, rn));
  } else if (rh > (lh + 2 | 0)) {
    return bal(join(ln, v, d, rl), rv, rd, rr);
  } else {
    return create(ln, v, d, rn);
  }
}

function concat(t1, t2) {
  if (t1 === undefined) {
    return t2;
  }
  if (t2 === undefined) {
    return t1;
  }
  var kr = {
    contents: t2.k
  };
  var vr = {
    contents: t2.v
  };
  var t2r = removeMinAuxWithRef(t2, kr, vr);
  return join(t1, kr.contents, vr.contents, t2r);
}

function concatOrJoin(t1, v, d, t2) {
  if (d !== undefined) {
    return join(t1, v, Caml_option.valFromOption(d), t2);
  } else {
    return concat(t1, t2);
  }
}

function keepSharedU(n, p) {
  if (n === undefined) {
    return ;
  }
  var v = n.k;
  var d = n.v;
  var newLeft = keepSharedU(n.l, p);
  var pvd = p(v, d);
  var newRight = keepSharedU(n.r, p);
  if (pvd) {
    return join(newLeft, v, d, newRight);
  } else {
    return concat(newLeft, newRight);
  }
}

function keepShared(n, p) {
  return keepSharedU(n, Curry.__2(p));
}

function keepMapU(n, p) {
  if (n === undefined) {
    return ;
  }
  var v = n.k;
  var d = n.v;
  var newLeft = keepMapU(n.l, p);
  var pvd = p(v, d);
  var newRight = keepMapU(n.r, p);
  if (pvd !== undefined) {
    return join(newLeft, v, Caml_option.valFromOption(pvd), newRight);
  } else {
    return concat(newLeft, newRight);
  }
}

function keepMap(n, p) {
  return keepMapU(n, Curry.__2(p));
}

function partitionSharedU(n, p) {
  if (n === undefined) {
    return [
            undefined,
            undefined
          ];
  }
  var key = n.k;
  var value = n.v;
  var match = partitionSharedU(n.l, p);
  var lf = match[1];
  var lt = match[0];
  var pvd = p(key, value);
  var match$1 = partitionSharedU(n.r, p);
  var rf = match$1[1];
  var rt = match$1[0];
  if (pvd) {
    return [
            join(lt, key, value, rt),
            concat(lf, rf)
          ];
  } else {
    return [
            concat(lt, rt),
            join(lf, key, value, rf)
          ];
  }
}

function partitionShared(n, p) {
  return partitionSharedU(n, Curry.__2(p));
}

function lengthNode(n) {
  var l = n.l;
  var r = n.r;
  var sizeL = l !== undefined ? lengthNode(l) : 0;
  var sizeR = r !== undefined ? lengthNode(r) : 0;
  return (1 + sizeL | 0) + sizeR | 0;
}

function size(n) {
  if (n !== undefined) {
    return lengthNode(n);
  } else {
    return 0;
  }
}

function toListAux(_n, _accu) {
  while(true) {
    var accu = _accu;
    var n = _n;
    if (n === undefined) {
      return accu;
    }
    var k = n.k;
    var v = n.v;
    var l = n.l;
    var r = n.r;
    _accu = {
      hd: [
        k,
        v
      ],
      tl: toListAux(r, accu)
    };
    _n = l;
    continue ;
  };
}

function toList(s) {
  return toListAux(s, /* [] */0);
}

function checkInvariantInternal(_v) {
  while(true) {
    var v = _v;
    if (v === undefined) {
      return ;
    }
    var l = v.l;
    var r = v.r;
    var diff = treeHeight(l) - treeHeight(r) | 0;
    if (!(diff <= 2 && diff >= -2)) {
      throw {
            RE_EXN_ID: "Assert_failure",
            _1: [
              "belt_internalAVLtree.ml",
              373,
              4
            ],
            Error: new Error()
          };
    }
    checkInvariantInternal(l);
    _v = r;
    continue ;
  };
}

function fillArrayKey(_n, _i, arr) {
  while(true) {
    var i = _i;
    var n = _n;
    var v = n.k;
    var l = n.l;
    var r = n.r;
    var next = l !== undefined ? fillArrayKey(l, i, arr) : i;
    arr[next] = v;
    var rnext = next + 1 | 0;
    if (r === undefined) {
      return rnext;
    }
    _i = rnext;
    _n = r;
    continue ;
  };
}

function fillArrayValue(_n, _i, arr) {
  while(true) {
    var i = _i;
    var n = _n;
    var l = n.l;
    var r = n.r;
    var next = l !== undefined ? fillArrayValue(l, i, arr) : i;
    arr[next] = n.v;
    var rnext = next + 1 | 0;
    if (r === undefined) {
      return rnext;
    }
    _i = rnext;
    _n = r;
    continue ;
  };
}

function fillArray(_n, _i, arr) {
  while(true) {
    var i = _i;
    var n = _n;
    var l = n.l;
    var v = n.k;
    var r = n.r;
    var next = l !== undefined ? fillArray(l, i, arr) : i;
    arr[next] = [
      v,
      n.v
    ];
    var rnext = next + 1 | 0;
    if (r === undefined) {
      return rnext;
    }
    _i = rnext;
    _n = r;
    continue ;
  };
}

function toArray(n) {
  if (n === undefined) {
    return [];
  }
  var size = lengthNode(n);
  var v = new Array(size);
  fillArray(n, 0, v);
  return v;
}

function keysToArray(n) {
  if (n === undefined) {
    return [];
  }
  var size = lengthNode(n);
  var v = new Array(size);
  fillArrayKey(n, 0, v);
  return v;
}

function valuesToArray(n) {
  if (n === undefined) {
    return [];
  }
  var size = lengthNode(n);
  var v = new Array(size);
  fillArrayValue(n, 0, v);
  return v;
}

function fromSortedArrayRevAux(arr, off, len) {
  switch (len) {
    case 0 :
        return ;
    case 1 :
        var match = arr[off];
        return singleton(match[0], match[1]);
    case 2 :
        var match_0 = arr[off];
        var match_1 = arr[off - 1 | 0];
        var match$1 = match_1;
        var match$2 = match_0;
        return {
                k: match$1[0],
                v: match$1[1],
                h: 2,
                l: singleton(match$2[0], match$2[1]),
                r: undefined
              };
    case 3 :
        var match_0$1 = arr[off];
        var match_1$1 = arr[off - 1 | 0];
        var match_2 = arr[off - 2 | 0];
        var match$3 = match_2;
        var match$4 = match_1$1;
        var match$5 = match_0$1;
        return {
                k: match$4[0],
                v: match$4[1],
                h: 2,
                l: singleton(match$5[0], match$5[1]),
                r: singleton(match$3[0], match$3[1])
              };
    default:
      var nl = len / 2 | 0;
      var left = fromSortedArrayRevAux(arr, off, nl);
      var match$6 = arr[off - nl | 0];
      var right = fromSortedArrayRevAux(arr, (off - nl | 0) - 1 | 0, (len - nl | 0) - 1 | 0);
      return create(left, match$6[0], match$6[1], right);
  }
}

function fromSortedArrayAux(arr, off, len) {
  switch (len) {
    case 0 :
        return ;
    case 1 :
        var match = arr[off];
        return singleton(match[0], match[1]);
    case 2 :
        var match_0 = arr[off];
        var match_1 = arr[off + 1 | 0];
        var match$1 = match_1;
        var match$2 = match_0;
        return {
                k: match$1[0],
                v: match$1[1],
                h: 2,
                l: singleton(match$2[0], match$2[1]),
                r: undefined
              };
    case 3 :
        var match_0$1 = arr[off];
        var match_1$1 = arr[off + 1 | 0];
        var match_2 = arr[off + 2 | 0];
        var match$3 = match_2;
        var match$4 = match_1$1;
        var match$5 = match_0$1;
        return {
                k: match$4[0],
                v: match$4[1],
                h: 2,
                l: singleton(match$5[0], match$5[1]),
                r: singleton(match$3[0], match$3[1])
              };
    default:
      var nl = len / 2 | 0;
      var left = fromSortedArrayAux(arr, off, nl);
      var match$6 = arr[off + nl | 0];
      var right = fromSortedArrayAux(arr, (off + nl | 0) + 1 | 0, (len - nl | 0) - 1 | 0);
      return create(left, match$6[0], match$6[1], right);
  }
}

function fromSortedArrayUnsafe(arr) {
  return fromSortedArrayAux(arr, 0, arr.length);
}

function cmpU(s1, s2, kcmp, vcmp) {
  var len1 = size(s1);
  var len2 = size(s2);
  if (len1 === len2) {
    var _e1 = stackAllLeft(s1, /* [] */0);
    var _e2 = stackAllLeft(s2, /* [] */0);
    while(true) {
      var e2 = _e2;
      var e1 = _e1;
      if (!e1) {
        return 0;
      }
      if (!e2) {
        return 0;
      }
      var h2 = e2.hd;
      var h1 = e1.hd;
      var c = kcmp(h1.k, h2.k);
      if (c !== 0) {
        return c;
      }
      var cx = vcmp(h1.v, h2.v);
      if (cx !== 0) {
        return cx;
      }
      _e2 = stackAllLeft(h2.r, e2.tl);
      _e1 = stackAllLeft(h1.r, e1.tl);
      continue ;
    };
  } else if (len1 < len2) {
    return -1;
  } else {
    return 1;
  }
}

function cmp(s1, s2, kcmp, vcmp) {
  return cmpU(s1, s2, kcmp, Curry.__2(vcmp));
}

function eqU(s1, s2, kcmp, veq) {
  var len1 = size(s1);
  var len2 = size(s2);
  if (len1 === len2) {
    var _e1 = stackAllLeft(s1, /* [] */0);
    var _e2 = stackAllLeft(s2, /* [] */0);
    while(true) {
      var e2 = _e2;
      var e1 = _e1;
      if (!e1) {
        return true;
      }
      if (!e2) {
        return true;
      }
      var h2 = e2.hd;
      var h1 = e1.hd;
      if (!(kcmp(h1.k, h2.k) === 0 && veq(h1.v, h2.v))) {
        return false;
      }
      _e2 = stackAllLeft(h2.r, e2.tl);
      _e1 = stackAllLeft(h1.r, e1.tl);
      continue ;
    };
  } else {
    return false;
  }
}

function eq(s1, s2, kcmp, veq) {
  return eqU(s1, s2, kcmp, Curry.__2(veq));
}

function get(_n, x, cmp) {
  while(true) {
    var n = _n;
    if (n === undefined) {
      return ;
    }
    var v = n.k;
    var c = cmp(x, v);
    if (c === 0) {
      return Caml_option.some(n.v);
    }
    _n = c < 0 ? n.l : n.r;
    continue ;
  };
}

function getUndefined(_n, x, cmp) {
  while(true) {
    var n = _n;
    if (n === undefined) {
      return ;
    }
    var v = n.k;
    var c = cmp(x, v);
    if (c === 0) {
      return n.v;
    }
    _n = c < 0 ? n.l : n.r;
    continue ;
  };
}

function getExn(_n, x, cmp) {
  while(true) {
    var n = _n;
    if (n !== undefined) {
      var v = n.k;
      var c = cmp(x, v);
      if (c === 0) {
        return n.v;
      }
      _n = c < 0 ? n.l : n.r;
      continue ;
    }
    throw {
          RE_EXN_ID: "Not_found",
          Error: new Error()
        };
  };
}

function getWithDefault(_n, x, def, cmp) {
  while(true) {
    var n = _n;
    if (n === undefined) {
      return def;
    }
    var v = n.k;
    var c = cmp(x, v);
    if (c === 0) {
      return n.v;
    }
    _n = c < 0 ? n.l : n.r;
    continue ;
  };
}

function has(_n, x, cmp) {
  while(true) {
    var n = _n;
    if (n === undefined) {
      return false;
    }
    var v = n.k;
    var c = cmp(x, v);
    if (c === 0) {
      return true;
    }
    _n = c < 0 ? n.l : n.r;
    continue ;
  };
}

function rotateWithLeftChild(k2) {
  var k1 = k2.l;
  k2.l = k1.r;
  k1.r = k2;
  var hlk2 = treeHeight(k2.l);
  var hrk2 = treeHeight(k2.r);
  k2.h = (
    hlk2 > hrk2 ? hlk2 : hrk2
  ) + 1 | 0;
  var hlk1 = treeHeight(k1.l);
  var hk2 = k2.h;
  k1.h = (
    hlk1 > hk2 ? hlk1 : hk2
  ) + 1 | 0;
  return k1;
}

function rotateWithRightChild(k1) {
  var k2 = k1.r;
  k1.r = k2.l;
  k2.l = k1;
  var hlk1 = treeHeight(k1.l);
  var hrk1 = treeHeight(k1.r);
  k1.h = (
    hlk1 > hrk1 ? hlk1 : hrk1
  ) + 1 | 0;
  var hrk2 = treeHeight(k2.r);
  var hk1 = k1.h;
  k2.h = (
    hrk2 > hk1 ? hrk2 : hk1
  ) + 1 | 0;
  return k2;
}

function doubleWithLeftChild(k3) {
  var x = k3.l;
  var v = rotateWithRightChild(x);
  k3.l = v;
  return rotateWithLeftChild(k3);
}

function doubleWithRightChild(k2) {
  var x = k2.r;
  var v = rotateWithLeftChild(x);
  k2.r = v;
  return rotateWithRightChild(k2);
}

function heightUpdateMutate(t) {
  var hlt = treeHeight(t.l);
  var hrt = treeHeight(t.r);
  t.h = (
    hlt > hrt ? hlt : hrt
  ) + 1 | 0;
  return t;
}

function balMutate(nt) {
  var l = nt.l;
  var r = nt.r;
  var hl = treeHeight(l);
  var hr = treeHeight(r);
  if (hl > (2 + hr | 0)) {
    var ll = l.l;
    var lr = l.r;
    if (heightGe(ll, lr)) {
      return heightUpdateMutate(rotateWithLeftChild(nt));
    } else {
      return heightUpdateMutate(doubleWithLeftChild(nt));
    }
  }
  if (hr > (2 + hl | 0)) {
    var rl = r.l;
    var rr = r.r;
    if (heightGe(rr, rl)) {
      return heightUpdateMutate(rotateWithRightChild(nt));
    } else {
      return heightUpdateMutate(doubleWithRightChild(nt));
    }
  }
  nt.h = (
    hl > hr ? hl : hr
  ) + 1 | 0;
  return nt;
}

function updateMutate(t, x, data, cmp) {
  if (t === undefined) {
    return singleton(x, data);
  }
  var k = t.k;
  var c = cmp(x, k);
  if (c === 0) {
    t.v = data;
    return t;
  }
  var l = t.l;
  var r = t.r;
  if (c < 0) {
    var ll = updateMutate(l, x, data, cmp);
    t.l = ll;
  } else {
    t.r = updateMutate(r, x, data, cmp);
  }
  return balMutate(t);
}

function fromArray(xs, cmp) {
  var len = xs.length;
  if (len === 0) {
    return ;
  }
  var next = Belt_SortArray.strictlySortedLengthU(xs, (function (param, param$1) {
          return cmp(param[0], param$1[0]) < 0;
        }));
  var result;
  if (next >= 0) {
    result = fromSortedArrayAux(xs, 0, next);
  } else {
    next = -next | 0;
    result = fromSortedArrayRevAux(xs, next - 1 | 0, next);
  }
  for(var i = next; i < len; ++i){
    var match = xs[i];
    result = updateMutate(result, match[0], match[1], cmp);
  }
  return result;
}

function removeMinAuxWithRootMutate(nt, n) {
  var rn = n.r;
  var ln = n.l;
  if (ln !== undefined) {
    n.l = removeMinAuxWithRootMutate(nt, ln);
    return balMutate(n);
  } else {
    nt.k = n.k;
    nt.v = n.v;
    return rn;
  }
}

exports.copy = copy;
exports.create = create;
exports.bal = bal;
exports.singleton = singleton;
exports.updateValue = updateValue;
exports.minKey = minKey;
exports.minKeyUndefined = minKeyUndefined;
exports.maxKey = maxKey;
exports.maxKeyUndefined = maxKeyUndefined;
exports.minimum = minimum;
exports.minUndefined = minUndefined;
exports.maximum = maximum;
exports.maxUndefined = maxUndefined;
exports.removeMinAuxWithRef = removeMinAuxWithRef;
exports.isEmpty = isEmpty;
exports.stackAllLeft = stackAllLeft;
exports.findFirstByU = findFirstByU;
exports.findFirstBy = findFirstBy;
exports.forEachU = forEachU;
exports.forEach = forEach;
exports.mapU = mapU;
exports.map = map;
exports.mapWithKeyU = mapWithKeyU;
exports.mapWithKey = mapWithKey;
exports.reduceU = reduceU;
exports.reduce = reduce;
exports.everyU = everyU;
exports.every = every;
exports.someU = someU;
exports.some = some;
exports.join = join;
exports.concat = concat;
exports.concatOrJoin = concatOrJoin;
exports.keepSharedU = keepSharedU;
exports.keepShared = keepShared;
exports.keepMapU = keepMapU;
exports.keepMap = keepMap;
exports.partitionSharedU = partitionSharedU;
exports.partitionShared = partitionShared;
exports.lengthNode = lengthNode;
exports.size = size;
exports.toList = toList;
exports.checkInvariantInternal = checkInvariantInternal;
exports.fillArray = fillArray;
exports.toArray = toArray;
exports.keysToArray = keysToArray;
exports.valuesToArray = valuesToArray;
exports.fromSortedArrayAux = fromSortedArrayAux;
exports.fromSortedArrayRevAux = fromSortedArrayRevAux;
exports.fromSortedArrayUnsafe = fromSortedArrayUnsafe;
exports.cmpU = cmpU;
exports.cmp = cmp;
exports.eqU = eqU;
exports.eq = eq;
exports.get = get;
exports.getUndefined = getUndefined;
exports.getWithDefault = getWithDefault;
exports.getExn = getExn;
exports.has = has;
exports.fromArray = fromArray;
exports.updateMutate = updateMutate;
exports.balMutate = balMutate;
exports.removeMinAuxWithRootMutate = removeMinAuxWithRootMutate;
/* No side effect */


/***/ }),

/***/ 62459:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var Caml = __webpack_require__(16253);
var Curry = __webpack_require__(41386);
var Caml_option = __webpack_require__(57175);
var Belt_SortArray = __webpack_require__(62531);
var Belt_internalAVLtree = __webpack_require__(46144);

function add(t, x, data) {
  if (t === undefined) {
    return Belt_internalAVLtree.singleton(x, data);
  }
  var k = t.k;
  if (x === k) {
    return Belt_internalAVLtree.updateValue(t, data);
  }
  var v = t.v;
  if (x < k) {
    return Belt_internalAVLtree.bal(add(t.l, x, data), k, v, t.r);
  } else {
    return Belt_internalAVLtree.bal(t.l, k, v, add(t.r, x, data));
  }
}

function get(_n, x) {
  while(true) {
    var n = _n;
    if (n === undefined) {
      return ;
    }
    var v = n.k;
    if (x === v) {
      return Caml_option.some(n.v);
    }
    _n = x < v ? n.l : n.r;
    continue ;
  };
}

function getUndefined(_n, x) {
  while(true) {
    var n = _n;
    if (n === undefined) {
      return ;
    }
    var v = n.k;
    if (x === v) {
      return n.v;
    }
    _n = x < v ? n.l : n.r;
    continue ;
  };
}

function getExn(_n, x) {
  while(true) {
    var n = _n;
    if (n !== undefined) {
      var v = n.k;
      if (x === v) {
        return n.v;
      }
      _n = x < v ? n.l : n.r;
      continue ;
    }
    throw {
          RE_EXN_ID: "Not_found",
          Error: new Error()
        };
  };
}

function getWithDefault(_n, x, def) {
  while(true) {
    var n = _n;
    if (n === undefined) {
      return def;
    }
    var v = n.k;
    if (x === v) {
      return n.v;
    }
    _n = x < v ? n.l : n.r;
    continue ;
  };
}

function has(_n, x) {
  while(true) {
    var n = _n;
    if (n === undefined) {
      return false;
    }
    var v = n.k;
    if (x === v) {
      return true;
    }
    _n = x < v ? n.l : n.r;
    continue ;
  };
}

function remove(n, x) {
  if (n === undefined) {
    return n;
  }
  var v = n.k;
  var l = n.l;
  var r = n.r;
  if (x !== v) {
    if (x < v) {
      return Belt_internalAVLtree.bal(remove(l, x), v, n.v, r);
    } else {
      return Belt_internalAVLtree.bal(l, v, n.v, remove(r, x));
    }
  }
  if (l === undefined) {
    return r;
  }
  if (r === undefined) {
    return l;
  }
  var kr = {
    contents: r.k
  };
  var vr = {
    contents: r.v
  };
  var r$1 = Belt_internalAVLtree.removeMinAuxWithRef(r, kr, vr);
  return Belt_internalAVLtree.bal(l, kr.contents, vr.contents, r$1);
}

function splitAux(x, n) {
  var v = n.k;
  var d = n.v;
  var l = n.l;
  var r = n.r;
  if (x === v) {
    return [
            l,
            Caml_option.some(d),
            r
          ];
  }
  if (x < v) {
    if (l === undefined) {
      return [
              undefined,
              undefined,
              n
            ];
    }
    var match = splitAux(x, l);
    return [
            match[0],
            match[1],
            Belt_internalAVLtree.join(match[2], v, d, r)
          ];
  }
  if (r === undefined) {
    return [
            n,
            undefined,
            undefined
          ];
  }
  var match$1 = splitAux(x, r);
  return [
          Belt_internalAVLtree.join(l, v, d, match$1[0]),
          match$1[1],
          match$1[2]
        ];
}

function split(x, n) {
  if (n !== undefined) {
    return splitAux(x, n);
  } else {
    return [
            undefined,
            undefined,
            undefined
          ];
  }
}

function mergeU(s1, s2, f) {
  if (s1 !== undefined) {
    if (s1.h >= (
        s2 !== undefined ? s2.h : 0
      )) {
      var v1 = s1.k;
      var d1 = s1.v;
      var l1 = s1.l;
      var r1 = s1.r;
      var match = split(v1, s2);
      return Belt_internalAVLtree.concatOrJoin(mergeU(l1, match[0], f), v1, f(v1, Caml_option.some(d1), match[1]), mergeU(r1, match[2], f));
    }
    
  } else if (s2 === undefined) {
    return ;
  }
  var v2 = s2.k;
  var d2 = s2.v;
  var l2 = s2.l;
  var r2 = s2.r;
  var match$1 = split(v2, s1);
  return Belt_internalAVLtree.concatOrJoin(mergeU(match$1[0], l2, f), v2, f(v2, match$1[1], Caml_option.some(d2)), mergeU(match$1[2], r2, f));
}

function merge(s1, s2, f) {
  return mergeU(s1, s2, Curry.__3(f));
}

function compareAux(_e1, _e2, vcmp) {
  while(true) {
    var e2 = _e2;
    var e1 = _e1;
    if (!e1) {
      return 0;
    }
    if (!e2) {
      return 0;
    }
    var h2 = e2.hd;
    var h1 = e1.hd;
    var c = Caml.caml_string_compare(h1.k, h2.k);
    if (c !== 0) {
      return c;
    }
    var cx = vcmp(h1.v, h2.v);
    if (cx !== 0) {
      return cx;
    }
    _e2 = Belt_internalAVLtree.stackAllLeft(h2.r, e2.tl);
    _e1 = Belt_internalAVLtree.stackAllLeft(h1.r, e1.tl);
    continue ;
  };
}

function cmpU(s1, s2, cmp) {
  var len1 = Belt_internalAVLtree.size(s1);
  var len2 = Belt_internalAVLtree.size(s2);
  if (len1 === len2) {
    return compareAux(Belt_internalAVLtree.stackAllLeft(s1, /* [] */0), Belt_internalAVLtree.stackAllLeft(s2, /* [] */0), cmp);
  } else if (len1 < len2) {
    return -1;
  } else {
    return 1;
  }
}

function cmp(s1, s2, f) {
  return cmpU(s1, s2, Curry.__2(f));
}

function eqAux(_e1, _e2, eq) {
  while(true) {
    var e2 = _e2;
    var e1 = _e1;
    if (!e1) {
      return true;
    }
    if (!e2) {
      return true;
    }
    var h2 = e2.hd;
    var h1 = e1.hd;
    if (!(h1.k === h2.k && eq(h1.v, h2.v))) {
      return false;
    }
    _e2 = Belt_internalAVLtree.stackAllLeft(h2.r, e2.tl);
    _e1 = Belt_internalAVLtree.stackAllLeft(h1.r, e1.tl);
    continue ;
  };
}

function eqU(s1, s2, eq) {
  var len1 = Belt_internalAVLtree.size(s1);
  var len2 = Belt_internalAVLtree.size(s2);
  if (len1 === len2) {
    return eqAux(Belt_internalAVLtree.stackAllLeft(s1, /* [] */0), Belt_internalAVLtree.stackAllLeft(s2, /* [] */0), eq);
  } else {
    return false;
  }
}

function eq(s1, s2, f) {
  return eqU(s1, s2, Curry.__2(f));
}

function addMutate(t, x, data) {
  if (t === undefined) {
    return Belt_internalAVLtree.singleton(x, data);
  }
  var k = t.k;
  if (x === k) {
    t.k = x;
    t.v = data;
    return t;
  }
  var l = t.l;
  var r = t.r;
  if (x < k) {
    var ll = addMutate(l, x, data);
    t.l = ll;
  } else {
    t.r = addMutate(r, x, data);
  }
  return Belt_internalAVLtree.balMutate(t);
}

function fromArray(xs) {
  var len = xs.length;
  if (len === 0) {
    return ;
  }
  var next = Belt_SortArray.strictlySortedLengthU(xs, (function (param, param$1) {
          return param[0] < param$1[0];
        }));
  var result;
  if (next >= 0) {
    result = Belt_internalAVLtree.fromSortedArrayAux(xs, 0, next);
  } else {
    next = -next | 0;
    result = Belt_internalAVLtree.fromSortedArrayRevAux(xs, next - 1 | 0, next);
  }
  for(var i = next; i < len; ++i){
    var match = xs[i];
    result = addMutate(result, match[0], match[1]);
  }
  return result;
}

var N;

var A;

var S;

exports.N = N;
exports.A = A;
exports.S = S;
exports.add = add;
exports.get = get;
exports.getUndefined = getUndefined;
exports.getExn = getExn;
exports.getWithDefault = getWithDefault;
exports.has = has;
exports.remove = remove;
exports.splitAux = splitAux;
exports.split = split;
exports.mergeU = mergeU;
exports.merge = merge;
exports.compareAux = compareAux;
exports.cmpU = cmpU;
exports.cmp = cmp;
exports.eqAux = eqAux;
exports.eqU = eqU;
exports.eq = eq;
exports.addMutate = addMutate;
exports.fromArray = fromArray;
/* No side effect */


/***/ }),

/***/ 48723:
/***/ (function(__unused_webpack_module, exports) {




function div(x, y) {
  if (y === 0) {
    throw {
          RE_EXN_ID: "Division_by_zero",
          Error: new Error()
        };
  }
  return x / y | 0;
}

function mod_(x, y) {
  if (y === 0) {
    throw {
          RE_EXN_ID: "Division_by_zero",
          Error: new Error()
        };
  }
  return x % y;
}

exports.div = div;
exports.mod_ = mod_;
/* No side effect */


/***/ }),

/***/ 82900:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var Caml_js_exceptions = __webpack_require__(74518);

var anyToExnInternal = Caml_js_exceptions.internalToOCamlException;

function raiseError(str) {
  throw new Error(str);
}

function raiseEvalError(str) {
  throw new EvalError(str);
}

function raiseRangeError(str) {
  throw new RangeError(str);
}

function raiseReferenceError(str) {
  throw new ReferenceError(str);
}

function raiseSyntaxError(str) {
  throw new SyntaxError(str);
}

function raiseTypeError(str) {
  throw new TypeError(str);
}

function raiseUriError(str) {
  throw new URIError(str);
}

var $$Error$1 = Caml_js_exceptions.$$Error;

exports.$$Error = $$Error$1;
exports.anyToExnInternal = anyToExnInternal;
exports.raiseError = raiseError;
exports.raiseEvalError = raiseEvalError;
exports.raiseRangeError = raiseRangeError;
exports.raiseReferenceError = raiseReferenceError;
exports.raiseSyntaxError = raiseSyntaxError;
exports.raiseTypeError = raiseTypeError;
exports.raiseUriError = raiseUriError;
/* No side effect */


/***/ }),

/***/ 11589:
/***/ (function(__unused_webpack_module, exports) {




function equal(x, y) {
  return x === y;
}

var max = 2147483647;

var min = -2147483648;

exports.equal = equal;
exports.max = max;
exports.min = min;
/* No side effect */


/***/ }),

/***/ 85688:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var Caml_option = __webpack_require__(57175);

function classify(x) {
  var ty = typeof x;
  if (ty === "string") {
    return {
            TAG: /* JSONString */0,
            _0: x
          };
  } else if (ty === "number") {
    return {
            TAG: /* JSONNumber */1,
            _0: x
          };
  } else if (ty === "boolean") {
    if (x === true) {
      return /* JSONTrue */1;
    } else {
      return /* JSONFalse */0;
    }
  } else if (x === null) {
    return /* JSONNull */2;
  } else if (Array.isArray(x)) {
    return {
            TAG: /* JSONArray */3,
            _0: x
          };
  } else {
    return {
            TAG: /* JSONObject */2,
            _0: x
          };
  }
}

function test(x, v) {
  switch (v) {
    case /* String */0 :
        return typeof x === "string";
    case /* Number */1 :
        return typeof x === "number";
    case /* Object */2 :
        if (x !== null && typeof x === "object") {
          return !Array.isArray(x);
        } else {
          return false;
        }
    case /* Array */3 :
        return Array.isArray(x);
    case /* Boolean */4 :
        return typeof x === "boolean";
    case /* Null */5 :
        return x === null;
    
  }
}

function decodeString(json) {
  if (typeof json === "string") {
    return json;
  }
  
}

function decodeNumber(json) {
  if (typeof json === "number") {
    return json;
  }
  
}

function decodeObject(json) {
  if (typeof json === "object" && !Array.isArray(json) && json !== null) {
    return Caml_option.some(json);
  }
  
}

function decodeArray(json) {
  if (Array.isArray(json)) {
    return json;
  }
  
}

function decodeBoolean(json) {
  if (typeof json === "boolean") {
    return json;
  }
  
}

function decodeNull(json) {
  if (json === null) {
    return null;
  }
  
}

var patch = (function (json) {
  var x = [json];
  var q = [{ kind: 0, i: 0, parent: x }];
  while (q.length !== 0) {
    // begin pop the stack
    var cur = q[q.length - 1];
    if (cur.kind === 0) {
      cur.val = cur.parent[cur.i]; // patch the undefined value for array
      if (++cur.i === cur.parent.length) {
        q.pop();
      }
    } else {
      q.pop();
    }
    // finish
    var task = cur.val;
    if (typeof task === "object") {
      if (Array.isArray(task) && task.length !== 0) {
        q.push({ kind: 0, i: 0, parent: task, val: undefined });
      } else {
        for (var k in task) {
          if (k === "RE_PRIVATE_NONE") {
            if (cur.kind === 0) {
              cur.parent[cur.i - 1] = undefined;
            } else {
              cur.parent[cur.i] = undefined;
            }
            continue;
          }
          q.push({ kind: 1, i: k, parent: task, val: task[k] });
        }
      }
    }
  }
  return x[0];
});

function serializeExn(x) {
  return (function(obj){
  var output= JSON.stringify(obj,function(_,value){
      if(value===undefined){
          return {RE_PRIVATE_NONE : true}
      }
    return value
  });
  
 if(output === undefined){
   // JSON.stringify will raise TypeError when it detects cylic objects
   throw new TypeError("output is undefined")
 }
 return output 
 })(x);
}

function deserializeUnsafe(s) {
  return patch(JSON.parse(s));
}

exports.classify = classify;
exports.test = test;
exports.decodeString = decodeString;
exports.decodeNumber = decodeNumber;
exports.decodeObject = decodeObject;
exports.decodeArray = decodeArray;
exports.decodeBoolean = decodeBoolean;
exports.decodeNull = decodeNull;
exports.deserializeUnsafe = deserializeUnsafe;
exports.serializeExn = serializeExn;
/* No side effect */


/***/ }),

/***/ 84763:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var Js_int = __webpack_require__(11589);

function unsafe_ceil(prim) {
  return Math.ceil(prim);
}

function ceil_int(f) {
  if (f > Js_int.max) {
    return Js_int.max;
  } else if (f < Js_int.min) {
    return Js_int.min;
  } else {
    return Math.ceil(f);
  }
}

function unsafe_floor(prim) {
  return Math.floor(prim);
}

function floor_int(f) {
  if (f > Js_int.max) {
    return Js_int.max;
  } else if (f < Js_int.min) {
    return Js_int.min;
  } else {
    return Math.floor(f);
  }
}

function random_int(min, max) {
  return floor_int(Math.random() * (max - min | 0)) + min | 0;
}

var ceil = ceil_int;

var floor = floor_int;

exports.unsafe_ceil = unsafe_ceil;
exports.ceil_int = ceil_int;
exports.ceil = ceil;
exports.unsafe_floor = unsafe_floor;
exports.floor_int = floor_int;
exports.floor = floor;
exports.random_int = random_int;
/* No side effect */


/***/ }),

/***/ 10354:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var Caml_option = __webpack_require__(57175);

function some(x) {
  return Caml_option.some(x);
}

function isSome(param) {
  return param !== undefined;
}

function isSomeValue(eq, v, x) {
  if (x !== undefined) {
    return eq(v, Caml_option.valFromOption(x));
  } else {
    return false;
  }
}

function isNone(param) {
  return param === undefined;
}

function getExn(x) {
  if (x !== undefined) {
    return Caml_option.valFromOption(x);
  }
  throw new Error("getExn");
}

function equal(eq, a, b) {
  if (a !== undefined) {
    if (b !== undefined) {
      return eq(Caml_option.valFromOption(a), Caml_option.valFromOption(b));
    } else {
      return false;
    }
  } else {
    return b === undefined;
  }
}

function andThen(f, x) {
  if (x !== undefined) {
    return f(Caml_option.valFromOption(x));
  }
  
}

function map(f, x) {
  if (x !== undefined) {
    return Caml_option.some(f(Caml_option.valFromOption(x)));
  }
  
}

function getWithDefault(a, x) {
  if (x !== undefined) {
    return Caml_option.valFromOption(x);
  } else {
    return a;
  }
}

function filter(f, x) {
  if (x === undefined) {
    return ;
  }
  var x$1 = Caml_option.valFromOption(x);
  if (f(x$1)) {
    return Caml_option.some(x$1);
  }
  
}

function firstSome(a, b) {
  if (a !== undefined) {
    return a;
  } else if (b !== undefined) {
    return b;
  } else {
    return ;
  }
}

var $$default = getWithDefault;

exports.some = some;
exports.isSome = isSome;
exports.isSomeValue = isSomeValue;
exports.isNone = isNone;
exports.getExn = getExn;
exports.equal = equal;
exports.andThen = andThen;
exports.map = map;
exports.getWithDefault = getWithDefault;
exports.$$default = $$default;
exports["default"] = $$default;
exports.__esModule = true;
exports.filter = filter;
exports.firstSome = firstSome;
/* No side effect */


/***/ })

}]);